<template>
  <div style="overflow-x: hidden;height: 100%;overflow-y: auto !important;display: ">
    <div id='PRODUCT'>
      <br>
      <diV id='MAIN' style="margin-top: -60px;display: ">
        <v-container>
          <v-row align="center" justify="center" class="my-2">
          <v-col cols="auto">
            <v-tabs v-model="addtab" color="#1976d2" bg-color="white" align-tabs="center">
              <v-tab value="1">窓商品</v-tab>
              <v-tab value="2">ドア商品</v-tab>
            </v-tabs>
            </v-col>
            <v-col cols="auto">
              <v-icon
                class="clickable"
                @click="onKaikoubuHelp"
                color="blue"
                size="24"
              >
                mdi-help-circle-outline
              </v-icon>
            </v-col>
          </v-row>
          <v-window v-model="addtab" style="margin-top: 0px;">
            <v-window-item value="1">
              <div id="WINDOWSTART" style="display:">
                <div style="display: flex; justify-content: left;width: 1168px; height: 30px;background-color: #eaeaea;">
                  <div style="padding-left: 10px;">建具の仕様の選択</div>
                </div>
                <div class="select-wrapper">
                  <!-- グレー帯 -->
                  <div class="select-bg"></div>
                  <!-- セレクト -->
                  <div class="select-foreground">
                    <v-select variant="outlined" density="compact" width="450px" bg-color="white" color="#1976d2"
                        :items="windowSpecSelectList"
                        v-model="windowSpecSelectListId"
                        @update:modelValue="windowSpecChange()"
                        required>
                    </v-select>
                  </div>
                </div>
                <div style="margin-top: 15px;">
                  <v-row justify="center">
                    <v-col>
                      <v-btn v-if="selectFlg != false" @click="next" color="#1976d2">
                        結 果 の 表 示
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
                <div v-if="windowkensu === 0" style="display:flex; align-items:center; width:100%;">
                  <div style="flex:1; display:flex; justify-content:center;">
                    <v-btn color="blue" variant="text" @click="backFnc" style="margin-left: 0px; background-color: white;">
                    －&nbsp;&nbsp;地域区分の選択へ戻る&nbsp;&nbsp;－
                  </v-btn>
                  </div>
                </div>
              </div>
              <v-card  v-if="windowkensu != 0"
                height="78px"
                color="#e3f5ff"
                min-width="800px"
                >
                <div style="position: absolute;font-size: 16px;font-weight: bold;top: 25px;left: 50px;">
                窓 {{ windowkensu }}件 選択
                </div>
                <div style="position: absolute;font-size: 16px;font-weight: bold;top: 17px;left: 250px;">
                地域区分 <span style="font-size: 24px;font-weight: bold;">{{ rigionClass }}</span>&nbsp;地域
                </div>
                <div style="top: 34px;left: 635px;width: 210px;font-size: smaller;position: absolute;text-align: center;height: 20px;background-color: #ffeb5a;
                  border-top: 1px solid black;padding-top: 1px;">
                  省エネ基準(断熱等級４)
                </div>
                <div style="top: 54px;left: 635px;position: absolute;font-size: smaller;width: 210px;text-align: center;height: 20px;background-color: #cdf5ad;
                  border-top: 1px solid black;padding-top: 1px;">
                  &emsp;誘導基準(断熱等級５)
                </div>
                <div style="top: 3px;left: 855px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                  熱貫流率
                </div>
                <div style="top: 17px;left: 855px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                  [W/(㎡・K)]
                </div>
                <div  style="top: 34px;left: 855px;position: absolute;width: 100px;height: 20px;background-color: #ffeb5a;
                  font-size: smaller;font-weight: bold;width: 100px;text-align: center;border-top: 1px solid black;padding-top: 1px;">
                  {{ WINDOW_STANDARD4_THERMAL_TRANS_DIS_KIJUNN }}
                </div>
                <div  style="top: 54px;left: 855px;position: absolute;width: 100px;height: 20px;background-color: #cdf5ad;
                  font-size: smaller;font-weight: bold;width: 100px;text-align: center;border-top: 1px solid black;padding-top: 1px;">
                  {{ WINDOW_STANDARD5_THERMAL_TRANS_DIS_KIJUNN }}
                </div>
                <div style="top: 3px;left: 965px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                  日射熱取得率
                </div>
                <div style="top: 17px;left: 965px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                  [―]
                </div>
                <div  style="top: 34px;left: 965px;position: absolute;width: 100px;height: 20px;background-color: #ffeb5a;
                  font-size: smaller;font-weight: bold;width: 100px;text-align: center;border-top: 1px solid black;padding-top: 1px;">
                  {{ WINDOW_STANDARD4_SOLARHEAT_DIS_KIJUNN }}
                </div>
                <div  style="top: 54px;left: 965px;position: absolute;width: 100px;height: 20px;background-color: #cdf5ad;
                  font-size: smaller;font-weight: bold;width: 100px;text-align: center;border-top: 1px solid black;padding-top: 1px;">
                  {{ WINDOW_STANDARD5_SOLARHEAT_DIS_KIJUNN }}
                </div>
              </v-card>
              <v-slide-y-transition>
                <div v-if="showWindowCards" class="card-container-w-pro">
                  <v-card
                    v-for="(item, index) in windowResultList"
                    :key="index"
                    class="mb-1 position-relative"
                    height="108px"
                    min-width="800px"
                  >
                  <div style="position: absolute;top: 6px;left: 1px;">
                      <div style="display: flex;align-items: center;gap: 8px;">
                        <div style="border: 1px solid #1976d2;border-radius: 5px;padding: 2px 6px;font-size: smaller;">
                          {{ item.SPEC }}
                        </div>
                        <div style="font-size: 16px;font-weight: bold;">
                          {{ item.SERIES }}
                        </div>
                      </div>
                    </div>
                    <div style="top: 33px;left: 1px;position: absolute;font-size: smaller ;">
                      {{ item.GLASS_TYPE }}
                    </div>
                    <div style="display: flex;align-items: center;position: absolute;top: 56px;left: 1px;font-size: smaller;">
                      {{ item.WINDOW_TYPE }}
                    </div>
                    <div style="top: 83px;left: 1px;position: absolute;font-size: smaller;">
                      開口部区分：{{ item.OPNING }}
                    </div>
                    <!-- 開口部が窓のみ表示させる20260126 -->
                    <div v-if="item.OPNING === '窓'">
                      <div v-if="rigionPattern !== '1'">
                        <div style="top: 83px;left: 120px;position: absolute;font-size: smaller ;">
                          {{ item.BUZAI_NM }}
                        </div>
                        <div style="top: 83px;left: 280px;position: absolute;font-size: smaller ;">
                          {{ item.HISASHI_NM }}
                        </div>
                      </div>
                    </div>
                    <div style="border-bottom: 1px solid black;padding: 1px;top: -1px;left: 635px;position: absolute;font-size: smaller;
                      width: 210px;height: 20px; text-align: center;">
                      建具とガラスの組み合わせ
                    </div>
                    <div style="top: 20px;left: 635px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                      熱貫流率
                    </div>
                    <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 635px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                      [W/(㎡・K)]
                    </div>
                    <div style="top: 49px;left: 635px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                      {{ item.TYPE_THERMAL_TRANS }}
                    </div>
                    <div style="top: 20px;left: 745px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                      日射熱取得率
                    </div>
                    <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 745px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                      [―]
                    </div>
                    <div style="top: 49px;left: 745px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                      {{ item.TYPE_SOLARHEAT }}
                    </div>
                    <div class="capsule-4" style="top: 68px;left: 635px;">
                    <span>省エネ基準：</span>
                    <span :class="item.TYPE_HANTEI_4 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                      {{ item.TYPE_HANTEI_4 }}</span>
                    </div>
                    <div class="capsule-5" style="top: 87px;left: 635px;">
                    <span>&emsp;誘導基準：</span>
                    <span :class="item.TYPE_HANTEI_5 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                      {{ item.TYPE_HANTEI_5 }}</span>
                    </div>
                    <div style="border-bottom: 1px solid black;padding: 0px;top: -1px;left: 855px;position: absolute;font-size: smaller;width: 210px;text-align: center;">
                      自己適合宣言書・附属書
                    </div>
                    <div style="top: 20px;left: 855px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                      熱貫流率
                    </div>
                    <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 855px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                      [W/(㎡・K)]
                    </div>
                    <div style="top: 49px;left: 855px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                      {{ item.EXAM_THERMAL_TRANS }}
                    </div>
                    <div style="top: 20px;left: 965px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                      日射熱取得率
                    </div>
                    <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 965px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                      [―]
                    </div>
                    <div style="top: 49px;left: 965px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                      {{ item.EXAM_SOLARHEAT }}
                    </div>
                    <div class="capsule-4" style="top: 68px;left: 855px;">
                    <span>省エネ基準：</span>
                    <span :class="item.EXAM_HANTEI_4 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                      {{ item.EXAM_HANTEI_4 }}</span>
                    </div>
                    <div class="capsule-5" style="top: 87px;left: 855px;">
                    <span>&emsp;誘導基準：</span>
                    <span :class="item.EXAM_HANTEI_5 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                      {{ item.EXAM_HANTEI_5 }}</span>
                    </div>
                    <div style="top: 10px;right: 6px;position: absolute;font-size: smaller ;">
                      <v-btn v-if="windowkensu < 100" size="small" @click="henkouWindowDis(index)" color="#1976d2" width="70px">
                        編集&nbsp;&nbsp;<v-icon style="color: white;" size="22">mdi-file-document-edit-outline</v-icon>
                      </v-btn>
                    </div>
                    <div style="top: 40px;right: 6px;position: absolute;font-size: smaller ;">
                      <v-btn v-if="windowkensu < 100" size="small" @click="copyWindow(index)" color="#1976d2" width="70px">
                        コピー<v-icon style="color: white;" size="22">mdi-content-copy</v-icon>
                      </v-btn>
                    </div>
                    <div style="top: 70px;right: 6px;position: absolute;font-size: smaller ;">
                      <v-btn size="small" @click="deleteWindow(index)" color="white" width="70px">
                        削除&nbsp;&nbsp;<v-icon style="color: gray;" size="22">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-card>
                </div>
              </v-slide-y-transition>
              <v-container style="margin-top: -5px;">
                <v-row justify="center">
                  <v-col>
                    <v-btn v-if="windowkensu != 0 && windowkensu < 100" class="text-none" v-on:click="addWindowDis()" color="#1976d2" variant="outlined">
                      窓 の 追 加
                    </v-btn>
                    <v-btn v-if="windowkensu >= 100" disabled class="text-none" v-on:click="addWindowDis()" color="#1976d2" variant="outlined">
                      窓 の 追 加
                    </v-btn>
                    &ensp;&ensp;
                    <v-btn v-if="windowkensu > 0 && selectFlg === true" @click="next" color="#1976d2">
                      結 果 の 表 示
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <div v-if="windowkensu != 0" style="display:flex; align-items:center; width:100%;">
                    <div style="flex:1; display:flex; justify-content:center;">
                      <v-btn color="blue" variant="text" @click="backFnc" style="margin-left: 0px; background-color: white;">
                      －&nbsp;&nbsp;地域区分の選択へ戻る&nbsp;&nbsp;－
                    </v-btn>
                    </div>
                  </div>
                </v-row>
              </v-container>
            </v-window-item>
            <v-window-item value="2">
              <div id="DOORSTART" style="display:">
                <div style="display: flex; justify-content: left;width: 1168px; height: 30px;background-color: #eaeaea;">
                  <div style="padding-left: 10px;">ドア シリーズの選択</div>
                </div>
                <div class="select-wrapper">
                  <!-- グレー帯 -->
                  <div class="select-bg"></div>
                  <!-- セレクト -->
                  <div class="select-foreground" style="width:915px;">
                    <v-select variant="outlined" density="compact" width="450px" bg-color="white" color="#1976d2"
                        :items="doorSeriesSelectList"
                        v-model="doorSeriesSelectListId"
                        @update:modelValue="doorSeriesChange()"
                        required>
                    </v-select>
                  </div>
                </div>
                <div style="margin-top: 15px;">
                  <v-row justify="center">
                    <v-col>
                      <v-btn v-if="selectFlg != false" @click="next" color="#1976d2">
                        結 果 の 表 示
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
                <div v-if="doorkensu === 0" style="display:flex; align-items:center; width:100%;">
                  <div style="flex:1; display:flex; justify-content:center;">
                    <v-btn color="blue" variant="text" @click="backFnc" style="margin-left: 0px; background-color: white;">
                    －&nbsp;&nbsp;地域区分の選択へ戻る&nbsp;&nbsp;－
                  </v-btn>
                  </div>
                </div>
              </div>
              <v-card  v-if="doorkensu != 0"
                height="78px"
                color="#e3f5ff"
                min-width="800px"
                >
                <div style="position: absolute;font-size: 16px;font-weight: bold;top: 25px;left: 50px;">
                ドア {{ doorkensu }}件 選択
                </div>
                <div style="position: absolute;font-size: 16px;font-weight: bold;top: 17px;left: 250px;">
                地域区分 <span style="font-size: 24px;font-weight: bold;">{{ rigionClass }}</span>&nbsp;地域
                </div>
                <div style="top: 34px;left: 635px;width: 210px;font-size: smaller;position: absolute;text-align: center;height: 20px;background-color: #ffeb5a;
                  border-top: 1px solid black;padding-top: 1px;">
                  省エネ基準(断熱等級４)
                </div>
                <div style="top: 54px;left: 635px;position: absolute;font-size: smaller;width: 210px;text-align: center;height: 20px;background-color: #cdf5ad;
                  border-top: 1px solid black;padding-top: 1px;">
                  &emsp;誘導基準(断熱等級５)
                </div>
                <div style="top: 3px;left: 855px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                  熱貫流率
                </div>
                <div style="top: 17px;left: 855px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                  [W/(㎡・K)]
                </div>
                <div  style="top: 34px;left: 855px;position: absolute;width: 100px;height: 20px;background-color: #ffeb5a;
                  font-size: smaller;font-weight: bold;width: 100px;text-align: center;border-top: 1px solid black;padding-top: 1px;">
                  {{ WINDOW_STANDARD4_THERMAL_TRANS_DIS_KIJUNN }}
                </div>
                <div  style="top: 54px;left: 855px;position: absolute;width: 100px;height: 20px;background-color: #cdf5ad;
                  font-size: smaller;font-weight: bold;width: 100px;text-align: center;border-top: 1px solid black;padding-top: 1px;">
                  {{ WINDOW_STANDARD5_THERMAL_TRANS_DIS_KIJUNN }}
                </div>
                <div style="top: 3px;left: 965px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                  日射熱取得率
                </div>
                <div style="top: 17px;left: 965px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                  [―]
                </div>
                <div  style="top: 34px;left: 965px;position: absolute;width: 100px;height: 20px;background-color: #ffeb5a;
                  font-size: smaller;font-weight: bold;width: 100px;text-align: center;border-top: 1px solid black;padding-top: 1px;">
                  {{ WINDOW_STANDARD4_SOLARHEAT_DIS_KIJUNN }}
                </div>
                <div  style="top: 54px;left: 965px;position: absolute;width: 100px;height: 20px;background-color: #cdf5ad;
                  font-size: smaller;font-weight: bold;width: 100px;text-align: center;border-top: 1px solid black;padding-top: 1px;">
                  {{ WINDOW_STANDARD5_SOLARHEAT_DIS_KIJUNN }}
                </div>
              </v-card>
              <v-slide-y-transition>
                <div v-if="showDoorCards" class="card-container-d-pro">
                  <v-card
                    v-for="(item, index) in doorResultList"
                    :key="index"
                    class="mb-1 position-relative"
                    height="108px"
                    min-width="800px"
                  >
                    <div style="top: 6px;left: 1px;position: absolute;font-size: 16px ;font-weight: bold;">
                      {{ item.SERIES }}
                    </div>
                    <div style="top: 33px;left: 1px;position: absolute;font-size: smaller ;">
                      {{ item.GLASS_TYPE }}
                    </div>
                    <div style="display: flex;align-items: center;position: absolute;top: 56px;left: 1px;font-size: smaller;">
                      <div>
                        {{ item.DESIGN }}
                      </div>
                      <div style="margin-left: 8px;">
                        {{ item.FRAME }}
                      </div>
                    </div>
                    <div style="top: 83px;left: 1px;position: absolute;font-size: smaller;">
                      開口部区分：{{ item.OPNING }}
                    </div>
                    <div v-if="item.OPNING === '窓'">
                      <div v-if="rigionPattern !== '1'">
                        <div style="top: 83px;left: 140px;position: absolute;font-size: smaller ;">
                          {{ item.HISASHI_NM }}
                        </div>
                      </div>
                    </div>
                    <div style="border-bottom: 1px solid black;padding: 0px;top: -1px;left: 635px;position: absolute;font-size: smaller;width: 210px;text-align: center;">
                      建具とガラスの組み合わせ
                    </div>
                    <div style="top: 20px;left: 635px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                      熱貫流率
                    </div>
                    <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 635px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                      [W/(㎡・K)]
                    </div>
                    <div style="top: 49px;left: 635px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                      {{ item.TYPE_THERMAL_TRANS }}
                    </div>
                    <div style="top: 20px;left: 745px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                      日射熱取得率
                    </div>
                    <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 745px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                      [―]
                    </div>
                    <div style="top: 49px;left: 745px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                      {{ item.TYPE_SOLARHEAT }}
                    </div>
                    <div class="capsule-4" style="top: 68px;left: 635px;">
                    <span>省エネ基準：</span>
                    <span :class="item.TYPE_HANTEI_4 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                      {{ item.TYPE_HANTEI_4 }}</span>
                    </div>
                    <div class="capsule-5" style="top: 87px;left: 635px;">
                    <span>&emsp;誘導基準：</span>
                    <span :class="item.TYPE_HANTEI_5 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                      {{ item.TYPE_HANTEI_5 }}</span>
                    </div>
                    <div style="border-bottom: 1px solid black;padding: 0px;top: -1px;left: 855px;position: absolute;font-size: smaller;width: 210px;text-align: center;">
                      自己適合宣言書・附属書
                    </div>
                    <div style="top: 20px;left: 855px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                      熱貫流率
                    </div>
                    <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 855px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                      [W/(㎡・K)]
                    </div>
                    <div style="top: 49px;left: 855px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                      {{ item.EXAM_THERMAL_TRANS }}
                    </div>
                    <div style="top: 20px;left: 965px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                      日射熱取得率
                    </div>
                    <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 965px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                      [―]
                    </div>
                    <div style="top: 49px;left: 965px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                      {{ item.EXAM_SOLARHEAT }}
                    </div>
                    <div class="capsule-4" style="top: 68px;left: 855px;">
                    <span>省エネ基準：</span>
                    <span :class="item.EXAM_HANTEI_4 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                      {{ item.EXAM_HANTEI_4 }}</span>
                    </div>
                    <div class="capsule-5" style="top: 87px;left: 855px;">
                    <span>&emsp;誘導基準：</span>
                    <span :class="item.EXAM_HANTEI_5 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                      {{ item.EXAM_HANTEI_5 }}</span>
                    </div>
                    <div style="top: 10px;right: 6px;position: absolute;font-size: smaller ;">
                      <v-btn v-if="doorkensu < 100" size="small" @click="henkouDoorDis(index)" color="#1976d2" width="70px">
                        編集&nbsp;&nbsp;<v-icon style="color: white;" size="22">mdi-file-document-edit-outline</v-icon>
                      </v-btn>
                    </div>
                    <div style="top: 40px;right: 6px;position: absolute;font-size: smaller ;">
                      <v-btn v-if="doorkensu < 100" size="small" @click="copyDoor(index)" color="#1976d2" width="70px">
                        コピー<v-icon style="color: white;" size="22">mdi-content-copy</v-icon>
                      </v-btn>
                    </div>
                    <div style="top: 70px;right: 6px;position: absolute;font-size: smaller ;">
                      <v-btn size="small" @click="deleteDoor(index)" color="white" width="70px">
                        削除&nbsp;&nbsp;<v-icon style="color: gray;" size="22">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-card>
                </div>
              </v-slide-y-transition>
              <v-container style="margin-top: -5px;">
                <v-row justify="center">
                  <v-col>
                    <v-btn v-if="doorkensu != 0 && doorkensu < 100" class="text-none" v-on:click="addDoorDis()" color="#1976d2" variant="outlined">
                      ドア の 追 加
                    </v-btn>
                    <v-btn v-if="doorkensu >= 100" disabled class="text-none" v-on:click="addDoorDis()" color="#1976d2" variant="outlined">
                      ドア の 追 加
                    </v-btn>
                    &ensp;&ensp;
                    <v-btn v-if="doorkensu > 0 && selectFlg === true" @click="next" color="#1976d2">
                      結 果 の 表 示
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <div v-if="doorkensu != 0" style="display:flex; align-items:center; width:100%;">
                    <div style="flex:1; display:flex; justify-content:center;">
                      <v-btn color="blue" variant="text" @click="backFnc" style="margin-left: 0px; background-color: white;">
                      －&nbsp;&nbsp;地域区分の選択へ戻る&nbsp;&nbsp;－
                    </v-btn>
                    </div>
                  </div>
                </v-row>
              </v-container>
            </v-window-item>
          </v-window>
        </v-container>
      </diV>
      <div id="WINDOW" style="display:none">
        <div style="display: flex; justify-content: left;width: 1168px; height: 30px;background-color: #eaeaea;">
          <div style="padding-left: 10px;">建具の仕様の選択</div>
        </div>
        <div class="select-wrapper">
          <!-- グレー帯 -->
          <div class="select-bg"></div>
          <!-- セレクト -->
          <div class="select-foreground">
            <v-select variant="outlined" density="compact" width="450px" bg-color="white" color="#1976d2"
                :items="windowSpecSelectList"
                v-model="windowSpecSelectListId"
                @update:modelValue="windowSpecChange()"
                required>
            </v-select>
          </div>
        </div>
        <div id="WINDOW0" style="display:none">
          <div style="display: flex; justify-content: left;width: 1168px; height: 30px;margin-top: 10px;background-color: #eaeaea;">
            <div style="padding-left: 10px;">窓 シリーズの選択</div>
          </div>
          <div class="select-wrapper">
            <!-- グレー帯 -->
            <div class="select-bg"></div>
            <!-- セレクト -->
            <div class="select-foreground">
              <v-select variant="outlined" density="compact" width="450px" bg-color="white" color="#1976d2"
                  :items="windowSeriesSelectList"
                  v-model="windowSeriesSelectListId"
                  @update:modelValue="windowSeriesChange()"
                  required>
              </v-select>
            </div>
          </div>
        </div>
        <div id="WINDOW1" style="display:none">
          <div style="display: flex; justify-content: left;width: 1168px; height: 20px;margin-top: 10px; background-color: #eaeaea;">
            <div style="padding-left: 10px;">窓種の選択</div>
          </div>
          <div style="display: flex; justify-content: left;">
            <div class="thumbnail-box">
              <div class="grid">
                <div
                  v-for="(item, index) in windowseriesimages"
                  :key="index"
                  class="thumb"
                  :class="{ 'selected-thumb': item.value === windowSyuSelectId }"
                  @click="WindowSeriseSelected(index)"
                >
                  <div class="thumb-content">
                    <img
                      v-if="!windowimageErrors[index]"
                      :src="item.item"
                      :alt="item.value"
                      @error="windowimageErrors[index] = true"
                    />
                    <div v-else class="fallback-text">{{ item.value }}</div>
                  </div>
                  <div class="caption">{{ item.value }}</div>
                  <!-- <img :src="item.item" alt={{ item.value }}/> -->
                  <div v-if="item.description !== ''" class="tooltip">{{ item.description }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>
        <div id="WINDOW2" style="display:none">
          <div style="display: flex; justify-content: left;width: 1168px; height: 60px;margin-top: -15px;background-color: #eaeaea;">
            <div>
              <v-btn size="large" style="width: 750px;margin-top: 10px;margin-left: 10px;" @click="glassSelectOpen()" color="#1976d2">ガ ラ ス 種 の 選 択</v-btn>
            </div>
            <div style="margin-top: 20px;margin-left: 12px;">
              <v-icon class="clickable" @click="onGlassHelp" color="blue" size="22">mdi-help-circle-outline</v-icon>
            </div>
          </div>
          <div class="select-wrapper">
            <!-- グレー帯 -->
            <div class="select-bg"></div>
            <!-- セレクト -->
            <div class="select-foregroundGlass">
              <v-select variant="outlined" density="compact" width="750px" bg-color="white" color="#1976d2"
                  :items="windowGlassSelectList"
                  v-model="windowGlassSelectId"
                  @update:modelValue="WindowEndDisplay()"
                  required>
              </v-select>
            </div>
          </div>
          <div v-show="windowOpeningFlg === 'window'">
            <div v-if="rigionPattern !== '1'">
              <div>
                <div style="display: flex; justify-content: left;padding-left: 10px;width: 1168px; height: 30px;margin-top: 10px;background-color: #eaeaea;">
                  有効な付属部材<span style="margin-top: 1px;">&nbsp;&nbsp;<v-icon class="clickable" @click="onBuzaiHelp" color="blue" size="22">mdi-help-circle-outline</v-icon></span>
                </div>
                <div style="display: flex; justify-content: left;padding-left: 10px;width: 1168px; height: 45px;background-color: #eaeaea;">
                  <v-btn-toggle
                    v-model="windowtoggle"
                    mandatory
                    class="toggle-box"
                  >
                    <v-btn
                      class="toggle-btn3"
                      :class="{'selected': windowtoggle === 0}"
                      value="0"
                    >なし</v-btn>
                    <v-btn :disabled="true"
                      class="toggle-btn3"
                      :class="{'selected': windowtoggle === 1}"
                      value="1"
                    >和障子</v-btn>
                    <v-btn :disabled="true"
                      class="toggle-btn3"
                      :class="{'selected': windowtoggle === 2}"
                      value="2"
                    >外付ブラインド</v-btn>
                  </v-btn-toggle>
                </diV>
              </div>
              <br>
              <div style="display: flex; justify-content: left;padding-left: 10px;width: 1168px; height: 30px;margin-top: -14px;background-color: #eaeaea;">
                有効なひさし、軒等<span style="margin-top: 1px;">&nbsp;&nbsp;<v-icon class="clickable" @click="onHisashiHelp" color="blue" size="22">mdi-help-circle-outline</v-icon></span>
              </div>
              <div style="display: flex; justify-content: left;padding-left: 10px;width: 1168px; height: 45px;background-color: #eaeaea;">
                <v-btn-toggle
                  v-model="windowHisashitoggle"
                  mandatory
                  class="toggle-box"
                >
                  <v-btn
                    class="toggle-btn"
                    :class="{'selected': windowHisashitoggle === 0}"
                    value="0"
                  >なし</v-btn>
                  <v-btn
                    class="toggle-btn"
                    :class="{'selected': windowHisashitoggle === 1}"
                    value="1"
                  >あり</v-btn>
                </v-btn-toggle>
              </diV>
            </div>
          </div>
        </div>
        <div id="WINDOWEND">
          <v-container style="margin-top: 8px;">
            <v-row justify="center">
              <v-col>
                <div style="display: flex; justify-content: center; gap: 16px;">
                  <div>
                    <v-btn @click="windowCancelMaindis" color="white">
                      キャンセル
                    </v-btn>
                  </div>
                  <div v-if="windowMode === 'insert'">
                    <v-btn :disabled="!windowGlassSelectId" @click="addWindow" color="#1976d2">
                      確定
                    </v-btn>
                  </div>
                  <div v-if="windowMode === 'update'">
                    <v-btn :disabled="!windowGlassSelectId" @click="henkouWindow" color="#1976d2">
                      確定
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <div style="display:flex; align-items:center; width:100%;">
            <div style="flex:1; display:flex; justify-content:center;">
              <v-btn color="blue" variant="text" @click="backFnc" style="margin-left: 0px; background-color: white;">
              －&nbsp;&nbsp;地域区分の選択へ戻る&nbsp;&nbsp;－
            </v-btn>
            </div>
          </div>
        </div>
      </diV>
      <div id="DOOR" style="display:none">
        <div style="display: flex; justify-content: left;width: 1168px; height: 30px;background-color: #eaeaea;">
          <div style="padding-left: 10px;">ドア シリーズの選択</div>
        </div>
        <div class="select-wrapper">
          <!-- グレー帯 -->
          <div class="select-bg"></div>
          <!-- セレクト -->
          <div class="select-foreground" style="width:915px;">
            <v-select variant="outlined" density="compact" width="960px" bg-color="white" color="#1976d2"
                :items="doorSeriesSelectList"
                v-model="doorSeriesSelectListId"
                @update:modelValue="doorSeriesChange()"
                required>
            </v-select>
          </div>
        </div>
        <div id="DOOR1" style="display:none">
          <div style="display: flex; justify-content: left;width: 1168px; height: 30px;margin-top: 10px;background-color: #eaeaea;">
            <div style="padding-left: 10px;">断熱の仕様の選択</div>
          </div>
          <div class="select-wrapper">
            <!-- グレー帯 -->
            <div class="select-bg"></div>
            <!-- セレクト -->
            <div class="select-foreground" style="width:915px;">
              <v-select variant="outlined" density="compact" width="960px" bg-color="white" color="#1976d2"
                  :items="doorThermalSelectList"
                  v-model="doorThermalSelectId"
                  @update:modelValue="doorThermalChange()"
                  required>
              </v-select>
            </div>
          </div>
        </div>
        <div id="DOOR2" style="display:none">
          <div style="display: flex; justify-content: left;width: 1168px; height: 20px;margin-top: 10px; background-color: #eaeaea;">
            <div style="padding-left: 10px;">枠の選択</div>
          </div>
          <div style="display: flex; justify-content: left;">
            <div class="thumbnail-box">
              <div class="grid">
                <div
                  v-for="(item, index) in doorseriesimages"
                  :key="index"
                  class="thumb"
                  :class="{ 'selected-thumb': item.value === doorSyuSelectId }"
                  @click="doorSeriseSelected(index)"
                >
                  <div class="thumb-content">
                    <img
                      v-if="!doorimageErrors[index]"
                      :src="item.item"
                      :alt="item.value"
                      @error="doorimageErrors[index] = true"
                    />
                    <div v-else class="fallback-text">{{ item.value }}</div>
                  </div>
                  <div class="caption">{{ item.value }}</div>
                  <!-- <img :src="item.item" alt={{ item.value }}/> -->
                  <div v-if="item.description !== ''" class="tooltip">{{ item.description }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="DOOR3" style="display:none">
          <div style="display: flex; justify-content: left;width: 1168px;margin-top: 10px; height: 30px;background-color: #eaeaea;">
            <div style="padding-left: 10px;">本体デザインの選択</div>
          </div>
          <div class="select-wrapper">
            <!-- グレー帯 -->
            <div class="select-bg"></div>
            <!-- セレクト -->
            <div class="select-foreground" style="width:915px;">
              <v-select variant="outlined" density="compact" width="450px" bg-color="white" color="#1976d2"
                  :items="doorDesignSelectList"
                  v-model="doorDesignSelectId"
                  @update:modelValue="doorGlassChange()"
                  required>
              </v-select>
            </div>
          </div>
        </div>
        <div id="DOOR4" style="display:none">
          <div style="display: flex; justify-content: left;width: 1168px;margin-top: 10px; height: 30px;background-color: #eaeaea;">
            <div style="padding-left: 10px;">ガラス種の選択</div>
          </div>
          <div class="select-wrapper">
            <!-- グレー帯 -->
            <div class="select-bg"></div>
            <!-- セレクト -->
            <div class="select-foregroundGlass" style="width:915px;">
              <v-select variant="outlined" density="compact" width="450px" bg-color="white" color="#1976d2"
                  :items="doorGlassSelectList"
                  v-model="doorGlassSelectId"
                  required>
              </v-select>
            </div>
          </div>
          <div v-if="rigionPattern !== '1'">
            <div v-if="doorOpeningFlg === 'window'">
              <div style="display: flex; justify-content: left;padding-left: 10px;width: 1168px; height: 30px;margin-top: 10px;background-color: #eaeaea;">
                有効なひさし、軒等&nbsp;&nbsp;<v-icon class="clickable" @click="onHisashiHelp" color="blue" size="22">mdi-help-circle-outline</v-icon>
              </div>
              <div style="display: flex; justify-content: left;padding-left: 10px;width: 1168px; height: 45px;background-color: #eaeaea;">
                <v-btn-toggle
                  v-model="doorHisashitoggle"
                  mandatory
                  class="toggle-box"
                >
                  <v-btn
                    class="toggle-btn"
                    :class="{'selected': doorHisashitoggle === 0}"
                    value="0"
                  >なし</v-btn>
                  <v-btn
                    class="toggle-btn"
                    :class="{'selected': doorHisashitoggle === 1}"
                    value="1"
                  >あり</v-btn>
                </v-btn-toggle>
              </diV>
            </div>
          </div>
        </div>
        <div id="DOOREND">
          <v-container style="margin-top: 8px;">
            <v-row justify="center">
              <v-col>
                <div style="display: flex; justify-content: center; gap: 16px;">
                  <div>
                    <v-btn @click="doorCancelMaindis" color="white">
                      キャンセル
                    </v-btn>
                  </div>
                  <diV v-if="doorMode === 'insert'">
                    <v-btn :disabled="!doorGlassSelectId" @click="addDoor" color="#1976d2">
                      確定
                    </v-btn>
                  </div>
                  <div v-if="doorMode === 'update'">
                    <v-btn :disabled="!doorGlassSelectId" @click="henkouDoor" color="#1976d2">
                      確定
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <div style="display:flex; align-items:center; width:100%;">
            <div style="flex:1; display:flex; justify-content:center;">
              <v-btn color="blue" variant="text" @click="backFnc" style="margin-left: 0px; background-color: white;">
              －&nbsp;&nbsp;地域区分の選択へ戻る&nbsp;&nbsp;－
            </v-btn>
            </div>
          </div>
        </div>
      </diV>
    </diV>
    <div id='RESULT' style="display:none ">
      <v-container>
        <v-tabs v-model="resulttab" color="#1976d2" bg-color="white" align-tabs="center" style="margin-top: -15px;">
          <!-- <v-tab value="4">結 果</v-tab> -->
          <v-tab value="1">結 果</v-tab>
          <v-tab value="2">窓 一 覧</v-tab>
          <v-tab value="3">ドア 一 覧</v-tab>
        </v-tabs>
        <v-window v-model="resulttab">
          <v-window-item value="1">
            <br>
            <div class="d-flex justify-center">
              <div class="d-flex align-center" style="margin-top: -15px;">
                <h2 class="mr-2" style="font-weight: bold;">仕 様 基 準 の 適 否 確 認 結 果</h2>
                <v-icon class="clickable" @click="onHelp" color="blue" size="36">mdi-help-circle-outline</v-icon>
              </div>
            </div>
            <br>
            <div style="margin-top: -10px;">
              <div style="display: flex; align-items: center; max-width: 1208px; width: 100%;">
                <div style="margin-right: 10px; width: 560px;"></div>
                <div style="width: 250px;">
                  <v-btn @click="pdfcreate()" color="#1976d2" style="width: 250px;">
                    &ensp;結果のみダウンロード&ensp;
                  </v-btn>
                </div>
                <div style="width: 20px;"></div>
                <div style="width: 250px;">
                  <v-btn @click="pdfcreateZip()" color="#1976d2" style="width: 250px;">
                    &ensp;証明書を含む一括ダウンロード&ensp;
                  </v-btn>
                </div>
              </div>
            </div>
            <div style="position: relative; margin-top: 25px; left: 20px; width: 1070px;
                        display: flex; flex-direction: row; align-items: center;">
              <!-- ラベル -->
              <div style="font-size: 16px; font-weight: bold; width: 90px;margin-top: -20px;margin-left: -12px;">
                判定方法
              </div>
              <v-radio-group
                v-model="hanteiMethod"
                @update:modelValue="hanteiSyuChange()"
                class="hantei-select-radio"
              >
                <v-radio
                  v-for="item in hanteiMethodList"
                  :key="item.value"
                  :label="item.title"
                  :value="item.value"
                  color="#1976d2"
                  class="radio-bold"
                />
              </v-radio-group>
            </div>
            <div>
              <div style="position: relative;margin-top: -10px; left: 20px;width: 1110px;
              display: flex; flex-direction: column; justify-content: center; align-items: flex-start;">
                <div style="font-size: 16px;font-weight: bold;">
                  地域区分&nbsp;<span style="font-size: 24px;font-weight: bold;">{{ rigionClass }}</span>&nbsp;地域
                </div>
              </div>
            </div>
            <div>
              <div style="position: relative;margin-top: 15px; left: 20px;width: 1110px; font-size: smaller;font-weight: bold;
                display: flex; flex-direction: column; justify-content: center; align-items: flex-start;">
                窓：大部分が透明材料で構成される開口部
              </div>
              <!-- 地域1-4用 -->
              <div v-if="rigionPattern === '1'" style="position: relative;left: 20px;width: 1110px; height: 105px;">
                <div style="position: absolute; left:0px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; background-color: #eaeaea; color: black;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  部位
                </div>
                <div style="position: absolute; left:50px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  No.
                </div>
                <!-- 見出し表示用 -->
                <div style=" position: absolute; left:100px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  background-color: #eaeaea; border-top:1px solid black; border-bottom:1px solid black; border-left:1px solid black;
                  display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <div>該当</div>
                    <div style="margin-top: -5px;">&nbsp;窓</div>
                    <div style="margin-top: -5px;">&nbsp;の有無</div>
                </div>
                <div style="position: absolute; left:150px; top: 0px; height: 28px; width: 270px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  熱貫流率U[W/(㎡・K)]
                </div>
                <div style="position: absolute; left:150px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-bottom:1px solid black;border-left:1px solid black;">
                  設計値
                </div>
                <div style="position: absolute; left:240px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  省エネ基準
                </div>
                <div style="position: absolute; left:240px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級4)
                </div>
                <div style="position: absolute; left:240px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:330px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  誘導基準
                </div>
                <div style="position: absolute; left:330px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級5)
                </div>
                <div style="position: absolute; left:330px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:420px; top: 0px; height: 28px; width: 180px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                  適否確認
                </div>
                <div style="position: absolute; left:420px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  省エネ基準
                </div>
                <div style="position: absolute; left:420px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級4)
                </div>
                <div style="position: absolute; left:420px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:510px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  誘導基準
                </div>
                <div style="position: absolute; left:510px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級5)
                </div>
                <div style="position: absolute; left:510px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                </div>
                <!-- 左サイド表示用 -->
                <div style="position: absolute; left:0px; top: 56px; height: 46px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; background-color: #eaeaea; color: black;
                  border-bottom:1px solid black;border-left:1px solid black;">
                  窓
                </div>
                <!-- データ部表示用 -->
                <div :style="[getNoStyle(resultDisplay.WINDOW_NO2),{position: 'absolute',left: '50px', top: '56px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_NO2 }}
                </div>
                <div :style="{position: 'absolute',left: '50px', top: '56px', width: '50px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '100px', top: '56px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                  {{ resultDisplay.WINDOW_EXIST2 }}
                </div>
                <div :style="[getValueStyle(resultDisplay.WINDOW_THERMAL_TRANS2),{position: 'absolute',left: '150px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_THERMAL_TRANS2 }}
                </div>
                <div :style="{position: 'absolute',left: '150px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getKijyunn4Style(resultDisplay.STANDARD4_THERMAL_TRANS2),{position: 'absolute',left: '240px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD4_THERMAL_TRANS2 }}
                </div>
                <div :style="{position: 'absolute',left: '240px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getKijyunn5Style(resultDisplay.STANDARD5_THERMAL_TRANS2),{position: 'absolute',left: '330px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD5_THERMAL_TRANS2 }}
                </div>
                <div :style="{position: 'absolute',left: '330px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getResult4Style(resultDisplay.WINDOW_HANTEI4_2),{position: 'absolute',left: '420px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_HANTEI4_2 }}
                </div>
                <div :style="{position: 'absolute',left: '420px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getResult5Style(resultDisplay.WINDOW_HANTEI5_2),{position: 'absolute',left: '510px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_HANTEI5_2 }}
                </div>
                <div :style="{position: 'absolute',left: '510px', top: '56px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', borderRight:'1px solid black'}">
                </div>
              </div>
              <div v-if="rigionPattern === '1'" style="position: relative;margin-top: 10px; left: 20px;width: 1110px; font-size: smaller;font-weight: bold;
                display: flex; flex-direction: column; justify-content: center; align-items: flex-start;">
                ドア：大部分が不透明材料で構成されている開口部
              </div>
              <div v-if="rigionPattern === '1'" style="position: relative;left: 20px;width: 1110px; height: 115px;">
                <div style="position: absolute; left:0px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; background-color: #eaeaea; color: black;">
                  部位
                </div>
                <div style="position: absolute; left:0px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; color: black;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:0px; top: 56px; height: 46px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; background-color: #eaeaea; color: black;">
                  ドア
                </div>
                <div style="position: absolute; left:0px; top: 56px; height: 46px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; color: black;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:50px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  No.
                </div>
                <!-- 見出し表示用 -->
                <div style=" position: absolute; left:100px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  background-color: #eaeaea; border-top:1px solid black; border-bottom:1px solid black; border-left:1px solid black;
                  display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <div>該当</div>
                    <div style="margin-top: -5px;">&nbsp;ドア</div>
                    <div style="margin-top: -5px;">&nbsp;の有無</div>
                </div>
                <div style="position: absolute; left:150px; top: 0px; height: 28px; width: 270px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  熱貫流率U[W/(㎡・K)]
                </div>
                <div style="position: absolute; left:150px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-bottom:1px solid black;border-left:1px solid black;">
                  設計値
                </div>
                <div style="position: absolute; left:240px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  省エネ基準
                </div>
                <div style="position: absolute; left:240px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級4)
                </div>
                <div style="position: absolute; left:240px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:330px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  誘導基準
                </div>
                <div style="position: absolute; left:330px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級5)
                </div>
                <div style="position: absolute; left:330px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:420px; top: 0px; height: 28px; width: 180px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                  適否確認
                </div>
                <div style="position: absolute; left:420px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  省エネ基準
                </div>
                <div style="position: absolute; left:420px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級4)
                </div>
                <div style="position: absolute; left:420px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:510px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  誘導基準
                </div>
                <div style="position: absolute; left:510px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級5)
                </div>
                <div style="position: absolute; left:510px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                </div>
                <!-- データ部表示用 -->
                <div :style="[getNoStyle(resultDisplay.DOOR_NO),{position: 'absolute',left: '50px', top: '56px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.DOOR_NO }}
                </div>
                <div :style="{position: 'absolute',left: '50px', top: '56px', width: '50px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '100px', top: '56px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                  {{ resultDisplay.DOOR_EXIST }}
                </div>
                <div :style="[getValueStyle(resultDisplay.DOOR_THERMAL_TRANS),{position: 'absolute',left: '150px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.DOOR_THERMAL_TRANS }}
                </div>
                <div :style="{position: 'absolute',left: '150px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getKijyunn4Style(resultDisplay.STANDARD4_THERMAL_TRANSD),{position: 'absolute',left: '240px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD4_THERMAL_TRANSD }}
                </div>
                <div :style="{position: 'absolute',left: '240px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getKijyunn5Style(resultDisplay.STANDARD5_THERMAL_TRANSD),{position: 'absolute',left: '330px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD5_THERMAL_TRANSD }}
                </div>
                <div :style="{position: 'absolute',left: '330px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getResult4Style(resultDisplay.DOOR_HANTEI4),{position: 'absolute',left: '420px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.DOOR_HANTEI4 }}
                </div>
                <div :style="{position: 'absolute',left: '420px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getResult5Style(resultDisplay.DOOR_HANTEI5),{position: 'absolute',left: '510px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.DOOR_HANTEI5 }}
                </div>
                <div :style="{position: 'absolute',left: '510px', top: '56px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', borderRight:'1px solid black'}">
                </div>
              </div>
              <!-- 地域5-7用 -->
              <div v-if="rigionPattern === '2'" style="position: relative;left: 20px;width: 1110px; height: 195px;">
                <div style="position: absolute; left:0px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; background-color: #eaeaea; color: black;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  部位
                </div>
                <div style="position: absolute; left:50px; top: 0px; height: 56px; width: 200px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; background-color: #eaeaea; color: black;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  日射遮蔽対策
                </div>
                <div style="position: absolute; left:250px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  No.
                </div>
                <!-- 見出し表示用 -->
                <div style=" position: absolute; left:300px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  background-color: #eaeaea; border-top:1px solid black; border-bottom:1px solid black; border-left:1px solid black;
                  display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <div>該当</div>
                    <div style="margin-top: -5px;">&nbsp;窓</div>
                    <div style="margin-top: -5px;">&nbsp;の有無</div>
                </div>
                <div style="position: absolute; left:350px; top: 0px; height: 28px; width: 270px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  熱貫流率U[W/(㎡・K)]
                </div>
                <div style="position: absolute; left:350px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-bottom:1px solid black;border-left:1px solid black;">
                  設計値
                </div>
                <div style="position: absolute; left:440px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  省エネ基準
                </div>
                <div style="position: absolute; left:440px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級4)
                </div>
                <div style="position: absolute; left:440px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:530px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  誘導基準
                </div>
                <div style="position: absolute; left:530px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級5)
                </div>
                <div style="position: absolute; left:530px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:620px; top: 0px; height: 28px; width: 270px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  日射熱取得率η[―]
                </div>
                <div style="position: absolute; left:620px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-bottom:1px solid black;border-left:1px solid black;">
                  設計値
                </div>
                <div style="position: absolute; left:710px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  省エネ基準
                </div>
                <div style="position: absolute; left:710px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級4)
                </div>
                <div style="position: absolute; left:710px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:800px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  誘導基準
                </div>
                <div style="position: absolute; left:800px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級5)
                </div>
                <div style="position: absolute; left:800px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:890px; top: 0px; height: 28px; width: 180px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                  適否確認
                </div>
                <div style="position: absolute; left:890px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  省エネ基準
                </div>
                <div style="position: absolute; left:890px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級4)
                </div>
                <div style="position: absolute; left:890px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:980px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  誘導基準
                </div>
                <div style="position: absolute; left:980px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級5)
                </div>
                <div style="position: absolute; left:980px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                </div>
                <!-- 左サイド表示用 -->
                <div style="position: absolute; left:0px; top: 56px; height: 137px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; background-color: #eaeaea; color: black;
                  border-bottom:1px solid black;border-left:1px solid black;">
                  窓
                </div>
                <div style=" position: absolute; left:50px; top: 56px; height: 46px; width: 200px; font-size: smaller;
                  background-color: #eaeaea; border-bottom:1px solid black; border-left:1px solid black;
                  display: flex; flex-direction: column; justify-content: center; align-items: flex-start; /* ← 左寄せ */ ">
                    <div>&nbsp;有効なひさし、軒等、</div>
                    <div style="margin-top: -5px;">&nbsp;付属部材が</div>
                    <div style="margin-top: -5px;">&nbsp;ある所に設置する窓</div>
                </div>
                <div style=" position: absolute; left:50px; top: 102px; height: 91px; width: 100px; font-size: smaller;
                  background-color: #eaeaea; border-bottom:1px solid black; border-left:1px solid black;
                  display: flex; flex-direction: column; justify-content: center; align-items: flex-start; /* ← 左寄せ */ ">
                    <div>&nbsp;有効なひさし、</div>
                    <div style="margin-top: -5px;">&nbsp;軒等、</div>
                    <div style="margin-top: -5px;">&nbsp;付属部材が</div>
                    <div style="margin-top: -5px;">&nbsp;ない所に設置</div>
                    <div style="margin-top: -5px;">&nbsp;する窓</div>
                </div>
                <div style=" position: absolute; left:150px; top: 102px; height: 46px; width: 100px; font-size: smaller;
                  background-color: #eaeaea; border-bottom:1px solid black; border-left:1px solid black;
                  display: flex; flex-direction: column; justify-content: center; align-items: flex-start; /* ← 左寄せ */ ">
                    <div>&nbsp;熱貫流率Uが</div>
                    <div style="margin-top: -5px;">&nbsp;最大の窓</div>
                </div>
                <div style=" position: absolute; left:150px; top: 147px; height: 46px; width: 100px; font-size: smaller;
                  background-color: #eaeaea; border-top:1px solid black; border-bottom:1px solid black; border-left:1px solid black;
                  display: flex; flex-direction: column; justify-content: center; align-items: flex-start; /* ← 左寄せ */ ">
                    <div>&nbsp;開口部の日射</div>
                    <div style="margin-top: -5px;">&nbsp;熱取得率ηdが</div>
                    <div style="margin-top: -5px;">&nbsp;最大の窓</div>
                </div>
                <!-- データ部表示用 -->
                <div :style="[getNoStyle(resultDisplay.WINDOW_NO1),{position: 'absolute',left: '250px', top: '56px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_NO1 }}
                </div>
                <div :style="[getNoStyle(resultDisplay.WINDOW_NO2),{position: 'absolute',left: '250px', top: '102px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_NO2 }}
                </div>
                <div :style="[getNoStyle(resultDisplay.WINDOW_NO3),{position: 'absolute',left: '250px', top: '147px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_NO3 }}
                </div>
                <div :style="{position: 'absolute',left: '250px', top: '56px', width: '50px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '250px', top: '102px', width: '50px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '250px', top: '147px', width: '50px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '300px', top: '56px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                  {{ resultDisplay.WINDOW_EXIST1 }}
                </div>
                <div :style="{position: 'absolute',left: '300px', top: '102px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                  {{ resultDisplay.WINDOW_EXIST2 }}
                </div>
                <div :style="{position: 'absolute',left: '300px', top: '147px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                  {{ resultDisplay.WINDOW_EXIST3 }}
                </div>
                <div :style="[getValueStyle(resultDisplay.WINDOW_THERMAL_TRANS1),{position: 'absolute',left: '350px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_THERMAL_TRANS1 }}
                </div>
                <div :style="[getValueStyle(resultDisplay.WINDOW_THERMAL_TRANS2),{position: 'absolute',left: '350px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_THERMAL_TRANS2 }}
                </div>
                <div :style="[getValueStyle(resultDisplay.WINDOW_THERMAL_TRANS3),{position: 'absolute',left: '350px', top: '147px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_THERMAL_TRANS3 }}
                </div>
                <div :style="{position: 'absolute',left: '350px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '350px', top: '102px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '350px', top: '147px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getKijyunn4Style(resultDisplay.STANDARD4_THERMAL_TRANS1),{position: 'absolute',left: '440px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD4_THERMAL_TRANS1 }}
                </div>
                <div :style="[getKijyunn4Style(resultDisplay.STANDARD4_THERMAL_TRANS2),{position: 'absolute',left: '440px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD4_THERMAL_TRANS2 }}
                </div>
                <div :style="[getKijyunn4Style(resultDisplay.STANDARD4_THERMAL_TRANS3),{position: 'absolute',left: '440px', top: '147px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD4_THERMAL_TRANS3 }}
                </div>
                <div :style="{position: 'absolute',left: '440px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '440px', top: '102px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '440px', top: '147px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getKijyunn5Style(resultDisplay.STANDARD5_THERMAL_TRANS1),{position: 'absolute',left: '530px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD5_THERMAL_TRANS1 }}
                </div>
                <div :style="[getKijyunn5Style(resultDisplay.STANDARD5_THERMAL_TRANS2),{position: 'absolute',left: '530px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD5_THERMAL_TRANS2 }}
                </div>
                <div :style="[getKijyunn5Style(resultDisplay.STANDARD5_THERMAL_TRANS3),{position: 'absolute',left: '530px', top: '147px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD5_THERMAL_TRANS3 }}
                </div>
                <div :style="{position: 'absolute',left: '530px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '530px', top: '102px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '530px', top: '147px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getValueStyle(resultDisplay.WINDOW_SOLARHEAT2),{position: 'absolute',left: '620px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_SOLARHEAT2 }}
                </div>
                <div :style="[getValueStyle(resultDisplay.WINDOW_SOLARHEAT3),{position: 'absolute',left: '620px', top: '147px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_SOLARHEAT3 }}
                </div>
                <div :style="{position: 'absolute',left: '620px', top: '56px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', backgroundColor: '#404040'}">
                </div>
                <div :style="{position: 'absolute',left: '620px', top: '102px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '620px', top: '147px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getKijyunn4Style(resultDisplay.STANDARD4_SOLARHEAT2),{position: 'absolute',left: '710px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD4_SOLARHEAT2 }}
                </div>
                <div :style="[getKijyunn4Style(resultDisplay.STANDARD4_SOLARHEAT3),{position: 'absolute',left: '710px', top: '147px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD4_SOLARHEAT3 }}
                </div>
                <div :style="{position: 'absolute',left: '710px', top: '56px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', backgroundColor: '#404040'}">
                </div>
                <div :style="{position: 'absolute',left: '710px', top: '102px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '710px', top: '147px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getKijyunn5Style(resultDisplay.STANDARD5_SOLARHEAT2),{position: 'absolute',left: '800px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD5_SOLARHEAT2 }}
                </div>
                <div :style="[getKijyunn5Style(resultDisplay.STANDARD5_SOLARHEAT3),{position: 'absolute',left: '800px', top: '147px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD5_SOLARHEAT3 }}
                </div>
                <div :style="{position: 'absolute',left: '800px', top: '56px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', backgroundColor: '#404040'}">
                </div>
                <div :style="{position: 'absolute',left: '800px', top: '102px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '800px', top: '147px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getResult4Style(resultDisplay.WINDOW_HANTEI4_1),{position: 'absolute',left: '890px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_HANTEI4_1 }}
                </div>
                <div :style="[getResult4Style(resultDisplay.WINDOW_HANTEI4_2),{position: 'absolute',left: '890px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_HANTEI4_2 }}
                </div>
                <div :style="[getResult4Style(resultDisplay.WINDOW_HANTEI4_3),{position: 'absolute',left: '890px', top: '147px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_HANTEI4_3 }}
                </div>
                <div :style="{position: 'absolute',left: '890px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '890px', top: '102px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '890px', top: '147px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getResult5Style(resultDisplay.WINDOW_HANTEI5_1),{position: 'absolute',left: '980px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_HANTEI5_1 }}
                </div>
                <div :style="[getResult5Style(resultDisplay.WINDOW_HANTEI5_2),{position: 'absolute',left: '980px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_HANTEI5_2 }}
                </div>
                <div :style="[getResult5Style(resultDisplay.WINDOW_HANTEI5_3),{position: 'absolute',left: '980px', top: '147px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_HANTEI5_3 }}
                </div>
                <div :style="{position: 'absolute',left: '980px', top: '56px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', borderRight:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '980px', top: '102px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', borderRight:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '980px', top: '147px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', borderRight:'1px solid black'}">
                </div>
              </div>
              <div v-if="rigionPattern === '2'" style="position: relative;margin-top: 10px; left: 20px;width: 1110px; font-size: smaller;font-weight: bold;
                display: flex; flex-direction: column; justify-content: center; align-items: flex-start;">
                ドア：大部分が不透明材料で構成されている開口部
              </div>
              <div v-if="rigionPattern === '2'" style="position: relative;left: 20px;width: 1110px; height: 115px;">
                <div style="background-color: #eaeaea;">
                </div>
                <div style="position: absolute; left:0px; top: 0px; height: 56px; width: 250px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; background-color: #eaeaea; color: black;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  <div style="width:50px; text-align:center;"> 部位 </div>
                </div>
                <div style="position: absolute; left:0px; top: 56px; height: 46px; width: 250px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; background-color: #eaeaea; color: black;
                  border-bottom:1px solid black;border-left:1px solid black;">
                  <div style="width:50px; text-align:center;"> ドア </div>
                </div>
                <div style="position: absolute; left:250px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  No.
                </div>
                <!-- 見出し表示用 -->
                <div style=" position: absolute; left:300px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  background-color: #eaeaea; border-top:1px solid black; border-bottom:1px solid black; border-left:1px solid black;
                  display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <div>該当</div>
                    <div style="margin-top: -5px;">&nbsp;ドア</div>
                    <div style="margin-top: -5px;">&nbsp;の有無</div>
                </div>
                <div style="position: absolute; left:350px; top: 0px; height: 28px; width: 270px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  熱貫流率U[W/(㎡・K)]
                </div>
                <div style="position: absolute; left:350px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-bottom:1px solid black;border-left:1px solid black;">
                  設計値
                </div>
                <div style="position: absolute; left:440px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  省エネ基準
                </div>
                <div style="position: absolute; left:440px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級4)
                </div>
                <div style="position: absolute; left:440px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:530px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  誘導基準
                </div>
                <div style="position: absolute; left:530px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級5)
                </div>
                <div style="position: absolute; left:530px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:620px; top: 0px; height: 28px; width: 180px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                  適否確認
                </div>
                <div style="position: absolute; left:620px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  省エネ基準
                </div>
                <div style="position: absolute; left:620px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級4)
                </div>
                <div style="position: absolute; left:620px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:710px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  誘導基準
                </div>
                <div style="position: absolute; left:710px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級5)
                </div>
                <div style="position: absolute; left:710px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                </div>
                <!-- データ部表示用 -->
                <div :style="[getNoStyle(resultDisplay.DOOR_NO),{position: 'absolute',left: '250px', top: '56px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.DOOR_NO }}
                </div>
                <div :style="{position: 'absolute',left: '250px', top: '56px', width: '50px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '300px', top: '56px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                  {{ resultDisplay.DOOR_EXIST }}
                </div>
                <div :style="[getValueStyle(resultDisplay.DOOR_THERMAL_TRANS),{position: 'absolute',left: '350px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.DOOR_THERMAL_TRANS }}
                </div>
                <div :style="{position: 'absolute',left: '350px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getKijyunn4Style(resultDisplay.STANDARD4_THERMAL_TRANSD),{position: 'absolute',left: '440px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD4_THERMAL_TRANSD }}
                </div>
                <div :style="{position: 'absolute',left: '440px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getKijyunn5Style(resultDisplay.STANDARD5_THERMAL_TRANSD),{position: 'absolute',left: '530px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD5_THERMAL_TRANSD }}
                </div>
                <div :style="{position: 'absolute',left: '530px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getResult4Style(resultDisplay.DOOR_HANTEI4),{position: 'absolute',left: '620px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.DOOR_HANTEI4 }}
                </div>
                <div :style="{position: 'absolute',left: '620px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getResult5Style(resultDisplay.DOOR_HANTEI5),{position: 'absolute',left: '710px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.DOOR_HANTEI5 }}
                </div>
                <div :style="{position: 'absolute',left: '710px', top: '56px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', borderRight:'1px solid black'}">
                </div>
              </div>
              <!-- 地域8用 -->
              <div v-if="rigionPattern === '3'" style="position: relative;left: 20px;width: 1110px; height: 195px;">
                <div style="position: absolute; left:0px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; background-color: #eaeaea; color: black;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  部位
                </div>
                <div style="position: absolute; left:50px; top: 0px; height: 56px; width: 250px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; background-color: #eaeaea; color: black;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  日射遮蔽対策
                </div>
                <div style="position: absolute; left:300px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  No.
                </div>
                <!-- 見出し表示用 -->
                <div style=" position: absolute; left:350px; top: 0px; height: 56px; width: 50px; font-size: smaller;
                  background-color: #eaeaea; border-top:1px solid black; border-bottom:1px solid black; border-left:1px solid black;
                  display: flex; flex-direction: column; justify-content: center; align-items: center;">
                    <div>該当</div>
                    <div style="margin-top: -5px;">&nbsp;窓</div>
                    <div style="margin-top: -5px;">&nbsp;の有無</div>
                </div>
                <div style="position: absolute; left:400px; top: 0px; height: 28px; width: 270px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;">
                  日射熱取得率η[―]
                </div>
                <div style="position: absolute; left:400px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-bottom:1px solid black;border-left:1px solid black;">
                  設計値
                </div>
                <div style="position: absolute; left:490px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  省エネ基準
                </div>
                <div style="position: absolute; left:490px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級4)
                </div>
                <div style="position: absolute; left:490px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:580px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  誘導基準
                </div>
                <div style="position: absolute; left:580px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級5)
                </div>
                <div style="position: absolute; left:580px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:670px; top: 0px; height: 28px; width: 180px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea;
                  border-top:1px solid black;border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                  適否確認
                </div>
                <div style="position: absolute; left:670px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  省エネ基準
                </div>
                <div style="position: absolute; left:670px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級4)
                </div>
                <div style="position: absolute; left:670px; top: 28px; height: 28px; width: 90px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;">
                </div>
                <div style="position: absolute; left:760px; top: 28px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  誘導基準
                </div>
                <div style="position: absolute; left:760px; top: 42px; height: 14px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;background-color: #eaeaea; ">
                  (断熱等級5)
                </div>
                <div style="position: absolute; left:760px; top: 28px; height: 28px; width: 90px; font-size: 11px;
                  display: flex; justify-content: center; align-items: center;
                  border-bottom:1px solid black;border-left:1px solid black;border-right:1px solid black;">
                </div>
                <!-- 左サイド表示用 -->
                <div style="position: absolute; left:0px; top: 56px; height: 92px; width: 50px; font-size: smaller;
                  display: flex; justify-content: center; align-items: center; background-color: #eaeaea; color: black;
                  border-bottom:1px solid black;border-left:1px solid black;">
                  窓
                </div>
                <div style=" position: absolute; left:50px; top: 56px; height: 46px; width: 250px; font-size: smaller;
                  background-color: #eaeaea; border-bottom:1px solid black; border-left:1px solid black;
                  display: flex; flex-direction: column; justify-content: center; align-items: flex-start; /* ← 左寄せ */ ">
                    <div>&nbsp;有効なひさし、軒等、</div>
                    <div style="margin-top: -5px;">&nbsp;付属部材が</div>
                    <div style="margin-top: -5px;">&nbsp;ある所に設置する窓</div>
                </div>
                <div style=" position: absolute; left:50px; top: 102px; height: 46px; width: 150px; font-size: smaller;
                  background-color: #eaeaea; border-bottom:1px solid black; border-left:1px solid black;
                  display: flex; flex-direction: column; justify-content: center; align-items: flex-start; /* ← 左寄せ */ ">
                    <div>&nbsp;有効なひさし、軒等、</div>
                    <div style="margin-top: -5px;">&nbsp;付属部材が</div>
                    <div style="margin-top: -5px;">&nbsp;ない所に設置する窓</div>
                </div>
                <div style=" position: absolute; left:200px; top: 102px; height: 46px; width: 100px; font-size: smaller;
                  background-color: #eaeaea; border-top:1px solid black; border-bottom:1px solid black; border-left:1px solid black;
                  display: flex; flex-direction: column; justify-content: center; align-items: flex-start; /* ← 左寄せ */ ">
                    <div>&nbsp;開口部の日射</div>
                    <div style="margin-top: -5px;">&nbsp;熱取得率ηdが</div>
                    <div style="margin-top: -5px;">&nbsp;最大の窓</div>
                </div>
                <!-- データ部表示用 -->
                <div :style="[getNoStyle(resultDisplay.WINDOW_NO1),{position: 'absolute',left: '300px', top: '56px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_NO1 }}
                </div>
                <div :style="[getNoStyle(resultDisplay.WINDOW_NO3),{position: 'absolute',left: '300px', top: '102px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_NO3 }}
                </div>
                <div :style="{position: 'absolute',left: '300px', top: '56px', width: '50px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '300px', top: '102px', width: '50px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '350px', top: '56px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                  {{ resultDisplay.WINDOW_EXIST1 }}
                </div>
                <div :style="{position: 'absolute',left: '350px', top: '102px', width: '50px', height: '46px', fontSize: 'smaller',
                  display: 'flex', justifyContent: 'center', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                  {{ resultDisplay.WINDOW_EXIST3 }}
                </div>
                <div :style="[getValueStyle(resultDisplay.WINDOW_SOLARHEAT3),{position: 'absolute',left: '400px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_SOLARHEAT3 }}
                </div>
                <div :style="{position: 'absolute',left: '400px', top: '56px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', backgroundColor: '#404040'}">
                </div>
                <div :style="{position: 'absolute',left: '400px', top: '102px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getKijyunn4Style(resultDisplay.STANDARD4_SOLARHEAT3),{position: 'absolute',left: '490px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD4_SOLARHEAT3 }}
                </div>
                <div :style="{position: 'absolute',left: '490px', top: '56px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', backgroundColor: '#404040'}">
                </div>
                <div :style="{position: 'absolute',left: '490px', top: '102px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getKijyunn5Style(resultDisplay.STANDARD5_SOLARHEAT3),{position: 'absolute',left: '580px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.STANDARD5_SOLARHEAT3 }}
                </div>
                <div :style="{position: 'absolute',left: '580px', top: '56px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', backgroundColor: '#404040'}">
                </div>
                <div :style="{position: 'absolute',left: '580px', top: '102px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getResult4Style(resultDisplay.WINDOW_HANTEI4_1),{position: 'absolute',left: '670px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_HANTEI4_1 }}
                </div>
                <div :style="[getResult4Style(resultDisplay.WINDOW_HANTEI4_3),{position: 'absolute',left: '670px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_HANTEI4_3 }}
                </div>
                <div :style="{position: 'absolute',left: '670px', top: '56px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '670px', top: '102px', width: '90px', height: '46px', borderBottom:'1px solid black', borderLeft:'1px solid black'}">
                </div>
                <div :style="[getResult5Style(resultDisplay.WINDOW_HANTEI5_1),{position: 'absolute',left: '760px', top: '56px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_HANTEI5_1 }}
                </div>
                <div :style="[getResult5Style(resultDisplay.WINDOW_HANTEI5_3),{position: 'absolute',left: '760px', top: '102px', width: '90px', height: '46px', fontSize: 'smaller',
                  display: 'flex', alignItems: 'center',
                  borderBottom:'1px solid black', borderLeft:'1px solid black'}]">
                  {{ resultDisplay.WINDOW_HANTEI5_3 }}
                </div>
                <div :style="{position: 'absolute',left: '760px', top: '56px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', borderRight:'1px solid black'}">
                </div>
                <div :style="{position: 'absolute',left: '760px', top: '102px', width: '90px', height: '46px',
                  borderBottom:'1px solid black', borderLeft:'1px solid black', borderRight:'1px solid black'}">
                </div>
              </div>
            </div>
            <div style="display:flex; align-items:center; width:100%;">
              <!-- 左端ボタン -->
              <v-btn size="small" @click="backProduct" color="grey darken-2" style="margin-left: 20px; width: 50px;">
                戻る
              </v-btn>
              <!-- 中央ボタン（flex で中央寄せ） -->
              <div style="flex:1; display:flex; justify-content:center;">
                <v-btn color="blue" variant="text" @click="backFnc" style="margin-left: -70px; background-color: white;">
                －&nbsp;&nbsp;地域区分の選択へ戻る&nbsp;&nbsp;－
              </v-btn>
              </div>
            </div>
          </v-window-item>
          <v-window-item value="2">
            <diV v-if="showWindowCardsResult">
            <v-card
                v-for="(item, index) in resultWindowList"
                :key="index"
                class="mb-1 position-relative"
                height="108px"
                min-width="800px"
              >
              <div
                style="top: 40px;left: 1px;position: absolute;font-size: smaller ;">
                No.{{ item.SEQ }}
              </div>
              <div
                style="top: 6px;left: 51px;position: absolute;font-size: 16px ;font-weight: bold;">
                {{ item.SERIES }}
              </div>
              <div
                style="top: 33px;left: 51px;position: absolute;font-size: smaller ;">
                {{ item.GLASS_TYPE }}
              </div>
              <div style="display: flex;align-items: center;position: absolute;top: 56px;left: 51px;font-size: smaller;">
                {{ item.WINDOW_TYPE }}
              </div>
              <!-- ドアで開口部が窓も表示させる20260108 -->
              <div v-if="rigionPattern !== '1' && item.FROM == 'WINDOW'">
                <div style="top: 83px;left: 51px;position: absolute;font-size: smaller ;">
                  有効な付属部材：{{ item.BUZAI }}
                </div>
                <div style="top: 83px;left: 226px;position: absolute;font-size: smaller ;">
                  有効なひさし、軒等：{{ item.HISASHI }}
                </div>
              </div>
              <div v-if="rigionPattern !== '1' && item.FROM == 'DOOR'">
                <div style="top: 83px;left: 56px;position: absolute;font-size: smaller ;">
                  有効なひさし、軒等：{{ item.HISASHI }}
                </div>
              </div>
              <div style="border-bottom: 1px solid black;padding: 0px;top: -1px;left: 700px;position: absolute;font-size: smaller;width: 210px;text-align: center;">
                建具とガラスの組み合わせ
              </div>
              <div style="top: 20px;left: 700px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                熱貫流率
              </div>
              <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 700px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                [W/(㎡・K)]
              </div>
              <div style="top: 49px;left: 700px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                {{ item.TYPE_THERMAL_TRANS }}
              </div>
              <div style="top: 20px;left: 810px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                日射熱取得率
              </div>
              <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 810px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                [―]
              </div>
              <div style="top: 49px;left: 810px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                {{ item.TYPE_SOLARHEAT }}
              </div>
              <div class="capsule-4"
                style="top: 68px;left: 700px;"
              >
                <span>省エネ基準：</span>
                <span :class="item.TYPE_HANTEI_4 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                  {{ item.TYPE_HANTEI_4 }}</span>
              </div>
              <div class="capsule-5"
                style="top: 87px;left: 700px;"
              >
                <span>&emsp;誘導基準：</span>
                  <span :class="item.TYPE_HANTEI_5 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                    {{ item.TYPE_HANTEI_5 }}</span>
              </div>
              <div style="border-bottom: 1px solid black;padding: 0px;top: -px;left: 920px;position: absolute;font-size: smaller;width: 210px;text-align: center;">
                自己適合宣言書・附属書
              </div>
              <div style="top: 20px;left: 920px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                熱貫流率
              </div>
              <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 920px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                [W/(㎡・K)]
              </div>
              <div style="top: 49px;left: 920px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                {{ item.EXAM_THERMAL_TRANS }}
              </div>
              <div style="top: 20px;left: 1030px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                日射熱取得率
              </div>
              <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 1030px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                [―]
              </div>
              <div style="top: 49px;left: 1030px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                {{ item.EXAM_SOLARHEAT }}
              </div>
              <div class="capsule-4"
                style="top: 68px;left: 920px;"
              >
              <span>省エネ基準：</span>
                <span :class="item.EXAM_HANTEI_4 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                  {{ item.EXAM_HANTEI_4 }}</span>
              </div>
              <div class="capsule-5"
                style="top: 87px;left: 920px;"
              >
              <span>&emsp;誘導基準：</span>
                  <span :class="item.EXAM_HANTEI_5 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                    {{ item.EXAM_HANTEI_5 }}</span>
              </div>
            </v-card>
            </div>
            <diV v-if="showWindowCardsResult == false">
              <br><br>
              <h1>選択されていません</h1>
            </diV>
          </v-window-item>
          <v-window-item value="3">
            <diV v-if="showDoorCardsResult">
              <v-card
                v-for="(item, index) in resultDoorList"
                :key="index"
                class="mb-1 position-relative"
                height="108px"
                min-width="800px"
              >
                <div
                  style="top: 40px;left: 1px;position: absolute;font-size: smaller ;"
                >
                  No.{{ item.SEQ }}
                </div>
                <div
                  style="top: 6px;left: 51px;position: absolute;font-size: 16px ;font-weight: bold;"
                >
                  {{ item.SERIES }}
                </div>
                <div
                  style="top: 33px;left: 51px;position: absolute;font-size: smaller ;"
                >
                  {{ item.GLASS_TYPE }}
                </div>
                <div
                  style="display: flex;align-items: center;position: absolute;top: 56px;left: 51px;font-size: smaller;
                  "
                >
                  {{ item.WINDOW_TYPE }}
                </div>
                <!-- ドアで開口部が窓も表示させる20260108 -->
                <!-- 20260126 ドアでは部材/ひさしの表示はしない。
                <div v-if="rigionPattern !== '1' && item.FROM == 'WINDOW'">
                  <div
                    style="top: 83px;left: 56px;position: absolute;font-size: smaller ;"
                  >
                    有効な付属部材：{{ item.BUZAI }}
                  </div>
                  <div
                    style="top: 83px;left: 196px;position: absolute;font-size: smaller ;"
                  >
                    有効なひさし：{{ item.HISASHI }}
                  </div>
                </div> -->
                <div
                  style="border-bottom: 1px solid black;padding: 0px;top: -1px;left: 700px;position: absolute;font-size: smaller;width: 210px;text-align: center;">
                  建具とガラスの組み合わせ
                </div>
                <div style="top: 20px;left: 700px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                  熱貫流率
                </div>
                <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 700px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                  [W/(㎡・K)]
                </div>
                <div style="top: 49px;left: 700px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                  {{ item.TYPE_THERMAL_TRANS }}
                </div>
                <div style="top: 20px;left: 810px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                  日射熱取得率
                </div>
                <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 810px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                  [―]
                </div>
                <div style="top: 49px;left: 810px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                  {{ item.TYPE_SOLARHEAT }}
                </div>
                <div class="capsule-4"
                  style="top: 68px;left: 700px;"
                >
                <span>省エネ基準：</span>
                <span :class="item.TYPE_HANTEI_4 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                  {{ item.TYPE_HANTEI_4 }}</span>
                </div>
                <div class="capsule-5"
                  style="top: 87px;left: 700px;"
                >
                <span>&emsp;誘導基準：</span>
                  <span :class="item.TYPE_HANTEI_5 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                    {{ item.TYPE_HANTEI_5 }}</span>
                </div>
                <div style="border-bottom: 1px solid black;padding: 0px;top: -1px;left: 920px;position: absolute;font-size: smaller;width: 210px;text-align: center;">
                  自己適合宣言書・附属書
                </div>
                <div style="top: 20px;left: 920px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                  熱貫流率
                </div>
                <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 920px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                  [W/(㎡・K)]
                </div>
                <div style="top: 49px;left: 920px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                  {{ item.EXAM_THERMAL_TRANS }}
                </div>
                <div style="top: 20px;left: 1030px;position: absolute;font-size: 11px;width: 100px;text-align: center;">
                  日射熱取得率
                </div>
                <div style="border-bottom: 1px solid black;padding: 0px;top: 34px;left: 1030px;position: absolute;font-size: 10px;width: 100px;text-align: center;">
                  [―]
                </div>
                <div style="top: 49px;left: 1030px;position: absolute;font-size: smaller;font-weight: bold;width: 100px;text-align: center;">
                  {{ item.EXAM_SOLARHEAT }}
                </div>
                <div class="capsule-4"
                  style="top: 68px;left: 920px;"
                >
                <span>省エネ基準：</span>
                <span :class="item.EXAM_HANTEI_4 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                  {{ item.EXAM_HANTEI_4 }}</span>
                </div>
                <div class="capsule-5"
                  style="top: 87px;left: 920px;"
                >
                <span>&emsp;誘導基準：</span>
                  <span :class="item.EXAM_HANTEI_5 === '不適' ? 'capsule-text-red' : 'capsule-text-black'">
                    {{ item.EXAM_HANTEI_5 }}</span>
                </div>
              </v-card>
            </div>
            <diV v-if="showDoorCardsResult == false">
              <br><br>
              <h1>選択されていません</h1>
            </diV>
          </v-window-item>
        </v-window>
      </v-container>
    </div>
    <v-dialog v-model="deleteWindowdialog" max-width="400">
      <v-card>
        <v-card-title>本当に削除しますか？</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" @click="deleteWindowdialog = false">キャンセル</v-btn>
          <v-btn color="red" @click="deleteWindowdialogFnc">削除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDoordialog" max-width="400">
      <v-card>
        <v-card-title>本当に削除しますか？</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" @click="deleteDoordialog = false">キャンセル</v-btn>
          <v-btn color="red" @click="deleteDoordialogFnc">削除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="backregiondialog" max-width="400">
      <v-card>
        <v-card-title>地域選択にもどりますか？<br>選択されたデータはクリアされます。</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" @click="backregiondialog = false">キャンセル</v-btn>
          <v-btn color="blue" @click="backRegionFnc()">戻る</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="glassAssistdialog3" color="white" width="1000">
      <div class="dialog-container white-bg">
        <!-- クローズボタン（dialog右上） -->
        <v-btn
          icon
          color="black"
          size="x-small"
          variant="outlined"
          class="close-btn"
          @click="glassAssistdialog3 = false"
        >
          <v-icon size="16">mdi-close</v-icon>
        </v-btn>
        <v-card
          width="900"
          color="#e0e0e0"
          class="mx-auto"
        >
          <v-card-actions class="d-flex">
            <span style="font-weight: bold;">ガラス種の選択</span>
            <v-btn class="ml-auto" color="light" size="small" variant="outlined" width="200px" v-on:click="glassAssistClear3()">条件クリア</v-btn>
          </v-card-actions>
          <v-card-text class="scroll-area">
            <div class="d-flex justify-start pa-2" style="margin-top: -20px;">
              ・ガス有無
            </div>
            <div class="d-flex justify-start pa-2" style="margin-top: -10px;">
              <div class="glass-button-grid">
                <div
                  v-for="(item, index) in glassAssistListInit1"
                  :key="index"
                >
                  <v-btn v-if="item.disable == true" color="grey darken-3" @click="glassAssistChange2(1, item.value)" width="265px" style="text-transform: none;">{{ item.value }}</v-btn>
                  <v-btn v-if="item.value == glassAssistId1" color="#1976d2" width="265px" style="text-transform: none;">{{ item.value }}</v-btn>
                  <v-btn v-if="item.value != glassAssistId1 && item.disable == false" color="white" @click="glassAssistChange2(1, item.value)" width="265px" style="text-transform: none;">{{ item.value }}</v-btn>
                </div>
              </div>
            </div>
            <div class="d-flex justify-start pa-2" style="margin-top: -15px;">
              ・Low-E膜色
            </div>
            <div class="d-flex justify-start pa-2" style="margin-top: -15px;">
              <div class="glass-button-grid">
                <div
                  v-for="(item, index) in glassAssistListInit3"
                  :key="index"
                >
                  <v-btn v-if="item.disable == true" color="grey darken-3" @click="glassAssistChange2(3, item.value)" width="265px" style="text-transform: none;">{{ item.value }}</v-btn>
                  <v-btn v-if="item.value == glassAssistId3" color="#1976d2" width="265px" style="text-transform: none;">{{ item.value }}</v-btn>
                  <v-btn v-if="item.value != glassAssistId3 && item.disable == false" color="white" @click="glassAssistChange2(3, item.value)" width="265px" style="text-transform: none;">{{ item.value }}</v-btn>
                </div>
              </div>
            </div>
            <div class="d-flex justify-start pa-2" style="margin-top: -15px;">
              ・スペーサー
            </div>
            <div class="d-flex justify-start pa-2" style="margin-top: -15px;">
              <div class="glass-button-grid">
                <div
                  v-for="(item, index) in glassAssistListInit4"
                  :key="index"
                >
                  <v-btn v-if="item.disable == true" color="grey darken-3" @click="glassAssistChange2(4, item.value)" width="265px" style="text-transform: none;">{{ item.value }}</v-btn>
                  <v-btn v-if="item.value == glassAssistId4" color="#1976d2" width="265px" style="text-transform: none;">{{ item.value }}</v-btn>
                  <v-btn v-if="item.value != glassAssistId4 && item.disable == false" color="white" @click="glassAssistChange2(4, item.value)" width="265px" style="text-transform: none;">{{ item.value }}</v-btn>
                </div>
              </div>
            </div>
            <div class="d-flex justify-start pa-2" style="margin-top: -15px;">
              ・ガラス構成
            </div>
            <div class="d-flex justify-start pa-2" style="margin-top: -15px;">
              <div class="glass-button-grid">
                <div
                  v-for="(item, index) in glassAssistListInit2"
                  :key="index"
                >
                  <v-btn v-if="item.disable == true" color="grey darken-3" @click="glassAssistChange2(2, item.value)" width="265px" style="text-transform: none;">{{ item.value }}</v-btn>
                  <v-btn v-if="item.value == glassAssistId2" color="#1976d2" width="265px" style="text-transform: none;">{{ item.value }}</v-btn>
                  <v-btn v-if="item.value != glassAssistId2 && item.disable == false" color="white" @click="glassAssistChange2(2, item.value)" width="265px" style="text-transform: none;">{{ item.value }}</v-btn>
                </div>
              </div>
            </div>
            <div class="d-flex justify-start pa-2" style="margin-top: 5px;">
              <v-list class="scrollable-list">
                <v-list-item-group v-model="glassdialogValue">
                  <v-list-item
                    v-for="item in glassHenkoList"
                    :key="item.value"
                    :class="{'selected-item': item.value === glassdialogValue}"
                    @click="glassAssistUpadte(3,item.value)"
                  >
                    <v-list-item-content class="left-aligned">
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
          </v-card-text>
          <br>
        </v-card>
      </diV>
        <!-- OKボタン -->
        <!-- <v-card-actions class="justify-center"> -->
          <!-- <v-btn color="primary" @click="glassdialog = false">OK</v-btn> -->
        <!-- </v-card-actions> -->
    </v-dialog>
    <template>
      <div>
        <v-dialog persistent v-model="Loading" max-width="300px">
          <!-- ダイアログの中身 -->
          <v-card class="center-dialog" width="300" height="270">
            <v-card-title>作成中 ・・・</v-card-title>
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
            <br><br>
            <v-card-text class="d-flex justify-center align-center" style="height: 30px;">
              しばらくお待ちください。
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <div>
        <v-dialog v-model="helpmsgdialog" :width="helpdialogWidth">
          <v-card style="position: relative;">
            <!-- 右上の×ボタン -->
            <v-btn
              icon
              color="black"
              size="x-small"
              variant="outlined"
              class="close-btn"
              @click="helpmsgdialog = false"
              style="position: absolute; top: 8px; right: 8px;"
            >
              <v-icon size="16">mdi-close</v-icon>
            </v-btn>
            <v-card-title v-if="helpmsgtitle !== ''" class="text-h6">{{ helpmsgtitle }}</v-card-title>
            <v-card-title v-if="helpmsgtitle === ''"></v-card-title>
            <v-card-text>
              <p v-html="helpmsgtext" class="vhtml-text"></p>
            </v-card-text>
            <br><br>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <div>
        <v-dialog v-model="alertmsgdialog" :width="alertdialogWidth">
          <v-card style="position: relative;">
            <!-- 右上の×ボタン -->
            <v-btn
              icon
              color="black"
              size="x-small"
              variant="outlined"
              class="close-btn"
              @click="alertmsgdialog = false"
              style="position: absolute; top: 8px; right: 8px;"
            >
              <v-icon size="16">mdi-close</v-icon>
            </v-btn>
            <v-card-title v-if="alertmsgtitle !== ''" class="text-h6">{{ alertmsgtitle }}</v-card-title>
            <v-card-title v-if="alertmsgtitle === ''"></v-card-title>
            <v-card-text>
              <p v-html="alertmsgtext" class="vhtml-text"></p>
            </v-card-text>
            <br><br>
          </v-card>
        </v-dialog>
      </div>
    </template>
</div>
</template>
<script>
import { nextTick } from 'vue'
import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
export default {
  data () {
    return {
      windowimageErrors: [],
      doorimageErrors: [],
      imageErrors: [],
      Loading: false,
      imageSelSyu: null,
      seriesdialog: false,
      seriesimages: [],
      windowseriesimages: [],
      doorseriesimages: [],
      resulttab: null,
      glassdialog: false,
      glassdialogValue: '',
      glassdialogSeq: -1,
      glassAssistdialog3: false,
      glassAssistSw: 0, // 1:窓追加時 2:変更時
      glassAssistListInit1: [],
      glassAssistListInit2: [],
      glassAssistListInit3: [],
      glassAssistListInit4: [],
      glassAssistList1: [],
      glassAssistId1: '',
      glassAssistList2: [],
      glassAssistId2: '',
      glassAssistList3: [],
      glassAssistId3: '',
      glassAssistList4: [],
      glassAssistId4: '',
      glassAssistAll: false,
      glassAssistAllId: '',
      code: '',
      selectFlg: false,
      showWindowCards: false,
      showDoorCards: false,
      // itemDisWindow: [],
      // itemDisDoor: [],
      testw: -1,
      testd: -1,
      allSeqNo: -1,
      addtab: null,
      windowMode: 'insert',
      windowModeId: -1,
      windowSpecSeriesList: [], // 変更時に使用
      windowkensu: 0,
      windowReceiveList: [],
      windowSpecSelectList: [],
      windowSpecSelectListId: '',
      windowSeriesSelectList: [],
      windowSeriesSelectListId: '',
      windowSyuSelectList: [],
      windowSyuSelectId: '',
      windowGlassSelectList: [],
      windowGlassSelectId: '',
      windowtoggle: '0',
      windowHisashitoggle: '0',
      windowResultList: [],
      windowPdf1: [],
      windowPdf2: [],
      windowOpeningFlg: '',
      deleteWindowdialog: false,
      doorMode: 'insert',
      doorModeId: -1,
      doorkensu: 0,
      doorReceiveList: [],
      doorSeriesSelectList: [],
      doorSeriesSelectListId: '',
      doorSyuSelectList: [],
      doorThermalSelectId: '', // 20260110
      doorThermalSelectList: [], // 20260110
      doorSyuSelectId: '',
      doorGlassSelectList: [],
      doorGlassSelectId: '',
      doorDesignSelectList: [],
      doorDesignSelectId: '',
      doortoggle: '0',
      doorHisashitoggle: '0',
      doorResultList: [],
      doorPdf1: [],
      doorPdf2: [],
      doorOpeningFlg: '',
      deleteDoordialog: false,
      backregiondialog: false,
      deleteIndex: -1,
      glassHenkoList: [],
      glassHenkoReceiveList: [],
      hozon_GLASS_TYPE: '',
      classtoggle: '5',
      rigionClass: '',
      rigionPattern: '',
      STANDARD_THERMAL_TRANS: 0,
      STANDARD_SOLARHEAT: 0,
      STANDARD_SOLARHEAT_DIS: '',
      WINDOW_STANDARD4_THERMAL_TRANS: 0,
      WINDOW_STANDARD4_THERMAL_TRANS_DIS_KIJUNN: '',
      WINDOW_STANDARD4_SOLARHEAT: 0,
      WINDOW_STANDARD4_SOLARHEAT_DIS: '',
      WINDOW_STANDARD4_SOLARHEAT_DIS_KIJUNN: '',
      WINDOW_STANDARD5_THERMAL_TRANS: 0,
      WINDOW_STANDARD5_THERMAL_TRANS_DIS_KIJUNN: '',
      WINDOW_STANDARD5_SOLARHEAT: 0,
      WINDOW_STANDARD5_SOLARHEAT_DIS: '',
      WINDOW_STANDARD5_SOLARHEAT_DIS_KIJUNN: '',
      // DOOR
      DOOR_STANDARD4_THERMAL_TRANS: 0,
      DOOR_STANDARD4_THERMAL_TRANS_DIS_KIJUNN: '',
      DOOR_STANDARD4_SOLARHEAT: 0,
      DOOR_STANDARD4_SOLARHEAT_DIS: '',
      DOOR_STANDARD4_SOLARHEAT_DIS_KIJUNN: '',
      DOOR_STANDARD5_THERMAL_TRANS: 0,
      DOOR_STANDARD5_THERMAL_TRANS_DIS_KIJUNN: '',
      DOOR_STANDARD5_SOLARHEAT: 0,
      DOOR_STANDARD5_SOLARHEAT_DIS: '',
      DOOR_STANDARD5_SOLARHEAT_DIS_KIJUNN: '',
      RESULT_THERMAL_TRANS: 0,
      RESULT_SOLARHEAT: 0,
      RESULT_SOLARHEAT_DIS: '',
      FINAL_THERMAL_TRANS: '',
      FINAL_SOLARHEAT: '',
      resultSeq: 0,
      resultWindowList: [],
      resultDoorList: [],
      showWindowCardsResult: false,
      showDoorCardsResult: false,
      hanteiMethodList: [],
      hanteiMethod: null,
      resultDisplay: {},
      hisashitext: '',
      buzaitext: '',
      kaikoubutext: '',
      resulttext: '',
      glasstext: '',
      // rigiontexttype: '',
      // rigiontextall: '',
      helpmsgtext: '',
      helpmsgtitle: '',
      helpdialogWidth: '700',
      helpmsgdialog: false,
      assistantGlassSelectList: [], // 20260117
      alertmsgtext: '',
      alertmsgtitle: '',
      alertdialogWidth: '700',
      alertmsgdialog: false,
      copyWindowMode: '', // 20260127 入力画面のリストを再作成する否か用
      copyDoorMode: '', // 20260127 入力画面のリストを再作成する否か用
      countWindow: 0, // 20260203
      countDoor: 0, // 20260203
      countWindowMax: 30, // 20260203
      countDoorMax: 10, // 20260203
      windowcountmsg: '', // 20260205
      doorcountmsg: '', // 20260205
      urlAddress1: '',
      urlAddressbikou: '',
      inputSW: 0, // 20260207 20260311 W->W D->W W->D D->Dに戻す。
      inputSeq: 0 // 20260207
    }
  },
  mounted () {
    // alert('products')
    const auth = useAuthStore()
    auth.setBsw('0') // 戻るボタン制御用
    if (auth.token !== 'ok') {
      auth.setBsw('1') // 戻るボタン制御用
      this.$router.push('/')
    }
    if (auth.acceptflg !== '1') {
      auth.setBsw('1') // 戻るボタン制御用
      this.$router.push('/')
    }
    this.rigionClass = auth.region
    this.rigionPattern = '1'
    if (this.rigionClass === '8') {
      this.rigionPattern = '3'
    }
    if (this.rigionClass === '5' || this.rigionClass === '6' || this.rigionClass === '7') {
      this.rigionPattern = '2'
    }
    this.standard45GetWindow(this.rigionClass, 0)
    this.standard45GetDoor(this.rigionClass)
    // alert('地域' + this.rigionClass)
    this.windowResultList = []
    this.doorResultList = []
    let wwk = {}
    this.hanteiMethodList = []
    wwk = {}
    wwk.value = 'MAX'
    wwk.title = '「建具とガラスの組み合わせ」と「自己適合宣言書・附属書」のうち性能値が高い方で適否確認を行います'
    this.hanteiMethodList.push(wwk)
    wwk = {}
    wwk.value = 'TYPE'
    wwk.title = '「建具とガラスの組み合わせ」で適否確認を行います'
    this.hanteiMethodList.push(wwk)
    this.hanteiMethod = 'MAX'
    // 部材/ひさし初期化 リージョンにより表示の有無が変わるため初期化する
    this.windowtoggle = '0'
    this.windowHisashitoggle = '0'
    this.doortoggle = '0'
    this.doorHisashitoggle = '0'
    this.inputSeq = 0 // 20260207
    this.startFnc()
  },
  methods: {
    async startFnc () {
      // alert('startDisplay region')
      const auth = useAuthStore()
      axios.post('/api/productsinit', {
        argtoken: auth.token,
        argrigion: this.rigionPattern,
        argacceptflg: auth.acceptflg
      })
        .then(response => {
          this.results = response.data
          if (this.results.status === 'NG') {
            alert('error ' + this.results.message)
            auth.setBsw('1') // 戻るボタン制御用
            this.$router.push('/about')
          } else {
            this.hisashitext = this.results.hisashitext
            this.buzaitext = this.results.buzaitext
            this.kaikoubutext = this.results.kaikoubutext
            this.resulttext = this.results.resulttext
            this.glasstext = this.results.glasstext
            // this.rigiontexttype = this.results.rigiontexttype
            // this.rigiontextall = this.results.rigiontextall
            this.windowcountmsg = this.results.windowcountmsg // 20260205
            this.doorcountmsg = this.results.doorcountmsg // 20260205
            this.windowSpecSelectList = []
            let wkll = {}
            for (let cx = 0; cx < this.results.datawindowspec.length; cx++) {
              wkll = {}
              wkll.title = this.results.datawindowspec[cx].SPEC
              wkll.value = this.results.datawindowspec[cx].SPEC
              this.windowSpecSelectList.push(wkll)
            }
            this.windowSpecSeriesList = JSON.parse(JSON.stringify(this.results.datawindowspecserie))
            this.urlAddress1 = JSON.parse(this.results.urltext)
            this.urlAddressbikou = JSON.parse(this.results.urltextbikou)
            // alert(JSON.stringify(this.urlAddressbikou['開口部の熱貫流率と日射熱取得率（玄関ドア・引戸）']))
            /*
            this.windowSeriesSelectList = []
            let wkll = {}
            for (let cx = 0; cx < this.results.datawindow.length; cx++) {
              wkll = {}
              wkll.title = this.results.datawindow[cx].SERIES
              wkll.value = this.results.datawindow[cx].SERIES
              this.windowSeriesSelectList.push(wkll)
            }
              */
            this.doorSeriesSelectList = []
            for (let cy = 0; cy < this.results.datadoor.length; cy++) {
              wkll = {}
              wkll.title = this.results.datadoor[cy].SERIES2
              wkll.value = this.results.datadoor[cy].SERIES2
              this.doorSeriesSelectList.push(wkll)
            }
          }
        })
        .catch(error => {
          // this.dialogsw = false
          auth.setBsw('1') // 戻るボタン制御用
          alert('error  ' + error)
          this.$router.push('/about')
        })
    },
    async windowSpecChange () {
      // alert('windowSeriesChange')
      const auth = useAuthStore()
      axios.post('/api/windowspecchange', {
        argselectid: this.windowSpecSelectListId,
        argtoken: auth.token,
        argacceptflg: auth.acceptflg
      })
        .then(response => {
          this.results = response.data
          if (this.results.status === 'NG') {
            alert('error ' + this.results.message)
            auth.setBsw('1') // 戻るボタン制御用
            this.$router.push('/about')
          } else {
            this.windowSeriesSelectList = []
            let wkll = {}
            for (let cx = 0; cx < this.results.datawindow.length; cx++) {
              wkll = {}
              wkll.title = this.results.datawindow[cx].SERIES
              wkll.value = this.results.datawindow[cx].SERIES
              this.windowSeriesSelectList.push(wkll)
            }
            window.document.getElementById('WINDOW').style.display = ''
            window.document.getElementById('MAIN').style.display = 'none'
            window.document.getElementById('WINDOWSTART').style.display = 'none'
            window.document.getElementById('WINDOW0').style.display = ''
            window.document.getElementById('WINDOW1').style.display = 'none'
            window.document.getElementById('WINDOW2').style.display = 'none'
            this.windowSeriesSelectListId = ''
            this.windowSyuSelectId = ''
            this.windowGlassSelectId = ''
          }
        })
        .catch(error => {
          // this.dialogsw = false
          auth.setBsw('1') // 戻るボタン制御用
          alert('error  ' + error)
          this.$router.push('/about')
        })
    },
    async windowSeriesChange () {
      // alert('windowSeriesChange')
      const auth = useAuthStore()
      axios.post('/api/windowserieschange', {
        argselectid: this.windowSeriesSelectListId,
        argtoken: auth.token,
        argacceptflg: auth.acceptflg
      })
        .then(response => {
          this.results = response.data
          if (this.results.status === 'NG') {
            alert('error ' + this.results.message)
            auth.setBsw('1') // 戻るボタン制御用
            this.$router.push('/about')
          } else {
            this.windowReceiveList = JSON.parse(JSON.stringify(this.results.datawindow))
            const wklist = []
            for (let i = 0; i < this.windowReceiveList.length; i++) {
              wklist.push(this.windowReceiveList[i].WINDOW_TYPE)
            }
            const wklistDis = wklist.filter((value, index, self) => self.indexOf(value) === index)
            this.windowSyuSelectList = []
            let wkll = {}
            for (let i = 0; i < wklistDis.length; i++) {
              wkll = {}
              wkll.title = wklistDis[i]
              wkll.value = wklistDis[i]
              this.windowSyuSelectList.push(wkll)
            }
            this.windowseriesimages = []
            this.windowimageErrors = []
            let wwk = {}
            for (let i = 0; i < this.windowSyuSelectList.length; i++) {
              for (let j = 0; j < this.windowReceiveList.length; j++) {
                if (this.windowSyuSelectList[i].value === this.windowReceiveList[j].WINDOW_TYPE) {
                  wwk = {}
                  // alert(this.windowReceiveList[j].IMAGE)
                  wwk.item = './images/WINDOW/' + this.windowReceiveList[j].IMAGE + '.jpg'
                  // wwk.description = this.windowReceiveList[j].WINDOW_TYPE
                  // wwk.description = '説明: tooltip テスト'
                  wwk.description = '' // 20260217
                  wwk.value = this.windowReceiveList[j].WINDOW_TYPE
                  this.windowseriesimages.push(wwk)
                  break
                }
              }
            }
            // window.document.getElementById('WINDOW').style.display = ''
            // window.document.getElementById('MAIN').style.display = 'none'
            // window.document.getElementById('WINDOWSTART').style.display = 'none'
            if (this.windowseriesimages.length === 1) {
              this.windowSyuSelectId = this.windowseriesimages[0].value
              window.document.getElementById('WINDOW1').style.display = ''
              window.document.getElementById('WINDOW2').style.display = ''
              this.windowSyuChange()
            } else {
              window.document.getElementById('WINDOW1').style.display = ''
              window.document.getElementById('WINDOW2').style.display = 'none'
              this.windowSyuSelectId = ''
              this.windowGlassSelectId = ''
            }
          }
        })
        .catch(error => {
          // this.dialogsw = false
          auth.setBsw('1') // 戻るボタン制御用
          alert('error  ' + error)
          this.$router.push('/about')
        })
    },
    windowSyuChange () {
      if (this.windowSyuSelectId === '') {
        return
      }
      this.windowGlassSelectList = []
      this.assistantGlassSelectList = [] // 20260126
      let wkll = {}
      let exsw = 0
      const wkaslist1 = []
      const wkaslist2 = []
      const wkaslist3 = []
      const wkaslist4 = []
      let wkaslist = []
      this.windowOpeningFlg = 'door'
      for (let i = 0; i < this.windowReceiveList.length; i++) {
        if (this.windowReceiveList[i].WINDOW_TYPE === this.windowSyuSelectId) {
          wkll = {}
          wkll.title = this.windowReceiveList[i].GLASS_TYPE
          wkll.value = this.windowReceiveList[i].ID
          // alert(JSON.stringify(wkll))
          this.windowGlassSelectList.push(wkll)
          this.assistantGlassSelectList.push(wkll) // 20260126
          if (this.windowReceiveList[i].GLASS_TYPE === this.hozon_GLASS_TYPE) {
            exsw = this.windowReceiveList[i].ID
          }
          wkaslist = this.windowReceiveList[i].GLASS_TYPE.split('/')
          wkaslist1.push(wkaslist[0])
          wkaslist2.push(wkaslist[1])
          wkaslist3.push(wkaslist[2])
          wkaslist4.push(wkaslist[3])
          // wklist1.push(this.windowReceiveList[i].GLASS_TYPE)
          // alert(wkaslist[1])
          if (this.windowReceiveList[i].OPNING === '窓') {
            this.windowOpeningFlg = 'window'
          }
        }
      }
      this.glassAssistInit(wkaslist1, wkaslist2, wkaslist3, wkaslist4) // 20260117
      // 開口部が窓でもドアでもSyuChangeで部材/ひさしをクリア
      this.windowtoggle = '0'
      this.windowHisashitoggle = '0'
      window.document.getElementById('WINDOW2').style.display = ''
      if (exsw === 0) {
        this.windowGlassSelectId = ''
      } else {
        // this.windowGlassSelectId = this.hozon_GLASS_TYPE // 20260208
        this.windowGlassSelectId = '' // 20260209
      }
    },
    glassAssistInit (wkaslist1, wkaslist2, wkaslist3, wkaslist4) {
      // ガラスアシストの作成
      let wkll = {}
      this.glassAssistAll = false
      this.glassAssistList1 = wkaslist1.filter((value, index, self) => self.indexOf(value) === index)
      this.glassAssistList2 = wkaslist2.filter((value, index, self) => self.indexOf(value) === index)
      this.glassAssistList3 = wkaslist3.filter((value, index, self) => self.indexOf(value) === index)
      this.glassAssistList4 = wkaslist4.filter((value, index, self) => self.indexOf(value) === index)
      this.glassAssistListInit1 = []
      this.glassAssistListInit2 = []
      this.glassAssistListInit3 = []
      this.glassAssistListInit4 = []
      for (let i = 0; i < this.glassAssistList1.length; i++) {
        wkll = {}
        wkll.title = this.glassAssistList1[i]
        wkll.value = this.glassAssistList1[i]
        wkll.disable = false
        this.glassAssistListInit1.push(wkll)
      }
      for (let i = 0; i < this.glassAssistList2.length; i++) {
        wkll = {}
        wkll.title = this.glassAssistList2[i]
        wkll.value = this.glassAssistList2[i]
        wkll.disable = false
        this.glassAssistListInit2.push(wkll)
        // alert(this.glassAssistList2[i])
      }
      for (let i = 0; i < this.glassAssistList3.length; i++) {
        wkll = {}
        wkll.title = this.glassAssistList3[i]
        wkll.value = this.glassAssistList3[i]
        wkll.disable = false
        this.glassAssistListInit3.push(wkll)
      }
      for (let i = 0; i < this.glassAssistList4.length; i++) {
        wkll = {}
        wkll.title = this.glassAssistList4[i]
        wkll.value = this.glassAssistList4[i]
        wkll.disable = false
        this.glassAssistListInit4.push(wkll)
      }
    },
    glassAssistChange (x1) {
      let wkaslist = []
      let sw1 = 0
      let sw2 = 0
      let sw3 = 0
      let sw4 = 0
      this.glassHenkoList = []
      this.glassAssistAllId = ''
      const wkaslist1 = []
      const wkaslist2 = []
      const wkaslist3 = []
      const wkaslist4 = []
      let wkaslistx = []
      let wkll = {}
      for (let i = 0; i < this.assistantGlassSelectList.length; i++) { // 20260117
        wkaslist = this.assistantGlassSelectList[i].title.split('/') // 20260117
        sw1 = 1
        sw2 = 1
        sw3 = 1
        sw4 = 1
        if (this.glassAssistId1 !== '') {
          if (wkaslist[0] !== this.glassAssistId1) {
            sw1 = 0
          }
        }
        if (this.glassAssistId2 !== '') {
          if (wkaslist[1] !== this.glassAssistId2) {
            sw2 = 0
          }
        }
        if (this.glassAssistId3 !== '') {
          if (wkaslist[2] !== this.glassAssistId3) {
            sw3 = 0
          }
        }
        if (this.glassAssistId4 !== '') {
          if (wkaslist[3] !== this.glassAssistId4) {
            sw4 = 0
          }
        }
        if (sw1 === 1 && sw2 === 1 && sw3 === 1 && sw4 === 1) {
          wkll = {}
          wkll.title = this.assistantGlassSelectList[i].title // 20260117
          wkll.value = this.assistantGlassSelectList[i].value // 20260117
          this.glassHenkoList.push(wkll)
          this.glassAssistAllId = wkll.value
          wkaslistx = this.assistantGlassSelectList[i].title.split('/') // 20260117
          wkaslist1.push(wkaslistx[0])
          wkaslist2.push(wkaslistx[1])
          wkaslist3.push(wkaslistx[2])
          wkaslist4.push(wkaslistx[3])
        }
      }
      // ガラスアシストの作成
      this.glassAssistList1 = wkaslist1.filter((value, index, self) => self.indexOf(value) === index)
      this.glassAssistList2 = wkaslist2.filter((value, index, self) => self.indexOf(value) === index)
      this.glassAssistList3 = wkaslist3.filter((value, index, self) => self.indexOf(value) === index)
      this.glassAssistList4 = wkaslist4.filter((value, index, self) => self.indexOf(value) === index)
    },
    glassAssistChange2 (x1, valuex) {
      // 対象が0件だった場合、選択した条件のみでリストをつくる。
      // 選択した条件以外の条件がリスト内に存在するかチェック
      // 存在していなければ条件をクリア
      if (x1 === 1) {
        this.glassAssistId1 = valuex
      }
      if (x1 === 2) {
        this.glassAssistId2 = valuex
      }
      if (x1 === 3) {
        this.glassAssistId3 = valuex
      }
      if (x1 === 4) {
        this.glassAssistId4 = valuex
      }
      let wkaslist = []
      let sw1 = 0
      let sw2 = 0
      let sw3 = 0
      let sw4 = 0
      this.glassHenkoList = []
      this.glassAssistAllId = ''
      const wkaslist1 = []
      const wkaslist2 = []
      const wkaslist3 = []
      const wkaslist4 = []
      let wkaslistx = []
      let wkll = {}
      // 対象が0件だった場合、選択した条件のみでリストをつくる。
      let glassSaveId1 = ''
      let glassSaveId2 = ''
      let glassSaveId3 = ''
      let glassSaveId4 = ''
      const wkHenkoList = []
      const wkhokan1 = []
      const wkhokan2 = []
      const wkhokan3 = []
      const wkhokan4 = []
      if (x1 === 1) {
        glassSaveId1 = valuex
      }
      if (x1 === 2) {
        glassSaveId2 = valuex
      }
      if (x1 === 3) {
        glassSaveId3 = valuex
      }
      if (x1 === 4) {
        glassSaveId4 = valuex
      }
      for (let i = 0; i < this.windowGlassSelectList.length; i++) {
        wkaslist = this.windowGlassSelectList[i].title.split('/')
        sw1 = 1
        sw2 = 1
        sw3 = 1
        sw4 = 1
        if (glassSaveId1 !== '') {
          if (wkaslist[0] !== glassSaveId1) {
            sw1 = 0
          }
        }
        if (glassSaveId2 !== '') {
          if (wkaslist[1] !== glassSaveId2) {
            sw2 = 0
          }
        }
        if (glassSaveId3 !== '') {
          if (wkaslist[2] !== glassSaveId3) {
            sw3 = 0
          }
        }
        if (glassSaveId4 !== '') {
          if (wkaslist[3] !== glassSaveId4) {
            sw4 = 0
          }
        }
        if (sw1 === 1 && sw2 === 1 && sw3 === 1 && sw4 === 1) {
          wkll = {}
          wkll.title = this.windowGlassSelectList[i].title
          wkll.value = this.windowGlassSelectList[i].value
          wkHenkoList.push(wkll)
          wkaslistx = this.windowGlassSelectList[i].title.split('/')
          wkhokan1.push(wkaslistx[0])
          wkhokan2.push(wkaslistx[1])
          wkhokan3.push(wkaslistx[2])
          wkhokan4.push(wkaslistx[3])
        }
      }
      // this.glassAssistIdXがwkhokanXに存在しているかチェック
      // 存在していなければthis.glassAssistIdXをクリア
      // 1
      let exitSw = 0
      for (let i = 0; i < wkhokan1.length; i++) {
        if (wkhokan1[i] === this.glassAssistId1) {
          exitSw = 1
        }
      }
      if (exitSw === 0) {
        this.glassAssistId1 = ''
      }
      // 2
      exitSw = 0
      for (let i = 0; i < wkhokan2.length; i++) {
        if (wkhokan2[i] === this.glassAssistId2) {
          exitSw = 1
        }
      }
      if (exitSw === 0) {
        this.glassAssistId2 = ''
      }
      // 3
      exitSw = 0
      for (let i = 0; i < wkhokan3.length; i++) {
        if (wkhokan3[i] === this.glassAssistId3) {
          exitSw = 1
        }
      }
      if (exitSw === 0) {
        this.glassAssistId3 = ''
      }
      // 4
      exitSw = 0
      for (let i = 0; i < wkhokan4.length; i++) {
        if (wkhokan4[i] === this.glassAssistId4) {
          exitSw = 1
        }
      }
      if (exitSw === 0) {
        this.glassAssistId4 = ''
      }
      // 通常処理
      // alert(2)
      for (let i = 0; i < this.windowGlassSelectList.length; i++) {
        wkaslist = this.windowGlassSelectList[i].title.split('/')
        sw1 = 1
        sw2 = 1
        sw3 = 1
        sw4 = 1
        if (this.glassAssistId1 !== '') {
          if (wkaslist[0] !== this.glassAssistId1) {
            sw1 = 0
          }
        }
        if (this.glassAssistId2 !== '') {
          if (wkaslist[1] !== this.glassAssistId2) {
            sw2 = 0
          }
        }
        if (this.glassAssistId3 !== '') {
          if (wkaslist[2] !== this.glassAssistId3) {
            sw3 = 0
          }
        }
        if (this.glassAssistId4 !== '') {
          if (wkaslist[3] !== this.glassAssistId4) {
            sw4 = 0
          }
        }
        if (sw1 === 1 && sw2 === 1 && sw3 === 1 && sw4 === 1) {
          // alert(3)
          wkll = {}
          wkll.title = this.windowGlassSelectList[i].title
          wkll.value = this.windowGlassSelectList[i].value
          this.glassHenkoList.push(wkll)
          this.glassAssistAllId = wkll.value
          wkaslistx = this.windowGlassSelectList[i].title.split('/')
          wkaslist1.push(wkaslistx[0])
          wkaslist2.push(wkaslistx[1])
          wkaslist3.push(wkaslistx[2])
          wkaslist4.push(wkaslistx[3])
        }
      }
      // ガラスアシストの作成
      this.glassAssistList1 = wkaslist1.filter((value, index, self) => self.indexOf(value) === index)
      this.glassAssistList2 = wkaslist2.filter((value, index, self) => self.indexOf(value) === index)
      this.glassAssistList3 = wkaslist3.filter((value, index, self) => self.indexOf(value) === index)
      this.glassAssistList4 = wkaslist4.filter((value, index, self) => self.indexOf(value) === index)
      for (let i = 0; i < this.glassAssistListInit1.length; i++) {
        this.glassAssistListInit1[i].disable = true
        for (let j = 0; j < this.glassAssistList1.length; j++) {
          if (this.glassAssistListInit1[i].value === this.glassAssistList1[j]) {
            this.glassAssistListInit1[i].disable = false
            break
          }
        }
      }
      for (let i = 0; i < this.glassAssistListInit2.length; i++) {
        this.glassAssistListInit2[i].disable = true
        for (let j = 0; j < this.glassAssistList2.length; j++) {
          if (this.glassAssistListInit2[i].value === this.glassAssistList2[j]) {
            this.glassAssistListInit2[i].disable = false
            break
          }
        }
      }
      for (let i = 0; i < this.glassAssistListInit3.length; i++) {
        this.glassAssistListInit3[i].disable = true
        for (let j = 0; j < this.glassAssistList3.length; j++) {
          if (this.glassAssistListInit3[i].value === this.glassAssistList3[j]) {
            this.glassAssistListInit3[i].disable = false
            break
          }
        }
      }
      for (let i = 0; i < this.glassAssistListInit4.length; i++) {
        this.glassAssistListInit4[i].disable = true
        for (let j = 0; j < this.glassAssistList4.length; j++) {
          if (this.glassAssistListInit4[i].value === this.glassAssistList4[j]) {
            this.glassAssistListInit4[i].disable = false
            break
          }
        }
      }
      this.glassAssistAll = true
      if (this.glassAssistId1 === '') {
        this.glassAssistAll = false
      }
      if (this.glassAssistId2 === '') {
        this.glassAssistAll = false
      }
      if (this.glassAssistId3 === '') {
        this.glassAssistAll = false
      }
      if (this.glassAssistId4 === '') {
        this.glassAssistAll = false
      }
    },
    async henkouWindowListSet (ix) {
      // alert(0)
      this.windowSpecSelectListId = this.windowResultList[ix].SPEC
      // Seriesリスト作成
      this.windowSeriesSelectList = []
      let wkll = {}
      for (let i = 0; i < this.windowSpecSeriesList.length; i++) {
        if (this.windowSpecSeriesList[i].SPEC === this.windowSpecSelectListId) {
          wkll = {}
          wkll.title = this.windowSpecSeriesList[i].SERIES
          wkll.value = this.windowSpecSeriesList[i].SERIES
          this.windowSeriesSelectList.push(wkll)
        }
      }
      // シリーズchange
      // alert(1)
      this.windowSeriesSelectListId = this.windowResultList[ix].SERIES
      const auth = useAuthStore()
      axios.post('/api/windowserieschange', {
        argselectid: this.windowSeriesSelectListId,
        argtoken: auth.token,
        argacceptflg: auth.acceptflg
      })
        .then(async response => {
          this.results = response.data
          if (this.results.status === 'NG') {
            alert('error ' + this.results.message)
            auth.setBsw('1') // 戻るボタン制御用
            this.$router.push('/about')
          } else {
            // alert(2)
            this.windowReceiveList = JSON.parse(JSON.stringify(this.results.datawindow))
            const wklist = []
            for (let i = 0; i < this.windowReceiveList.length; i++) {
              wklist.push(this.windowReceiveList[i].WINDOW_TYPE)
            }
            const wklistDis = wklist.filter((value, index, self) => self.indexOf(value) === index)
            this.windowSyuSelectList = []
            let wkll = {}
            for (let i = 0; i < wklistDis.length; i++) {
              wkll = {}
              wkll.title = wklistDis[i]
              wkll.value = wklistDis[i]
              this.windowSyuSelectList.push(wkll)
            }
            this.windowseriesimages = []
            this.windowimageErrors = []
            await nextTick()
            let wwk = {}
            for (let i = 0; i < this.windowSyuSelectList.length; i++) {
              for (let j = 0; j < this.windowReceiveList.length; j++) {
                if (this.windowSyuSelectList[i].value === this.windowReceiveList[j].WINDOW_TYPE) {
                  wwk = {}
                  // alert(this.windowReceiveList[j].IMAGE)
                  wwk.item = './images/WINDOW/' + this.windowReceiveList[j].IMAGE + '.jpg'
                  // wwk.description = this.windowReceiveList[j].WINDOW_TYPE
                  // wwk.description = '説明: tooltip テスト'
                  wwk.description = '' // 20260217
                  wwk.value = this.windowReceiveList[j].WINDOW_TYPE
                  this.windowseriesimages.push(wwk)
                  break
                }
              }
            }
            this.windowSyuSelectId = this.windowResultList[ix].WINDOW_TYPE
            this.windowGlassSelectList = []
            this.assistantGlassSelectList = [] // 20260126
            wkll = {}
            const wkaslist1 = []
            const wkaslist2 = []
            const wkaslist3 = []
            const wkaslist4 = []
            let wkaslist = []
            this.windowOpeningFlg = 'door'
            for (let i = 0; i < this.windowReceiveList.length; i++) {
              if (this.windowReceiveList[i].WINDOW_TYPE === this.windowSyuSelectId) {
                wkll = {}
                wkll.title = this.windowReceiveList[i].GLASS_TYPE
                wkll.value = this.windowReceiveList[i].ID
                // alert(JSON.stringify(wkll))
                this.windowGlassSelectList.push(wkll)
                this.assistantGlassSelectList.push(wkll) // 20260126
                wkaslist = this.windowReceiveList[i].GLASS_TYPE.split('/')
                wkaslist1.push(wkaslist[0])
                wkaslist2.push(wkaslist[1])
                wkaslist3.push(wkaslist[2])
                wkaslist4.push(wkaslist[3])
                // wklist1.push(this.windowReceiveList[i].GLASS_TYPE)
                if (this.windowReceiveList[i].OPNING === '窓') {
                  this.windowOpeningFlg = 'window'
                }
              }
            }
            // alert(9)
            this.glassAssistInit(wkaslist1, wkaslist2, wkaslist3, wkaslist4) // 20260117
            this.windowGlassSelectId = this.windowResultList[ix].ID
            this.windowtoggle = this.windowResultList[ix].BUZAI
            this.windowHisashitoggle = this.windowResultList[ix].HISASHI
            // 20260203
            this.glassSelectDis()
            await nextTick()
            window.document.getElementById('MAIN').style.display = 'none'
            window.document.getElementById('WINDOW').style.display = ''
            window.document.getElementById('WINDOW0').style.display = ''
            window.document.getElementById('WINDOW1').style.display = ''
            window.document.getElementById('WINDOW2').style.display = ''
          }
        })
        .catch(error => {
          // this.dialogsw = false
          auth.setBsw('1') // 戻るボタン制御用
          alert('error  ' + error)
          this.$router.push('/about')
        })
    },
    henkouWindowDis (ix) {
      this.windowMode = 'update'
      this.windowModeId = ix
      this.hozon_GLASS_TYPE = this.windowResultList[ix].GLASS_TYPE // おなじガラスタイプの判断用
      this.henkouWindowListSet(ix)
    },
    henkouWindow () {
      const ix = this.windowModeId
      // this.windowResultList[ix].SPEC = this.windowSpecSelectListId
      // this.windowResultList[ix].SERIES = this.windowSeriesSelectListId
      // this.windowResultList[ix].WINDOW_TYPE = this.windowSyuSelectId
      // this.windowResultList[ix].ID = this.windowGlassSelectId
      // this.windowResultList[ix].BUZAI = this.windowtoggle
      // this.windowResultList[ix].HISASHI = this.windowHisashitoggle
      // alert(91)
      this.countWindowDoor('W', ix)
      for (let i = 0; i < this.windowReceiveList.length; i++) {
        if (this.windowReceiveList[i].ID === this.windowGlassSelectId) {
          const nowOpnig = this.windowReceiveList[i].OPNING
          if (this.countWindow >= this.countWindowMax && nowOpnig === '窓') {
            this.countWindowAlert(this.countWindow)
            return
          }
          if (this.countDoor >= this.countDoorMax && nowOpnig === 'ドア') {
            this.countDoorAlert(this.countDoor)
            return
          }
          const resultwk = this.windowMisaiSet(this.windowReceiveList[i])
          const wkinputseq = this.windowResultList[ix].INPUTSEQ // 20260207
          this.windowResultList[ix] = JSON.parse(JSON.stringify(resultwk))
          this.windowResultList[ix].INPUTSEQ = wkinputseq // 20260207
          this.hozon_GLASS_TYPE = this.windowReceiveList[i].GLASS_TYPE // おなじガラスタイプの判断用
        }
      }
      // alert(92)
      this.windowPdfGet()
      // alert(93)
      this.selectFlgSet()
      this.showWindowCards = true
      window.document.getElementById('MAIN').style.display = ''
      window.document.getElementById('WINDOW').style.display = 'none'
      // window.document.getElementById('WINDOW1').style.display = 'none'
      // window.document.getElementById('WINDOW2').style.display = 'none'
      window.document.getElementById('DOOR').style.display = 'none'
    },
    addWindowDis () {
      if (this.copyWindowMode === 'copy') {
        const ix = this.windowResultList.length - 1
        this.henkouWindowListSet(ix)
      }
      this.glassSelectDis()
      this.windowMode = 'insert'
      window.document.getElementById('MAIN').style.display = 'none'
      window.document.getElementById('WINDOW').style.display = ''
      this.copyWindowMode = ''
    },
    async addWindow () {
      this.countWindowDoor('', 0)
      this.testw += 1
      this.allSeqNo += 1 // 20251212
      for (let i = 0; i < this.windowReceiveList.length; i++) {
        if (this.windowReceiveList[i].ID === this.windowGlassSelectId) {
          const nowOpnig = this.windowReceiveList[i].OPNING
          if (this.countWindow >= this.countWindowMax && nowOpnig === '窓') {
            this.countWindowAlert(this.countWindow)
            return
          }
          if (this.countDoor >= this.countDoorMax && nowOpnig === 'ドア') {
            this.countDoorAlert(this.countDoor)
            return
          }
          const resultwk = this.windowMisaiSet(this.windowReceiveList[i])
          // alert('2 ' + this.windowReceiveList[i].PDF_TYPE1)
          this.windowResultList.push(resultwk)
          this.inputSeq += 1 // 20260207
          this.windowResultList[this.windowResultList.length - 1].INPUTSEQ = this.inputSeq // 20260207
          this.hozon_GLASS_TYPE = this.windowReceiveList[i].GLASS_TYPE // おなじガラスタイプの判断用
          break
        }
        this.windowkensu = this.windowResultList.length
      }
      this.windowPdfGet()
      this.selectFlgSet()
      this.showWindowCards = true
      window.document.getElementById('MAIN').style.display = ''
      window.document.getElementById('WINDOW').style.display = 'none'
      // window.document.getElementById('WINDOW1').style.display = 'none'
      // window.document.getElementById('WINDOW2').style.display = 'none'
      window.document.getElementById('DOOR').style.display = 'none'
      // window.document.getElementById('DOOR1').style.display = 'none'
      // window.document.getElementById('DOOR2').style.display = 'none'
      await nextTick()
      const container = document.querySelector('.card-container-w-pro')
      if (container) {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth'
        })
      }
    },
    windowMisaiSet (dataObject) {
      const resultwk = {}
      resultwk.ALLSEQ = this.allSeqNo // 20251212
      resultwk.ID = dataObject.ID
      resultwk.SPEC = dataObject.SPEC
      resultwk.SERIES = dataObject.SERIES
      resultwk.GLASS_TYPE = dataObject.GLASS_TYPE
      resultwk.WINDOW_TYPE = dataObject.WINDOW_TYPE
      resultwk.OPNING = dataObject.OPNING
      resultwk.THERMAL_TRANS_EXAM = dataObject.THERMAL_TRANS_EXAM // 熱貫流率代表試験体
      resultwk.THERMAL_TRANS_TYPE = dataObject.THERMAL_TRANS_TYPE // 熱貫流率仕様
      resultwk.SOLARHEAT_EXAM = dataObject.SOLARHEAT_EXAM
      resultwk.SOLARHEAT_TYPE0 = dataObject.SOLARHEAT_TYPE0
      resultwk.SOLARHEAT_TYPE1 = dataObject.SOLARHEAT_TYPE1
      resultwk.SOLARHEAT_TYPE2 = dataObject.SOLARHEAT_TYPE2
      resultwk.SELF_DECLRATION_NO = dataObject.SELF_DECLRATION_NO
      resultwk.SELF_DECLRATION_ID = dataObject.SELF_DECLRATION_ID
      resultwk.SELF_DECLRATION = dataObject.SELF_DECLRATION
      // 表示・計算エリア
      resultwk.BUZAI = this.windowtoggle
      resultwk.BUZAI_NM = '有効な付属部材：なし'
      resultwk.HISASHI = this.windowHisashitoggle
      resultwk.HISASHI_NM = '有効なひさし、軒等：なし'
      resultwk.DIS_THERMAL_TRANS_EXAM = ''
      resultwk.DIS_THERMAL_TRANS_TYPE = ''
      resultwk.DIS_SOLARHEAT_EXAM = ''
      resultwk.DIS_SOLARHEAT_TYPE0 = ''
      resultwk.DIS_SOLARHEAT_TYPE1 = ''
      resultwk.DIS_SOLARHEAT_TYPE2 = ''
      resultwk.DIS_SOLARHEAT = 0
      resultwk.CAL_THERMAL_TRANS_EXAM = 0
      resultwk.CAL_THERMAL_TRANS_TYPE = 0
      resultwk.CAL_THERMAL_TRANS = 0
      resultwk.CAL_SOLARHEAT = 0
      resultwk.HAN_THERMAL_TRANS = '' // 判定エリア
      resultwk.HAN_SOLARHEAT = '' // 判定エリア
      // 個別判定
      resultwk.THERMAL_TRANS_HANTEI_FLG = '' // 熱貫流率仕様・試験判定フラグ どちらを使ったか
      resultwk.THERMAL_TRANS_HANTEI_4 = '' // 熱貫流率判定結果 等級4
      resultwk.THERMAL_TRANS_HANTEI_5 = '' // 熱貫流率判定結果 等級5
      resultwk.SOLARHEAT_HANTEI_FLG = '' // 日射仕様・試験判定フラグ どちらを使ったか
      resultwk.SOLARHEAT_HANTEI_4 = '' // 日射判定結果 等級4
      resultwk.SOLARHEAT_HANTEI_5 = '' // 日射判定結果 等級5
      resultwk.EXAM_THERMAL_TRANS = '' // 20251212
      resultwk.TYPE_THERMAL_TRANS = '' // 20251212
      resultwk.EXAM_SOLARHEAT = '' // 20251212
      resultwk.TYPE_SOLARHEAT = '' // 20251212
      resultwk.EXAM_HANTEI_4 = '' // EXAM判定結果 等級4 20251212
      resultwk.EXAM_HANTEI_5 = '' // EXAM判定結果 等級5 20251212
      resultwk.TYPE_HANTEI_4 = '' // TYPE判定結果 等級4 20251212
      resultwk.TYPE_HANTEI_5 = '' // TYPE判定結果 等級5 20251212
      // 窓
      // alert('w1')
      if (Number.isNaN(Number(dataObject.THERMAL_TRANS_EXAM))) {
        resultwk.DIS_THERMAL_TRANS_EXAM = dataObject.THERMAL_TRANS_EXAM
        resultwk.EXAM_THERMAL_TRANS = '－' // 20251212
      } else {
        resultwk.DIS_THERMAL_TRANS_EXAM = '代表試験体 ' + dataObject.THERMAL_TRANS_EXAM + ' W/㎡K'
        resultwk.CAL_THERMAL_TRANS_EXAM = Math.round(dataObject.THERMAL_TRANS_EXAM * 10) / 10 // 四捨五入
        resultwk.EXAM_THERMAL_TRANS = Number(dataObject.THERMAL_TRANS_EXAM).toFixed(2) // 20251212
      }
      if (Number.isNaN(Number(dataObject.THERMAL_TRANS_TYPE))) {
        resultwk.DIS_THERMAL_TRANS_TYPE = dataObject.THERMAL_TRANS_TYPE
        resultwk.TYPE_THERMAL_TRANS = '－' // 20251212
      } else {
        resultwk.DIS_THERMAL_TRANS_TYPE = '仕様 ' + dataObject.THERMAL_TRANS_TYPE + ' W/㎡K'
        resultwk.CAL_THERMAL_TRANS_TYPE = Math.round(dataObject.THERMAL_TRANS_TYPE * 10) / 10 // 四捨五入
        resultwk.TYPE_THERMAL_TRANS = Number(dataObject.THERMAL_TRANS_TYPE).toFixed(2) // 20251212
      }
      // alert(dataObject.SOLARHEAT_TYPE0 + '  1  ' + this.windowtoggle)
      resultwk.SOLARHEAT_HANTEI_FLG = 'TYPE' // 窓はTYPEを選択 日射仕様・試験判定フラグ どちらを使ったか
      // 日射 EXAM
      // alert('w2')
      if (Number.isNaN(Number(dataObject.SOLARHEAT_EXAM))) { // 20251212
        if (dataObject.SOLARHEAT_EXAM === '計算') { // 20251212
          if (Number.isNaN(Number(dataObject.THERMAL_TRANS_EXAM))) { // 20251212
            resultwk.EXAM_SOLARHEAT = '－' // 20251212
          } else {
            const wksol = Math.round(dataObject.THERMAL_TRANS_EXAM * 0.034 * 100) / 100 // 20251212
            resultwk.EXAM_SOLARHEAT = wksol.toFixed(2) // 20251212
          }
        } else {
          resultwk.EXAM_SOLARHEAT = '－' // 20251212
        }
      } else {
        resultwk.EXAM_SOLARHEAT = Number(dataObject.SOLARHEAT_EXAM.toFixed(2)) // 20251212
      }
      // 日射 TYPE
      // alert('w3')
      if (Number.isNaN(Number(dataObject.SOLARHEAT_TYPE0))) { // 20251212
        if (dataObject.SOLARHEAT_TYPE0 === '計算') { // 20251212
          if (Number.isNaN(Number(dataObject.THERMAL_TRANS_TYPE))) { // 20251212
            resultwk.TYPE_SOLARHEAT = '－' // 20251212
          } else {
            const wksol = Math.round(dataObject.THERMAL_TRANS_TYPE * 0.034 * 100) / 100 // 20251212
            resultwk.TYPE_SOLARHEAT = wksol.toFixed(2) // 20251212
          }
        } else {
          resultwk.TYPE_SOLARHEAT = '－' // 20251212
        }
      } else {
        // alert('w4')
        // SOLARHEAT_TYPE0が数値ならSOLARHEAT_TYPE1/SOLARHEAT_TYPE2も数値?
        if (this.windowtoggle === '0') {
          // alert('w4-01')
          resultwk.BUZAI_NM = '有効な付属部材：なし'
          resultwk.SOLARHEAT_DIS = dataObject.SOLARHEAT_TYPE0 // 日射熱取得率
          resultwk.CAL_SOLARHEAT = Math.round(dataObject.SOLARHEAT_TYPE0 * 100) / 100 // 日射熱取得率 四捨五入
          // alert('w4-02')
          resultwk.TYPE_SOLARHEAT = Number(dataObject.SOLARHEAT_TYPE0).toFixed(2) // 20251212
        }
        // alert('w4-1')
        if (this.windowtoggle === '1') {
          resultwk.BUZAI_NM = '和障子'
          resultwk.SOLARHEAT_DIS = dataObject.SOLARHEAT_TYPE1 // 日射熱取得率
          resultwk.CAL_SOLARHEAT = Math.round(dataObject.SOLARHEAT_TYPE1 * 100) / 100 // 日射熱取得率 四捨五入
          resultwk.TYPE_SOLARHEAT = Number(dataObject.SOLARHEAT_TYPE1).toFixed(2) // 20251212
        }
        if (this.windowtoggle === '2') {
          resultwk.BUZAI_NM = '外付ブラインド'
          resultwk.SOLARHEAT_DIS = dataObject.SOLARHEAT_TYPE2 // 日射熱取得率
          resultwk.CAL_SOLARHEAT = Math.round(dataObject.SOLARHEAT_TYPE2 * 100) / 100 // 日射熱取得率 四捨五入
          resultwk.TYPE_SOLARHEAT = Number(dataObject.SOLARHEAT_TYPE2).toFixed(2) // 20251212
        }
        // alert('w4-2')
        // ひさし
        if (this.windowHisashitoggle === '0') {
          // alert(dataObject.SOLARHEAT_TYPE0)
          resultwk.HISASHI_NM = '有効なひさし、軒等：なし'
          resultwk.SOLARHEAT_DIS = dataObject.SOLARHEAT_TYPE0 // 日射熱取得率
          resultwk.CAL_SOLARHEAT = Math.round(dataObject.SOLARHEAT_TYPE0 * 100) / 100 // 日射熱取得率 四捨五入
        }
        if (this.windowHisashitoggle === '1') {
          resultwk.HISASHI_NM = '有効なひさし、軒等：あり'
          // 計算が必要になる
          resultwk.SOLARHEAT_DIS = dataObject.SOLARHEAT_TYPE1 // 日射熱取得率
          resultwk.CAL_SOLARHEAT = Math.round(dataObject.SOLARHEAT_TYPE1 * 100) / 100 // 日射熱取得率 四捨五入
        }
      }
      // 基準値以下ならOKなので大きい方をセットする。
      // alert('w4')
      if (resultwk.CAL_THERMAL_TRANS_EXAM > resultwk.CAL_THERMAL_TRANS_TYPE) {
        resultwk.CAL_THERMAL_TRANS = resultwk.CAL_THERMAL_TRANS_EXAM
        resultwk.THERMAL_TRANS_HANTEI_FLG = 'EXAM' // 熱貫流率仕様・試験判定フラグ どちらを使ったか
      } else {
        resultwk.CAL_THERMAL_TRANS = resultwk.CAL_THERMAL_TRANS_TYPE
        resultwk.THERMAL_TRANS_HANTEI_FLG = 'TYPE' // 熱貫流率仕様・試験判定フラグ どちらを使ったか
      }
      // alert(resultwk.DIS_THERMAL_TRANS_EXAM + ' ' + resultwk.CAL_THERMAL_TRANS_EXAM)
      // alert(JSON.stringify(resultwk))
      this.standard45GetWindow(this.rigionClass, resultwk.BUZAI)
      this.standard45GetDoor(this.rigionClass)
      // let resultHan = this.standard45Hantei(resultwk.EXAM_THERMAL_TRANS, resultwk.EXAM_SOLARHEAT)
      // resultwk.EXAM_HANTEI_4 = resultHan.HANTEI_4 // 等級4
      // resultwk.EXAM_HANTEI_5 = resultHan.HANTEI_5 // 等級5
      // resultHan = this.standard45Hantei(resultwk.TYPE_THERMAL_TRANS, resultwk.TYPE_SOLARHEAT)
      // resultwk.TYPE_HANTEI_4 = resultHan.HANTEI_4 // 等級4
      // resultwk.TYPE_HANTEI_5 = resultHan.HANTEI_5 // 等級5
      let resultHan = ''
      if (resultwk.OPNING === '窓') {
        // *1対応 EXAM_SOLARHEATが数値では無い場合、TYPE_SOLARHEATを使い判定する。
        if (this.rigionPattern === '2') {
          if (Number.isNaN(Number(resultwk.EXAM_SOLARHEAT))) {
            resultHan = this.standard45HanteiWindow(resultwk.EXAM_THERMAL_TRANS, resultwk.TYPE_SOLARHEAT, resultwk.HISASHI)
          } else {
            resultHan = this.standard45HanteiWindow(resultwk.EXAM_THERMAL_TRANS, resultwk.EXAM_SOLARHEAT, resultwk.HISASHI)
          }
        } else {
          resultHan = this.standard45HanteiWindow(resultwk.EXAM_THERMAL_TRANS, resultwk.EXAM_SOLARHEAT, resultwk.HISASHI)
        }
        resultwk.EXAM_HANTEI_4 = resultHan.HANTEI_4 // 等級4
        resultwk.EXAM_HANTEI_5 = resultHan.HANTEI_5 // 等級5
        // alert('EXAM ' + resultHan.HANTEI_4 + '  ' + resultHan.HANTEI_5)
        resultHan = this.standard45HanteiWindow(resultwk.TYPE_THERMAL_TRANS, resultwk.TYPE_SOLARHEAT, resultwk.HISASHI)
        resultwk.TYPE_HANTEI_4 = resultHan.HANTEI_4 // 等級4
        resultwk.TYPE_HANTEI_5 = resultHan.HANTEI_5 // 等級5
        // alert('TYPE ' + resultHan.HANTEI_4 + '  ' + resultHan.HANTEI_5 + '  ' + resultwk.TYPE_THERMAL_TRANS)
      }
      if (resultwk.OPNING === 'ドア') {
        resultHan = this.standard45HanteiDoor(resultwk.EXAM_THERMAL_TRANS, resultwk.EXAM_SOLARHEAT, resultwk.HISASHI)
        resultwk.EXAM_HANTEI_4 = resultHan.HANTEI_4 // 等級4
        resultwk.EXAM_HANTEI_5 = resultHan.HANTEI_5 // 等級5
        resultHan = this.standard45HanteiDoor(resultwk.TYPE_THERMAL_TRANS, resultwk.TYPE_SOLARHEAT, resultwk.HISASHI)
        resultwk.TYPE_HANTEI_4 = resultHan.HANTEI_4 // 等級4
        resultwk.TYPE_HANTEI_5 = resultHan.HANTEI_5 // 等級5
      }
      resultwk.PDF_TYPE1 = dataObject.PDF_TYPE1
      resultwk.PDF_TYPE2 = dataObject.PDF_TYPE2
      resultwk.PDF_TYPE3 = dataObject.PDF_TYPE3
      resultwk.PDF_TYPE4 = dataObject.PDF_TYPE4
      resultwk.PDF_DECLRATION1234567 = dataObject.PDF_DECLRATION1234567
      resultwk.PDF_DECLRATION5678 = dataObject.PDF_DECLRATION5678
      return resultwk
    },
    windowPdfGet () {
      const declrationnowk = []
      const declrationwk = []
      for (let i = 0; i < this.windowResultList.length; i++) {
        declrationnowk.push(this.windowResultList[i].SELF_DECLRATION_NO)
        declrationwk.push(this.windowResultList[i].SELF_DECLRATION)
      }
      this.windowPdf1 = [...new Set(declrationnowk)]
      this.windowPdf2 = [...new Set(declrationwk)]
    },
    async doorSeriesChange () {
      // alert('windowSeriesChange')
      const auth = useAuthStore()
      axios.post('/api/doorserieschange', {
        argselectid: this.doorSeriesSelectListId,
        argtoken: auth.token,
        argacceptflg: auth.acceptflg
      })
        .then(response => {
          this.results = response.data
          if (this.results.status === 'NG') {
            alert('error ' + this.results.message)
            auth.setBsw('1') // 戻るボタン制御用
            this.$router.push('/about')
          } else {
            // alert(JSON.stringify(this.results))
            this.doorReceiveList = JSON.parse(JSON.stringify(this.results.datadoor))
            const wklist = []
            for (let i = 0; i < this.doorReceiveList.length; i++) {
              wklist.push(this.doorReceiveList[i].THERMAL2)
            }
            const wklistDis = wklist.filter((value, index, self) => self.indexOf(value) === index)
            this.doorThermalSelectList = []
            let wkll = {}
            for (let i = 0; i < wklistDis.length; i++) {
              wkll = {}
              wkll.title = wklistDis[i]
              wkll.value = wklistDis[i]
              this.doorThermalSelectList.push(wkll)
            }
            if (this.doorThermalSelectList.length === 1) {
              this.doorThermalSelectId = this.doorThermalSelectList[0].value
              window.document.getElementById('DOOR').style.display = ''
              window.document.getElementById('MAIN').style.display = 'none'
              window.document.getElementById('DOORSTART').style.display = 'none'
              window.document.getElementById('DOOR1').style.display = ''
              window.document.getElementById('DOOR2').style.display = ''
              window.document.getElementById('DOOR3').style.display = 'none'
              window.document.getElementById('DOOR4').style.display = 'none'
              this.doorSyuSelectId = ''
              this.doorGlassSelectId = ''
              this.doorDesignSelectId = ''
              this.doorThermalChange()
            } else {
              window.document.getElementById('DOOR').style.display = ''
              window.document.getElementById('MAIN').style.display = 'none'
              window.document.getElementById('DOORSTART').style.display = 'none'
              window.document.getElementById('DOOR1').style.display = ''
              window.document.getElementById('DOOR2').style.display = 'none'
              window.document.getElementById('DOOR3').style.display = 'none'
              window.document.getElementById('DOOR4').style.display = 'none'
              this.doorThermalSelectId = ''
              this.doorSyuSelectId = ''
              this.doorGlassSelectId = ''
              this.doorDesignSelectId = ''
            }
          }
        })
        .catch(error => {
          // this.dialogsw = false
          auth.setBsw('1') // 戻るボタン制御用
          alert('error  ' + error)
          this.$router.push('/about')
        })
    },
    doorThermalChange () {
      if (this.doorThermalSelectId === '') {
        return
      }
      const wklist = []
      // alert(this.doorThermalSelectId)
      for (let i = 0; i < this.doorReceiveList.length; i++) {
        if (this.doorReceiveList[i].THERMAL2 === this.doorThermalSelectId) {
          wklist.push(this.doorReceiveList[i].FRAME2)
          // alert(i + ' ' + this.doorReceiveList[i].FRAME2)
        }
        const wklistDis = wklist.filter((value, index, self) => self.indexOf(value) === index)
        this.doorSyuSelectList = []
        let wkll = {}
        for (let i = 0; i < wklistDis.length; i++) {
          wkll = {}
          wkll.title = wklistDis[i]
          wkll.value = wklistDis[i]
          this.doorSyuSelectList.push(wkll)
        }
        this.doorseriesimages = []
        this.doorimageErrors = []
        let wwk = {}
        for (let i = 0; i < this.doorSyuSelectList.length; i++) {
          for (let j = 0; j < this.doorReceiveList.length; j++) {
            if (this.doorSyuSelectList[i].value === this.doorReceiveList[j].FRAME2) { // 20260311
              if (this.doorThermalSelectId === this.doorReceiveList[j].THERMAL2) {
                wwk = {}
                // alert(this.windowReceiveList[j].IMAGE)
                wwk.item = './images/DOOR/' + this.doorReceiveList[j].IMAGE + '.jpg'
                // wwk.description = this.doorReceiveList[j].FRAME
                wwk.description = ''
                wwk.value = this.doorReceiveList[j].FRAME2 // 20260311
                this.doorseriesimages.push(wwk)
                break
              }
            }
          }
        }
      }
      if (this.doorseriesimages.length === 1) {
        this.doorSyuSelectId = this.doorseriesimages[0].value
        window.document.getElementById('DOOR2').style.display = ''
        window.document.getElementById('DOOR3').style.display = ''
        this.doorSyuChange()
      } else {
        window.document.getElementById('DOOR2').style.display = ''
        window.document.getElementById('DOOR3').style.display = 'none'
        window.document.getElementById('DOOR4').style.display = 'none'
      }
    },
    doorSyuChange () {
      if (this.doorSyuSelectId === '') {
        return
      }
      // this.doorOpeningFlg = 'door'
      // alert('doorSyuChange ' + this.doorSyuSelectId)
      const wklist1 = []
      for (let i = 0; i < this.doorReceiveList.length; i++) {
        if (this.doorReceiveList[i].THERMAL2 === this.doorThermalSelectId) {
          if (this.doorReceiveList[i].FRAME2 === this.doorSyuSelectId) {
            wklist1.push(this.doorReceiveList[i].DESIGN2) // 20260311
            /*
            if (this.doorReceiveList[i].OPNING === '窓') {
              this.doorOpeningFlg = 'window'
            }
              */
          }
        }
      }
      // alert(this.doorOpeningFlg)
      // 開口部が窓でもドアでもSyuChangeで部材/ひさしをクリア
      this.doortoggle = '0'
      this.doorHisashitoggle = '0'
      // alert(this.doorReceiveList[1].FRAME)
      // alert(this.doorReceiveList[1].GLASS_TYPE)
      const wklistDis1 = wklist1.filter((value, index, self) => self.indexOf(value) === index)
      this.doorDesignSelectList = []
      let wkll = {}
      for (let i = 0; i < wklistDis1.length; i++) {
        wkll = {}
        wkll.title = wklistDis1[i]
        wkll.value = wklistDis1[i]
        this.doorDesignSelectList.push(wkll)
      }
      if (this.doorDesignSelectList.length === 1) {
        this.doorDesignSelectId = this.doorDesignSelectList[0].value
        window.document.getElementById('DOOR3').style.display = ''
        window.document.getElementById('DOOR4').style.display = ''
        this.doorGlassChange()
      } else {
        window.document.getElementById('DOOR3').style.display = ''
        window.document.getElementById('DOOR4').style.display = 'none'
        this.doorDesignSelectId = ''
        this.doorGlassSelectId = ''
      }
    },
    doorGlassChange () {
      if (this.doorDesignSelectId === '') {
        return
      }
      this.doorOpeningFlg = 'door'
      const wklist2 = []
      for (let i = 0; i < this.doorReceiveList.length; i++) {
        if (this.doorReceiveList[i].THERMAL2 === this.doorThermalSelectId) {
          if (this.doorReceiveList[i].FRAME2 === this.doorSyuSelectId) { // 20260311
            if (this.doorReceiveList[i].DESIGN2 === this.doorDesignSelectId) { // 20260311
              wklist2.push([this.doorReceiveList[i].ID, this.doorReceiveList[i].GLASS_TYPE2]) // 20260311
              if (this.doorReceiveList[i].OPNING === '窓') {
                this.doorOpeningFlg = 'window'
              }
            }
          }
        }
      }
      // 開口部が窓でもドアでもSyuChangeで部材/ひさしをクリア
      this.doortoggle = '0'
      this.doorHisashitoggle = '0'
      // alert(wklist2)
      const seen = new Set()
      const wklistDis2 = wklist2.filter(item => {
        const key = item[1] // 2番目の要素
        if (seen.has(key)) {
          return false
        }
        seen.add(key)
        return true
      })
      // alert(wklistDis2)
      // alert(wklistDis2[1][0])
      // alert(wklistDis2[2][0])
      this.doorGlassSelectList = []
      let wkll = {}
      for (let i = 0; i < wklistDis2.length; i++) {
        wkll = {}
        wkll.title = wklistDis2[i][1]
        wkll.value = wklistDis2[i][0]
        this.doorGlassSelectList.push(wkll)
      }
      if (this.doorGlassSelectList.length === 1) {
        this.doorGlassSelectId = this.doorGlassSelectList[0].value
        window.document.getElementById('DOOR4').style.display = ''
        setTimeout(() => {
          const el = document.getElementById('DOOREND')
          el.scrollIntoView({ behavior: 'smooth' })
        }, 100)
      } else {
        window.document.getElementById('DOOR4').style.display = ''
        setTimeout(() => {
          const el = document.getElementById('DOOREND')
          el.scrollIntoView({ behavior: 'smooth' })
        }, 100)
        this.doorGlassSelectId = ''
      }
    },
    henkouDoorDis (ix) {
      this.doorMode = 'update'
      this.doorModeId = ix
      this.henkouDoorListSet(ix)
    },
    async henkouDoorListSet (ix) {
      // alert(0)
      this.doorSeriesSelectListId = this.doorResultList[ix].SERIES2
      const auth = useAuthStore()
      axios.post('/api/doorserieschange', {
        argselectid: this.doorSeriesSelectListId,
        argtoken: auth.token,
        argacceptflg: auth.acceptflg
      })
        .then(async response => {
          this.results = response.data
          if (this.results.status === 'NG') {
            alert('error ' + this.results.message)
            auth.setBsw('1') // 戻るボタン制御用
            this.$router.push('/about')
          } else {
            // alert(JSON.stringify(this.results))
            this.doorReceiveList = JSON.parse(JSON.stringify(this.results.datadoor))
            let wklist = []
            for (let i = 0; i < this.doorReceiveList.length; i++) {
              wklist.push(this.doorReceiveList[i].THERMAL2)
            }
            const wklistDis = wklist.filter((value, index, self) => self.indexOf(value) === index)
            this.doorThermalSelectList = []
            let wkll = {}
            for (let i = 0; i < wklistDis.length; i++) {
              wkll = {}
              wkll.title = wklistDis[i]
              wkll.value = wklistDis[i]
              this.doorThermalSelectList.push(wkll)
            }
            this.doorThermalSelectId = this.doorResultList[ix].THERMALID
            // イメージ作成
            wklist = []
            for (let i = 0; i < this.doorReceiveList.length; i++) {
              if (this.doorReceiveList[i].THERMAL2 === this.doorThermalSelectId) {
                wklist.push(this.doorReceiveList[i].FRAME2)
              }
              const wklistDis = wklist.filter((value, index, self) => self.indexOf(value) === index)
              this.doorSyuSelectList = []
              let wkll = {}
              for (let i = 0; i < wklistDis.length; i++) {
                wkll = {}
                wkll.title = wklistDis[i]
                wkll.value = wklistDis[i]
                this.doorSyuSelectList.push(wkll)
              }
              this.doorseriesimages = []
              this.doorimageErrors = []
              await nextTick()
              let wwk = {}
              for (let i = 0; i < this.doorSyuSelectList.length; i++) {
                for (let j = 0; j < this.doorReceiveList.length; j++) {
                  if (this.doorSyuSelectList[i].value === this.doorReceiveList[j].FRAME2) { // 20260311
                    if (this.doorThermalSelectId === this.doorReceiveList[j].THERMAL2) { // 20260311
                      wwk = {}
                      // alert(this.windowReceiveList[j].IMAGE)
                      wwk.item = './images/DOOR/' + this.doorReceiveList[j].IMAGE + '.jpg'
                      // wwk.description = this.doorReceiveList[j].FRAME
                      wwk.description = ''
                      wwk.value = this.doorReceiveList[j].FRAME2 // 20260311
                      this.doorseriesimages.push(wwk)
                      break
                    }
                  }
                }
              }
            }
            this.doorSyuSelectId = this.doorResultList[ix].FRAME2 // 20260311
            // デザインリスト作成
            const wklist1 = []
            this.doorOpeningFlg = 'door'
            for (let i = 0; i < this.doorReceiveList.length; i++) {
              if (this.doorReceiveList[i].THERMAL2 === this.doorThermalSelectId) {
                if (this.doorReceiveList[i].FRAME2 === this.doorSyuSelectId) {
                  wklist1.push(this.doorReceiveList[i].DESIGN2) // 20260311
                  if (this.doorReceiveList[i].OPNING === '窓') {
                    this.doorOpeningFlg = 'window'
                  }
                }
              }
            }
            const wklistDis1 = wklist1.filter((value, index, self) => self.indexOf(value) === index)
            this.doorDesignSelectList = []
            wkll = {}
            for (let i = 0; i < wklistDis1.length; i++) {
              wkll = {}
              wkll.title = wklistDis1[i]
              wkll.value = wklistDis1[i]
              this.doorDesignSelectList.push(wkll)
            }
            this.doorDesignSelectId = this.doorResultList[ix].DESIGN2 // 20260311
            // ガラスリスト作成
            const wklist2 = []
            for (let i = 0; i < this.doorReceiveList.length; i++) {
              if (this.doorReceiveList[i].THERMAL2 === this.doorThermalSelectId) {
                if (this.doorReceiveList[i].FRAME2 === this.doorSyuSelectId) { // 20260311
                  if (this.doorReceiveList[i].DESIGN2 === this.doorDesignSelectId) { // 20260311
                    wklist2.push([this.doorReceiveList[i].ID, this.doorReceiveList[i].GLASS_TYPE2]) // 20260311
                  }
                }
              }
            }
            const seen = new Set()
            const wklistDis2 = wklist2.filter(item => {
              const key = item[1] // 2番目の要素
              if (seen.has(key)) {
                return false
              }
              seen.add(key)
              return true
            })
            this.doorGlassSelectList = []
            wkll = {}
            for (let i = 0; i < wklistDis2.length; i++) {
              wkll = {}
              wkll.title = wklistDis2[i][1]
              wkll.value = wklistDis2[i][0]
              this.doorGlassSelectList.push(wkll)
            }
            this.doorGlassSelectId = this.doorResultList[ix].ID
            this.doortoggle = this.doorResultList[ix].BUZAI
            this.doorHisashitoggle = this.doorResultList[ix].HISASHI
            await nextTick()
            window.document.getElementById('DOOR').style.display = ''
            window.document.getElementById('MAIN').style.display = 'none'
            window.document.getElementById('DOORSTART').style.display = 'none'
            window.document.getElementById('DOOR1').style.display = ''
            window.document.getElementById('DOOR2').style.display = ''
            window.document.getElementById('DOOR3').style.display = ''
            window.document.getElementById('DOOR4').style.display = ''
          }
        })
        .catch(error => {
          // this.dialogsw = false
          auth.setBsw('1') // 戻るボタン制御用
          alert('error  ' + error)
          this.$router.push('/about')
        })
    },
    henkouDoor () {
      const ix = this.doorModeId
      // this.doorResultList[ix].SERIES = this.doorSeriesSelectListId
      // this.doorResultList[ix].FRAME = this.doorSyuSelectId
      // this.doorResultList[ix].DESIGN = this.doorDesignSelectId
      // this.doorResultList[ix].ID = this.doorGlassSelectId
      // this.doorResultList[ix].BUZAI = this.doortoggle
      // this.doorResultList[ix].HISASHI = this.doorHisashitoggle
      this.countWindowDoor('D', ix)
      for (let i = 0; i < this.doorReceiveList.length; i++) {
        if (this.doorReceiveList[i].ID === this.doorGlassSelectId) {
          const nowOpnig = this.doorReceiveList[i].OPNING
          if (this.countWindow >= this.countWindowMax && nowOpnig === '窓') {
            this.countWindowAlert(this.countWindow)
            return
          }
          if (this.countDoor >= this.countDoorMax && nowOpnig === 'ドア') {
            this.countDoorAlert(this.countDoor)
            return
          }
          const resultwk = this.doorMisaiSet(this.doorReceiveList[i])
          const wkinputseq = this.doorResultList[ix].INPUTSEQ // 20260207
          this.doorResultList[ix] = JSON.parse(JSON.stringify(resultwk))
          this.doorResultList[ix].INPUTSEQ = wkinputseq // 20260207
        }
      }
      this.doorResultList[ix].THERMALID = this.doorThermalSelectId // 20260123 編集で使用するため
      this.doorPdfGet()
      this.selectFlgSet()
      this.showDoorCards = true
      window.document.getElementById('MAIN').style.display = ''
      window.document.getElementById('WINDOW').style.display = 'none'
      window.document.getElementById('DOOR').style.display = 'none'
    },
    addDoorDis () {
      if (this.copyDoorMode === 'copy') {
        const ix = this.doorResultList.length - 1
        this.henkouDoorListSet(ix)
      }
      this.doorMode = 'insert'
      window.document.getElementById('MAIN').style.display = 'none'
      window.document.getElementById('DOOR').style.display = ''
      this.copyDoorMode = ''
    },
    async addDoor () {
      // alert(this.doortoggle)
      this.countWindowDoor('', 0)
      this.testd += 1
      this.allSeqNo += 1 // 20251212
      // let wklist = {}
      // wklist.title = this.doorSeriesSelectListId
      // wklist.description = this.doorDesignSelectId
      // this.itemDisDoor.push(wklist)
      // const resultwk = {}
      // const declrationnowk = []
      // const declrationwk = []
      for (let i = 0; i < this.doorReceiveList.length; i++) {
        if (this.doorReceiveList[i].ID === this.doorGlassSelectId) { // 20251228
          const nowOpnig = this.doorReceiveList[i].OPNING
          if (this.countWindow >= this.countWindowMax && nowOpnig === '窓') {
            this.countWindowAlert(this.countWindow)
            return
          }
          if (this.countDoor >= this.countDoorMax && nowOpnig === 'ドア') {
            this.countDoorAlert(this.countDoor)
            return
          }
          const resultwk = this.doorMisaiSet(this.doorReceiveList[i])
          // alert('2 ' + this.windowReceiveList[i].PDF_TYPE1)
          this.doorResultList.push(resultwk)
          this.inputSeq += 1 // 20260207
          this.doorResultList[this.doorResultList.length - 1].INPUTSEQ = this.inputSeq // 20260207
          break
        }
      }
      this.doorPdfGet()
      // this.doorPdf1 = [...new Set(declrationnowk)]
      // this.doorPdf2 = [...new Set(declrationwk)]
      this.selectFlgSet()
      this.showDoorCards = true
      window.document.getElementById('MAIN').style.display = ''
      window.document.getElementById('WINDOW').style.display = 'none'
      // window.document.getElementById('WINDOW1').style.display = 'none'
      // window.document.getElementById('WINDOW2').style.display = 'none'
      window.document.getElementById('DOOR').style.display = 'none'
      // window.document.getElementById('DOOR1').style.display = 'none'
      // window.document.getElementById('DOOR2').style.display = 'none'
      // window.document.getElementById('DOOR3').style.display = 'none'
      await nextTick()
      const container = document.querySelector('.card-container-d-pro')
      if (container) {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth'
        })
      }
    },
    doorMisaiSet (dataObject) {
      const resultwk = {}
      resultwk.ALLSEQ = this.allSeqNo // 20251212
      resultwk.THERMALID = this.doorThermalSelectId // 20260123 編集で使用するため
      resultwk.ID = dataObject.ID
      resultwk.SERIES = dataObject.SERIES
      resultwk.SERIES2 = dataObject.SERIES2
      resultwk.DESIGN = dataObject.DESIGN
      resultwk.DESIGN2 = dataObject.DESIGN2 // 20260311
      resultwk.FRAME = dataObject.FRAME
      resultwk.FRAME2 = dataObject.FRAME2 // 20260311
      resultwk.GLASS_TYPE = dataObject.GLASS_TYPE
      resultwk.GLASS_TYPE2 = dataObject.GLASS_TYPE2 // 20260311
      resultwk.OPNING = dataObject.OPNING
      resultwk.SLEEVE = dataObject.SLEEVE
      resultwk.THERMAL_TRANS_EXAM = dataObject.THERMAL_TRANS_EXAM // 熱貫流率代表試験体
      resultwk.THERMAL_TRANS_TYPE = dataObject.THERMAL_TRANS_TYPE // 熱貫流率仕様
      resultwk.SOLARHEAT_EXAM = dataObject.SOLARHEAT_EXAM
      resultwk.SOLARHEAT_TYPE0 = dataObject.SOLARHEAT_TYPE0
      resultwk.SELF_DECLRATION_NO = dataObject.SELF_DECLRATION_NO
      resultwk.SELF_DECLRATION_ID = dataObject.SELF_DECLRATION_ID
      resultwk.SELF_DECLRATION = dataObject.SELF_DECLRATION
      resultwk.REMARK = dataObject.REMARK
      resultwk.BUZAI = this.doortoggle
      resultwk.BUZAI_NM = ''
      resultwk.HISASHI = this.doorHisashitoggle
      resultwk.HISASHI_NM = ''
      resultwk.DIS_THERMAL_TRANS_EXAM = ''
      resultwk.DIS_THERMAL_TRANS_TYPE = ''
      resultwk.DIS_SOLARHEAT_EXAM = ''
      resultwk.DIS_SOLARHEAT_TYPE0 = ''
      resultwk.CAL_THERMAL_TRANS_EXAM = 0
      resultwk.CAL_THERMAL_TRANS_TYPE = 0
      resultwk.CAL_THERMAL_TRANS = 0
      resultwk.CAL_SOLARHEAT = 0
      resultwk.HAN_THERMAL_TRANS = '' // 判定エリア
      resultwk.HAN_SOLARHEAT = '' // 判定エリア
      // 個別判定
      resultwk.THERMAL_TRANS_HANTEI_FLG = '' // 熱貫流率仕様・試験判定フラグ どちらを使ったか
      resultwk.THERMAL_TRANS_HANTEI_4 = '' // 熱貫流率判定結果 等級4
      resultwk.THERMAL_TRANS_HANTEI_5 = '' // 熱貫流率判定結果 等級5
      resultwk.SOLARHEAT_HANTEI_FLG = '' // 日射仕様・試験判定フラグ どちらを使ったか
      resultwk.SOLARHEAT_HANTEI_4 = '' // 日射判定結果 等級4
      resultwk.SOLARHEAT_HANTEI_5 = '' // 日射判定結果 等級5
      resultwk.EXAM_THERMAL_TRANS = '' // 20251212
      resultwk.TYPE_THERMAL_TRANS = '' // 20251212
      resultwk.EXAM_SOLARHEAT = '' // 20251212
      resultwk.TYPE_SOLARHEAT = '' // 20251212
      resultwk.EXAM_THERMAL_TRANS_HANTEI_4 = '' // 熱貫流率判定結果 等級4 20251212
      resultwk.EXAM_THERMAL_TRANS_HANTEI_5 = '' // 熱貫流率判定結果 等級5 20251212
      resultwk.EXAM_SOLARHEAT_HANTEI_4 = '' // 日射判定結果 等級4 20251212
      resultwk.EXAM_SOLARHEAT_HANTEI_5 = '' // 日射判定結果 等級5 20251212
      resultwk.EXAM_HANTEI_4 = '' // EXAM判定結果 等級4 20251212
      resultwk.EXAM_HANTEI_5 = '' // EXAM判定結果 等級5 20251212
      resultwk.TYPE_HANTEI_4 = '' // TYPE判定結果 等級4 20251212
      resultwk.TYPE_HANTEI_5 = '' // TYPE判定結果 等級5 20251212
      if (Number.isNaN(Number(dataObject.THERMAL_TRANS_EXAM))) {
        resultwk.CAL_THERMAL_TRANS_EXAM = dataObject.THERMAL_TRANS_EXAM
        resultwk.EXAM_THERMAL_TRANS = '－' // 20251212
      } else {
        resultwk.DIS_THERMAL_TRANS_EXAM = '代表試験体 ' + dataObject.THERMAL_TRANS_EXAM + ' W/㎡K'
        resultwk.CAL_THERMAL_TRANS_EXAM = Math.round(dataObject.THERMAL_TRANS_EXAM * 10) / 10 // 四捨五入
        resultwk.EXAM_THERMAL_TRANS = Number(dataObject.THERMAL_TRANS_EXAM).toFixed(2) // 20251212
      }
      if (Number.isNaN(Number(dataObject.THERMAL_TRANS_TYPE))) {
        resultwk.DIS_THERMAL_TRANS_TYPE = dataObject.THERMAL_TRANS_TYPE
        resultwk.TYPE_THERMAL_TRANS = '－' // 20251212
      } else {
        resultwk.DIS_THERMAL_TRANS_TYPE = '仕様 ' + dataObject.THERMAL_TRANS_TYPE + ' W/㎡K'
        resultwk.CAL_THERMAL_TRANS_TYPE = Math.round(dataObject.THERMAL_TRANS_TYPE * 10) / 10 // 四捨五入
        resultwk.TYPE_THERMAL_TRANS = Number(dataObject.THERMAL_TRANS_TYPE).toFixed(2) // 20251212
      }
      // 日射 EXAM
      if (Number.isNaN(Number(dataObject.SOLARHEAT_EXAM))) { // 20251212
        if (dataObject.SOLARHEAT_EXAM === '計算') { // 20251212
          if (Number.isNaN(Number(dataObject.THERMAL_TRANS_EXAM))) { // 20251212
            resultwk.EXAM_SOLARHEAT = '－' // 20251212
          } else {
            const wksol = Math.round(dataObject.THERMAL_TRANS_EXAM * 0.034 * 100) / 100 // 20251212
            resultwk.EXAM_SOLARHEAT = wksol.toFixed(2) // 20251212
          }
        } else {
          resultwk.EXAM_SOLARHEAT = '－' // 20251212
        }
      } else {
        resultwk.EXAM_SOLARHEAT = Number(dataObject.SOLARHEAT_EXAM).toFixed(2) // 20251212
      }
      // 日射 TYPE
      if (Number.isNaN(Number(dataObject.SOLARHEAT_TYPE0))) { // 20251212
        if (dataObject.SOLARHEAT_TYPE0 === '計算') { // 20251212
          if (Number.isNaN(Number(dataObject.THERMAL_TRANS_TYPE))) { // 20251212
            resultwk.TYPE_SOLARHEAT = '－' // 20251212
          } else {
            const wksol = Math.round(dataObject.THERMAL_TRANS_TYPE * 0.034 * 100) / 100 // 20251212
            resultwk.TYPE_SOLARHEAT = wksol.toFixed(2) // 20251212
          }
        } else {
          resultwk.TYPE_SOLARHEAT = '－' // 20251212
        }
      } else {
        // 20251222 指摘により修正resultwk.EXAM_SOLARHEAT = Number(dataObject.SOLARHEAT_TYPE0).toFixed(2) // 20251212
        resultwk.TYPE_SOLARHEAT = Number(dataObject.SOLARHEAT_TYPE0).toFixed(2) // 20251212
      }
      // 基準値以下ならOKなので大きい方をセットする。
      if (resultwk.CAL_THERMAL_TRANS_EXAM > resultwk.CAL_THERMAL_TRANS_TYPE) {
        resultwk.CAL_THERMAL_TRANS = resultwk.CAL_THERMAL_TRANS_EXAM
        resultwk.THERMAL_TRANS_HANTEI_FLG = 'EXAM' // 熱貫流率仕様・試験判定フラグ どちらを使ったか
      } else {
        resultwk.CAL_THERMAL_TRANS = resultwk.CAL_THERMAL_TRANS_TYPE
        resultwk.THERMAL_TRANS_HANTEI_FLG = 'TYPE' // 熱貫流率仕様・試験判定フラグ どちらを使ったか
      }
      this.standard45GetWindow(this.rigionClass, resultwk.BUZAI)
      this.standard45GetDoor(this.rigionClass)
      // let resultHan = this.standard45Hantei(resultwk.EXAM_THERMAL_TRANS, resultwk.EXAM_SOLARHEAT)
      // resultwk.EXAM_HANTEI_4 = '－' // 等級4
      // resultwk.EXAM_HANTEI_5 = '－' // 等級5
      // resultwk.EXAM_HANTEI_4 = resultHan.HANTEI_4 // 等級4
      // resultwk.EXAM_HANTEI_5 = resultHan.HANTEI_5 // 等級5
      // resultHan = this.standard45Hantei(resultwk.TYPE_THERMAL_TRANS, resultwk.TYPE_SOLARHEAT)
      // resultwk.TYPE_HANTEI_4 = resultHan.HANTEI_4 // 等級4
      // resultwk.TYPE_HANTEI_5 = resultHan.HANTEI_5 // 等級5
      let resultHan = ''
      if (resultwk.OPNING === '窓') {
        // *1対応 EXAM_SOLARHEATが数値では無い場合、TYPE_SOLARHEATを使い判定する。 20260311 add
        if (this.rigionPattern === '2') {
          if (Number.isNaN(Number(resultwk.EXAM_SOLARHEAT))) {
            resultHan = this.standard45HanteiWindow(resultwk.EXAM_THERMAL_TRANS, resultwk.TYPE_SOLARHEAT, resultwk.HISASHI)
          } else {
            resultHan = this.standard45HanteiWindow(resultwk.EXAM_THERMAL_TRANS, resultwk.EXAM_SOLARHEAT, resultwk.HISASHI)
          }
        } else {
          resultHan = this.standard45HanteiWindow(resultwk.EXAM_THERMAL_TRANS, resultwk.EXAM_SOLARHEAT, resultwk.HISASHI)
        }
        // 20260311 resultHan = this.standard45HanteiWindow(resultwk.EXAM_THERMAL_TRANS, resultwk.EXAM_SOLARHEAT, resultwk.HISASHI)
        resultwk.EXAM_HANTEI_4 = resultHan.HANTEI_4 // 等級4
        resultwk.EXAM_HANTEI_5 = resultHan.HANTEI_5 // 等級5
        resultHan = this.standard45HanteiWindow(resultwk.TYPE_THERMAL_TRANS, resultwk.TYPE_SOLARHEAT, resultwk.HISASHI)
        resultwk.TYPE_HANTEI_4 = resultHan.HANTEI_4 // 等級4
        resultwk.TYPE_HANTEI_5 = resultHan.HANTEI_5 // 等級5
      }
      if (resultwk.OPNING === 'ドア') {
        resultHan = this.standard45HanteiDoor(resultwk.EXAM_THERMAL_TRANS, resultwk.EXAM_SOLARHEAT, resultwk.HISASHI)
        resultwk.EXAM_HANTEI_4 = resultHan.HANTEI_4 // 等級4
        resultwk.EXAM_HANTEI_5 = resultHan.HANTEI_5 // 等級5
        resultHan = this.standard45HanteiDoor(resultwk.TYPE_THERMAL_TRANS, resultwk.TYPE_SOLARHEAT, resultwk.HISASHI)
        resultwk.TYPE_HANTEI_4 = resultHan.HANTEI_4 // 等級4
        resultwk.TYPE_HANTEI_5 = resultHan.HANTEI_5 // 等級5
      }
      // resultwk.TYPE_THERMAL_TRANS_HANTEI_4 = resultHan.THERMAL_TRANS_HANTEI_4 // 熱貫流率判定結果 等級4
      // resultwk.TYPE_THERMAL_TRANS_HANTEI_5 = resultHan.THERMAL_TRANS_HANTEI_5 // 熱貫流率判定結果 等級5
      // resultwk.TYPE_SOLARHEAT_HANTEI_4 = resultHan.SOLARHEAT_HANTEI_4 // 日射判定結果 等級4
      // resultwk.TYPE_SOLARHEAT_HANTEI_5 = resultHan.SOLARHEAT_HANTEI_5 // 日射判定結果 等級5
      if (this.doorHisashitoggle === '0') {
        resultwk.HISASHI_NM = '有効なひさし、軒等：なし'
        resultwk.SOLARHEAT_DIS = dataObject.SOLARHEAT_TYPE0 // 日射熱取得率
        resultwk.CAL_SOLARHEAT = Math.round(dataObject.SOLARHEAT_TYPE0 * 100) / 100 // 日射熱取得率 四捨五入
      }
      if (this.doorHisashitoggle === '1') {
        resultwk.HISASHI_NM = '有効なひさし、軒等：あり'
        // 計算が必要になる
        resultwk.SOLARHEAT_DIS = dataObject.SOLARHEAT_TYPE0 // 日射熱取得率
        resultwk.CAL_SOLARHEAT = Math.round(dataObject.SOLARHEAT_TYPE0 * 100) / 100 // 日射熱取得率 四捨五入
      }
      resultwk.PDF_TYPE1 = dataObject.PDF_TYPE1
      resultwk.PDF_TYPE2 = dataObject.PDF_TYPE2
      resultwk.PDF_TYPE3 = dataObject.PDF_TYPE3
      resultwk.PDF_TYPE4 = dataObject.PDF_TYPE4
      resultwk.PDF_DECLRATION1234567 = dataObject.PDF_DECLRATION1234567
      resultwk.PDF_DECLRATION5678 = dataObject.PDF_DECLRATION5678
      return resultwk
    },
    doorPdfGet () {
      const declrationnowk = []
      const declrationwk = []
      for (let i = 0; i < this.doorResultList.length; i++) {
        declrationnowk.push(this.doorResultList[i].SELF_DECLRATION_NO)
        declrationwk.push(this.doorResultList[i].SELF_DECLRATION)
      }
      this.doorPdf1 = [...new Set(declrationnowk)]
      this.doorPdf2 = [...new Set(declrationwk)]
    },
    selectFlgSet () {
      this.selectFlg = false
      this.showWindowCards = false
      this.showDoorCards = false
      if (this.windowResultList.length > 0) {
        this.showWindowCards = true
        this.selectFlg = true
      }
      if (this.doorResultList.length > 0) {
        this.showDoorCards = true
        this.selectFlg = true
      }
      this.windowkensu = this.windowResultList.length
      this.doorkensu = this.doorResultList.length
    },
    onCardClickWindow (x1) {
      alert('w card ' + x1)
    },
    deleteWindow (x1) {
      this.deleteIndex = x1
      this.deleteWindowdialog = true
    },
    deleteWindowdialogFnc () {
      this.windowResultList.splice(parseInt(this.deleteIndex), 1)
      this.windowPdfGet()
      this.selectFlgSet()
      // 20260109 add
      if (this.windowResultList.length === 0) {
        this.windowCancelMaindis()
        this.windowMode = 'insert' // 20260208
      }
      this.deleteWindowdialog = false
    },
    async copyWindow (ix) {
      this.copyWindowMode = 'copy'
      this.countWindowDoor('', 0)
      const nowOpnig = this.windowResultList[ix].OPNING
      if (this.countWindow >= this.countWindowMax && nowOpnig === '窓') {
        this.countWindowAlert(this.countWindow)
        return
      }
      if (this.countDoor >= this.countDoorMax && nowOpnig === 'ドア') {
        this.countDoorAlert(this.countDoor)
        return
      }
      const wklist = JSON.stringify(this.windowResultList[ix])
      this.windowResultList.push(JSON.parse(wklist))
      this.inputSeq += 1 // 20260207
      this.windowResultList[this.windowResultList.length - 1].INPUTSEQ = this.inputSeq // 20260207
      // this.windowResultList.splice(ix, 0, this.windowResultList[ix]) 次に追加
      this.windowPdfGet()
      this.selectFlgSet()
      await nextTick()
      const container = document.querySelector('.card-container-w-pro')
      if (container) {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth'
        })
      }
    },
    onCardClickDoor (x1) {
      alert('d card ' + x1)
    },
    deleteDoor (x1) {
      this.deleteIndex = x1
      this.deleteDoordialog = true
    },
    deleteDoordialogFnc () {
      // alert('ドア' + this.deleteIndex)
      this.doorResultList.splice(parseInt(this.deleteIndex), 1)
      this.doorPdfGet()
      this.selectFlgSet()
      // 20260109 add
      if (this.doorResultList.length === 0) {
        this.doorMode = 'insert' // 20260208
        this.doorCancelMaindis()
      }
      // alert('ドアend' + this.deleteIndex)
      this.deleteDoordialog = false
    },
    async copyDoor (ix) {
      this.copyDoorMode = 'copy'
      this.countWindowDoor('', 0)
      const nowOpnig = this.doorResultList[ix].OPNING
      if (this.countWindow >= this.countWindowMax && nowOpnig === '窓') {
        this.countWindowAlert(this.countWindow)
        return
      }
      if (this.countDoor >= this.countDoorMax && nowOpnig === 'ドア') {
        this.countDoorAlert(this.countDoor)
        return
      }
      const wklist = JSON.stringify(this.doorResultList[ix])
      this.doorResultList.push(JSON.parse(wklist))
      // this.doorResultList.push(this.doorResultList[ix])
      this.inputSeq += 1 // 20260207
      this.doorResultList[this.doorResultList.length - 1].INPUTSEQ = this.inputSeq // 20260207
      // this.doorResultList.splice(ix, 0, this.doorResultList[ix]) 次に追加
      this.doorPdfGet()
      this.selectFlgSet()
      await nextTick()
      const container = document.querySelector('.card-container-d-pro')
      if (container) {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth'
        })
      }
    },
    windowCancelMaindis () {
      window.document.getElementById('MAIN').style.display = ''
      window.document.getElementById('WINDOW').style.display = 'none'
      window.document.getElementById('DOOR').style.display = 'none'
      if (this.windowkensu === 0) {
        window.document.getElementById('WINDOWSTART').style.display = ''
        this.windowSpecSelectListId = ''
      }
    },
    doorCancelMaindis () {
      window.document.getElementById('MAIN').style.display = ''
      window.document.getElementById('WINDOW').style.display = 'none'
      window.document.getElementById('DOOR').style.display = 'none'
      if (this.doorkensu === 0) {
        window.document.getElementById('DOORSTART').style.display = ''
        this.doorSeriesSelectListId = ''
      }
    },
    maindis (x1) {
      window.document.getElementById('MAIN').style.display = ''
      window.document.getElementById('WINDOW').style.display = 'none'
      window.document.getElementById('DOOR').style.display = 'none'
    },
    next () {
      // this.hanteiCalculation() del 20260206
      this.resultDataSet()
      this.resulttab = '1'
      window.document.getElementById('PRODUCT').style.display = 'none'
      window.document.getElementById('RESULT').style.display = ''
      // 値の保存(common.js)
      // const auth = useAuthStore()
      // auth.setBsw('1') // 戻るボタン制御用
      // this.$router.push('/result')
    },
    backFnc () {
      this.backregiondialog = true
    },
    backRegionFnc () {
      const auth = useAuthStore()
      auth.setBsw('1') // 戻るボタン制御用
      auth.setRegion('')
      this.$router.push('/region')
      /*
      let result = window.confirm('地域選択にもどりますか? 選択されたデータはクリアされます。')
      if (result) {
        auth.setBsw('1') // 戻るボタン制御用
        auth.setRegion('')
        this.$router.push('/region')
      }
        */
    },
    backProduct () {
      window.document.getElementById('PRODUCT').style.display = ''
      window.document.getElementById('RESULT').style.display = 'none'
    },
    WindowSeriseDis (x1) {
      this.imageSelSyu = x1
      this.seriesdialog = true
    },
    WindowSyuDis () {
      this.seriesdialog = true
    },
    WindowSeriseSelected (x1) {
      // alert(x1)
      // if (this.imageSelSyu === 'windowsyu') {
      this.windowSyuSelectId = this.windowseriesimages[x1].value
      this.windowSyuChange()
      this.glassSelectDis() // 20260203
      const el = document.getElementById('WINDOWEND')
      el.scrollIntoView({ behavior: 'smooth' })
      // }
      // this.seriesdialog = false
    },
    WindowEndDisplay () {
      const el = document.getElementById('WINDOWEND')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    doorSeriseSelected (x1) {
      // alert(x1)
      // if (this.imageSelSyu === 'windowsyu') {
      this.doorSyuSelectId = this.doorseriesimages[x1].value
      this.doorSyuChange()
      const el = document.getElementById('DOOREND')
      el.scrollIntoView({ behavior: 'smooth' })
      // }
      // this.seriesdialog = false
    },
    async glassAssistUpadte (id, ix) {
      if (id === 3) {
        if (this.glassAssistSw === 1) {
          this.windowGlassSelectId = ix
          this.glassAssistdialog3 = false
        }
        this.WindowEndDisplay()
      }
    },
    glassAssistClear () {
      this.glassAssistId1 = ''
      this.glassAssistId2 = ''
      this.glassAssistId3 = ''
      this.glassAssistId4 = ''
      this.glassAssistChange()
    },
    glassAssistClear3 () {
      this.glassAssistId1 = ''
      this.glassAssistId2 = ''
      this.glassAssistId3 = ''
      this.glassAssistId4 = ''
      // this.glassAssistChange()
      this.glassAssistChange2(1, '')
    },
    glassSelectDis () { // 20260203 編集時と追加時にも必要?
      this.glassAssistAll = true
      this.glassAssistId1 = ''
      this.glassAssistId2 = ''
      this.glassAssistId3 = ''
      this.glassAssistId4 = ''
      this.glassAssistChange()
      this.glassAssistClear3()
      this.glassAssistSw = 1
      // this.glassAssistdialog3 = true
    },
    glassSelectOpen () { // 20260203
      this.glassAssistSw = 1
      this.glassAssistdialog3 = true
    },
    standard45GetWindow (rigionClass, buzaiSw) {
      // 基準値の取得
      if (rigionClass === '1' || rigionClass === '2' || rigionClass === '3') {
        this.WINDOW_STANDARD4_THERMAL_TRANS = 2.3
        this.WINDOW_STANDARD4_THERMAL_TRANS_DIS_KIJUNN = '≦2.3'
        this.WINDOW_STANDARD4_SOLARHEAT = 0
        this.WINDOW_STANDARD4_SOLARHEAT_DIS = ''
        this.WINDOW_STANDARD4_SOLARHEAT_DIS_KIJUNN = 'ー'
        this.WINDOW_STANDARD5_THERMAL_TRANS = 1.9
        this.WINDOW_STANDARD5_THERMAL_TRANS_DIS_KIJUNN = '≦1.9'
        this.WINDOW_STANDARD5_SOLARHEAT = 0
        this.WINDOW_STANDARD5_SOLARHEAT_DIS = ''
        this.WINDOW_STANDARD5_SOLARHEAT_DIS_KIJUNN = 'ー'
      }
      if (rigionClass === '4') {
        this.WINDOW_STANDARD4_THERMAL_TRANS = 3.5
        this.WINDOW_STANDARD4_THERMAL_TRANS_DIS_KIJUNN = '≦3.5'
        this.WINDOW_STANDARD4_SOLARHEAT = 0
        this.WINDOW_STANDARD4_SOLARHEAT_DIS = ''
        this.WINDOW_STANDARD4_SOLARHEAT_DIS_KIJUNN = 'ー'
        this.WINDOW_STANDARD5_THERMAL_TRANS = 2.3
        this.WINDOW_STANDARD5_THERMAL_TRANS_DIS_KIJUNN = '≦2.3'
        this.WINDOW_STANDARD5_SOLARHEAT = 0
        this.WINDOW_STANDARD5_SOLARHEAT_DIS = ''
        this.WINDOW_STANDARD5_SOLARHEAT_DIS_KIJUNN = 'ー'
      }
      if (rigionClass === '5' || rigionClass === '6' || rigionClass === '7') {
        this.WINDOW_STANDARD4_THERMAL_TRANS = 4.7
        this.WINDOW_STANDARD4_THERMAL_TRANS_DIS_KIJUNN = '≦4.7'
        if (buzaiSw === 1) {
          this.WINDOW_STANDARD4_SOLARHEAT = 0
          this.WINDOW_STANDARD4_SOLARHEAT_DIS = ''
          this.WINDOW_STANDARD4_SOLARHEAT_DIS_KIJUNN = 'ー'
        } else {
          this.WINDOW_STANDARD4_SOLARHEAT = 0.59
          this.WINDOW_STANDARD4_SOLARHEAT_DIS = '0.59'
          this.WINDOW_STANDARD4_SOLARHEAT_DIS_KIJUNN = '≦0.59'
        }
        this.WINDOW_STANDARD5_THERMAL_TRANS = 2.3
        this.WINDOW_STANDARD5_THERMAL_TRANS_DIS_KIJUNN = '≦2.3'
        if (buzaiSw === 1) {
          this.WINDOW_STANDARD5_SOLARHEAT = 0
          this.WINDOW_STANDARD5_SOLARHEAT_DIS = ''
          this.WINDOW_STANDARD5_SOLARHEAT_DIS_KIJUNN = 'ー'
        } else {
          this.WINDOW_STANDARD5_SOLARHEAT = 0.59
          this.WINDOW_STANDARD5_SOLARHEAT_DIS = '0.59'
          this.WINDOW_STANDARD5_SOLARHEAT_DIS_KIJUNN = '≦0.59'
        }
      }
      if (rigionClass === '8') {
        this.WINDOW_STANDARD4_THERMAL_TRANS = 0
        this.WINDOW_STANDARD4_THERMAL_TRANS_DIS_KIJUNN = 'ー'
        if (buzaiSw === 1) {
          this.WINDOW_STANDARD4_SOLARHEAT = 0
          this.WINDOW_STANDARD4_SOLARHEAT_DIS = ''
          this.WINDOW_STANDARD4_SOLARHEAT_DIS_KIJUNN = 'ー'
        } else {
          this.WINDOW_STANDARD4_SOLARHEAT = 0.53
          this.WINDOW_STANDARD4_SOLARHEAT_DIS = '0.53'
          this.WINDOW_STANDARD4_SOLARHEAT_DIS_KIJUNN = '≦0.53'
        }
        this.WINDOW_STANDARD5_THERMAL_TRANS = 0
        this.WINDOW_STANDARD5_THERMAL_TRANS_DIS_KIJUNN = 'ー'
        if (buzaiSw === 1) {
          this.WINDOW_STANDARD5_SOLARHEAT = 0
          this.WINDOW_STANDARD5_SOLARHEAT_DIS = ''
          this.WINDOW_STANDARD4_SOLARHEAT_DIS_KIJUNN = 'ー'
        } else {
          this.WINDOW_STANDARD5_SOLARHEAT = 0.53
          this.WINDOW_STANDARD5_SOLARHEAT_DIS = '0.53'
          this.WINDOW_STANDARD5_SOLARHEAT_DIS_KIJUNN = '≦0.53'
        }
      }
    },
    standard45HanteiWindow (TXT_THERMAL_TRANS, TXT_SOLARHEAT, HISASHI) {
      // alert('value ' + TXT_THERMAL_TRANS)
      // alert('WINDOW_STANDARD4_THERMAL_TRANS ' + this.WINDOW_STANDARD4_THERMAL_TRANS)
      // alert('WINDOW_STANDARD5_THERMAL_TRANS ' + this.WINDOW_STANDARD5_THERMAL_TRANS)
      const wklist = {}
      wklist.HANTEI_4 = '－'
      wklist.HANTEI_5 = '－'
      let CALX_THERMAL_TRANS = 0
      let CALX_SOLARHEAT = 0
      if (Number.isNaN(Number(TXT_THERMAL_TRANS))) { // 20251212
        CALX_THERMAL_TRANS = 0
      } else {
        CALX_THERMAL_TRANS = Math.round(TXT_THERMAL_TRANS * 10) / 10 // 四捨五入
      }
      if (Number.isNaN(Number(TXT_SOLARHEAT))) { // 20251212
        CALX_SOLARHEAT = 0
      } else {
        CALX_SOLARHEAT = Math.round(TXT_SOLARHEAT * 100) / 100 // 四捨五入
      }
      if (this.rigionPattern === '1') {
        if (this.WINDOW_STANDARD4_THERMAL_TRANS > 0) {
          if (CALX_THERMAL_TRANS > 0) {
            if (CALX_THERMAL_TRANS > this.WINDOW_STANDARD4_THERMAL_TRANS) {
              wklist.HANTEI_4 = '不適'
            } else {
              wklist.HANTEI_4 = '適合'
            }
          }
        }
        if (this.WINDOW_STANDARD5_THERMAL_TRANS > 0) {
          if (CALX_THERMAL_TRANS > 0) {
            if (CALX_THERMAL_TRANS > this.WINDOW_STANDARD5_THERMAL_TRANS) {
              wklist.HANTEI_5 = '不適'
            } else {
              wklist.HANTEI_5 = '適合'
            }
          }
        }
      }
      if (this.rigionPattern === '2') {
        if (this.WINDOW_STANDARD4_THERMAL_TRANS > 0) {
          if (CALX_THERMAL_TRANS > 0) {
            // alert('4 ' + this.WINDOW_STANDARD4_THERMAL_TRANS + ' ' + CALX_THERMAL_TRANS)
            if (CALX_THERMAL_TRANS > this.WINDOW_STANDARD4_THERMAL_TRANS) {
              wklist.HANTEI_4 = '不適'
            } else {
              wklist.HANTEI_4 = '適合' // ひさしありは日射を見ない
              if (HISASHI === '0') { // 20260207
                // alert(CALX_SOLARHEAT + ' ' + this.WINDOW_STANDARD4_SOLARHEAT)
                if (CALX_SOLARHEAT > 0) {
                  // alert(1)
                  if (CALX_SOLARHEAT > this.WINDOW_STANDARD4_SOLARHEAT) {
                    wklist.HANTEI_4 = '不適'
                  } else {
                    wklist.HANTEI_4 = '適合'
                  }
                }
                /* else { // 20260307比べる日射の値が無い場合は、不適とする。
                  wklist.HANTEI_4 = '不適' シート5地域の最後シートのエピソードⅡNEO-Rの判定だけおかしく思う。
                } */
              }
            }
            // alert('4 ' + CALX_SOLARHEAT + ' ' + CALX_THERMAL_TRANS)
          }
        }
        if (this.WINDOW_STANDARD5_THERMAL_TRANS > 0) {
          if (CALX_THERMAL_TRANS > 0) {
            if (CALX_THERMAL_TRANS > this.WINDOW_STANDARD5_THERMAL_TRANS) {
              wklist.HANTEI_5 = '不適'
            } else {
              wklist.HANTEI_5 = '適合' // ひさしありは日射を見ない
              if (HISASHI === '0') { // 20260207
                if (CALX_SOLARHEAT > 0) {
                  if (CALX_SOLARHEAT > this.WINDOW_STANDARD5_SOLARHEAT) {
                    wklist.HANTEI_5 = '不適'
                  } else {
                    wklist.HANTEI_5 = '適合'
                  }
                }
                /* else { // 20260307比べる日射の値が無い場合は、不適とする。
                  wklist.HANTEI_5 = '不適' シート5地域の最後シートのエピソードⅡNEO-Rの判定だけおかしく思う。
                } */
              }
            }
          }
        }
      }
      if (this.rigionPattern === '3') {
        if (CALX_SOLARHEAT > 0) {
          if (CALX_SOLARHEAT > this.WINDOW_STANDARD4_SOLARHEAT) {
            wklist.HANTEI_4 = '不適'
          } else {
            wklist.HANTEI_4 = '適合'
          }
        }
        if (CALX_SOLARHEAT > 0) {
          if (CALX_SOLARHEAT > this.WINDOW_STANDARD5_SOLARHEAT) {
            wklist.HANTEI_5 = '不適'
          } else {
            wklist.HANTEI_5 = '適合'
          }
        }
        if (HISASHI === '1') { // 20260207
          wklist.HANTEI_4 = '適合' // 20260207
          wklist.HANTEI_5 = '適合' // 20260207
        }
      }
      return wklist
    },
    standard45GetDoor (rigionClass) {
      // 基準値の取得
      if (rigionClass === '1' || rigionClass === '2' || rigionClass === '3') {
        this.DOOR_STANDARD4_THERMAL_TRANS = 2.3
        this.DOOR_STANDARD4_THERMAL_TRANS_DIS_KIJUNN = '≦2.3'
        this.DOOR_STANDARD4_SOLARHEAT = 0
        this.DOOR_STANDARD4_SOLARHEAT_DIS = ''
        this.DOOR_STANDARD4_SOLARHEAT_DIS_KIJUNN = 'ー'
        this.DOOR_STANDARD5_THERMAL_TRANS = 1.9
        this.DOOR_STANDARD5_THERMAL_TRANS_DIS_KIJUNN = '≦1.9'
        this.DOOR_STANDARD5_SOLARHEAT = 0
        this.DOOR_STANDARD5_SOLARHEAT_DIS = ''
        this.DOOR_STANDARD5_SOLARHEAT_DIS_KIJUNN = 'ー'
      }
      if (rigionClass === '4') {
        this.DOOR_STANDARD4_THERMAL_TRANS = 3.5
        this.DOOR_STANDARD4_THERMAL_TRANS_DIS_KIJUNN = '≦3.5'
        this.DOOR_STANDARD4_SOLARHEAT = 0
        this.DOOR_STANDARD4_SOLARHEAT_DIS = ''
        this.DOOR_STANDARD4_SOLARHEAT_DIS_KIJUNN = 'ー'
        this.DOOR_STANDARD5_THERMAL_TRANS = 2.3
        this.DOOR_STANDARD5_THERMAL_TRANS_DIS_KIJUNN = '≦2.3'
        this.DOOR_STANDARD5_SOLARHEAT = 0
        this.DOOR_STANDARD5_SOLARHEAT_DIS = ''
        this.DOOR_STANDARD5_SOLARHEAT_DIS_KIJUNN = 'ー'
      }
      if (rigionClass === '5' || rigionClass === '6' || rigionClass === '7') {
        this.DOOR_STANDARD4_THERMAL_TRANS = 4.7
        this.DOOR_STANDARD4_THERMAL_TRANS_DIS_KIJUNN = '≦4.7'
        this.DOOR_STANDARD4_SOLARHEAT = 0
        this.DOOR_STANDARD4_SOLARHEAT_DIS = ''
        this.DOOR_STANDARD4_SOLARHEAT_DIS_KIJUNN = 'ー'
        this.DOOR_STANDARD5_THERMAL_TRANS = 2.3
        this.DOOR_STANDARD5_THERMAL_TRANS_DIS_KIJUNN = '≦2.3'
        this.DOOR_STANDARD5_SOLARHEAT = 0
        this.DOOR_STANDARD5_SOLARHEAT_DIS = ''
        this.DOOR_STANDARD5_SOLARHEAT_DIS_KIJUNN = 'ー'
      }
      if (rigionClass === '8') {
        this.DOOR_STANDARD4_THERMAL_TRANS = 0
        this.DOOR_STANDARD4_THERMAL_TRANS_DIS_KIJUNN = 'ー'
        this.DOOR_STANDARD4_SOLARHEAT = 0
        this.DOOR_STANDARD4_SOLARHEAT_DIS = ''
        this.DOOR_STANDARD4_SOLARHEAT_DIS_KIJUNN = 'ー'
        this.DOOR_STANDARD5_THERMAL_TRANS = 0
        this.DOOR_STANDARD5_THERMAL_TRANS_DIS_KIJUNN = 'ー'
        this.DOOR_STANDARD5_SOLARHEAT = 0
        this.DOOR_STANDARD5_SOLARHEAT_DIS = ''
        this.DOOR_STANDARD5_SOLARHEAT_DIS_KIJUNN = 'ー'
      }
    },
    standard45HanteiDoor (TXT_THERMAL_TRANS, TXT_SOLARHEAT, HISASHI) {
      const wklist = {}
      wklist.HANTEI_4 = '－'
      wklist.HANTEI_5 = '－'
      let CALX_THERMAL_TRANS = 0
      // let CALX_SOLARHEAT = 0
      if (Number.isNaN(Number(TXT_THERMAL_TRANS))) { // 20251212
        CALX_THERMAL_TRANS = 0
      } else {
        CALX_THERMAL_TRANS = Math.round(TXT_THERMAL_TRANS * 10) / 10 // 四捨五入
      }
      /*
      if (Number.isNaN(Number(TXT_SOLARHEAT))) { // 20251212
        CALX_SOLARHEAT = 0
      } else {
        CALX_SOLARHEAT = Math.round(TXT_SOLARHEAT * 10) / 10 // 四捨五入
      }
        */
      if (this.rigionPattern === '1' || this.rigionPattern === '2') {
        if (this.DOOR_STANDARD4_THERMAL_TRANS > 0) {
          if (CALX_THERMAL_TRANS > 0) {
            if (CALX_THERMAL_TRANS > this.DOOR_STANDARD4_THERMAL_TRANS) {
              wklist.HANTEI_4 = '不適'
            } else {
              wklist.HANTEI_4 = '適合'
            }
          }
        }
        if (this.DOOR_STANDARD5_THERMAL_TRANS > 0) {
          if (CALX_THERMAL_TRANS > 0) {
            if (CALX_THERMAL_TRANS > this.DOOR_STANDARD5_THERMAL_TRANS) {
              wklist.HANTEI_5 = '不適'
            } else {
              wklist.HANTEI_5 = '適合'
            }
          }
        }
      }
      /*
      if (this.DOOR_STANDARD4_SOLARHEAT > 0) {
        if (CALX_SOLARHEAT > 0) {
          if (CALX_SOLARHEAT > this.DOOR_STANDARD4_SOLARHEAT) {
            wklist.HANTEI_4 = '不適'
          } else {
            wklist.HANTEI_4 = '適合'
          }
        }
      }
      if (this.DOOR_STANDARD5_SOLARHEAT > 0) {
        if (CALX_SOLARHEAT > 0) {
          if (CALX_SOLARHEAT > this.DOOR_STANDARD5_SOLARHEAT) {
            wklist.HANTEI_5 = '不適'
          } else {
            wklist.HANTEI_5 = '適合'
          }
        }
      }
        */
      return wklist
    },
    shuffleString (str) {
      const arr = str.split('')
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const temp = arr[i]
        arr[i] = arr[j]
        arr[j] = temp
      }
      return arr.join('')
    },
    async pdfcreate () {
      // alert('startDisplay region')
      const auth = useAuthStore()
      // const initYmd1 = auth.initymd
      // alert(initYmd1)
      // const initYmd2 = this.shuffleString(initYmd1 + '' + this.getFormattedDateTime())
      const initYmd2 = this.shuffleString(this.getFormattedDateTime())
      // alert(initYmd2)
      axios.post('/api/pdfcreate', {
        argfolder: initYmd2,
        argdataset: this.pdfDataSet(),
        argtoken: auth.token,
        argrigionpattern: this.rigionPattern,
        argtohanteimethod: this.hanteiMethod,
        argacceptflg: auth.acceptflg
      })
        .then(response => {
          this.results = response.data
          if (this.results.status === 'NG') {
            alert('error ' + this.results.message)
            auth.setBsw('1') // 戻るボタン制御用
            this.$router.push('/about')
          } else {
            /*
            const filename = this.results.filename
            const downloadUrl = `/api/pdfdownload?file=${encodeURIComponent(filename)}`
            window.open(downloadUrl, '_blank')
            */
            alert(this.results.filename)
            // ダウンロード処理を追加
            window.open(this.results.filename, '_blank')
            // zip時
          }
        })
        .catch(error => {
          // this.dialogsw = false
          auth.setBsw('1') // 戻るボタン制御用
          alert('error  ' + error)
          this.$router.push('/about')
        })
    },
    async pdfcreateZip () {
      // alert('startDisplay region')
      const auth = useAuthStore()
      // const initYmd1 = auth.initymd
      // alert(initYmd1)
      // const initYmd2 = this.shuffleString(initYmd1 + '' + this.getFormattedDateTime())
      const initYmd2 = this.shuffleString(this.getFormattedDateTime())
      // alert(initYmd2)
      // const urllist = this.pdfUrlSet()
      // alert(JSON.stringify(urllist))
      this.Loading = true
      axios.post('/api/pdfcreatezip', {
        argfolder: initYmd2,
        argdataset: this.pdfDataSet(),
        argurllist: this.pdfUrlSet(),
        argtoken: auth.token,
        argrigionpattern: this.rigionPattern,
        argtohanteimethod: this.hanteiMethod,
        argacceptflg: auth.acceptflg
      })
        .then(response => {
          this.results = response.data
          if (this.results.status === 'NG') {
            alert('error ' + this.results.message)
            auth.setBsw('1') // 戻るボタン制御用
            this.$router.push('/about')
          } else {
            /*
            const filename = this.results.filename
            const downloadUrl = `/api/pdfdownload?file=${encodeURIComponent(filename)}`
            window.open(downloadUrl, '_blank')
            */
            // alert(this.results.filename)
            this.downloadZip(this.results.filename)
            this.Loading = false
          }
        })
        .catch(error => {
          // this.dialogsw = false
          auth.setBsw('1') // 戻るボタン制御用
          alert('error  ' + error)
          this.$router.push('/about')
        })
    },
    async downloadZip (filenameFromServer) {
      // const response = await fetch('/api/downloadzip')
      const response = await fetch(`/api/downloadzip?file=${encodeURIComponent(filenameFromServer)}`)
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'ダウンロード.zip' // 表示用のファイル名（固定でもOK）
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    countWindowDoor (syu, ix) { // 20260203
      this.countWindow = 0
      this.countDoor = 0
      let notcountsw = 0
      for (let i = 0; i < this.windowResultList.length; i++) {
        notcountsw = 0
        if (syu === 'W' && ix === i) {
          notcountsw = 1
        }
        if (notcountsw === 0) {
          if (this.windowResultList[i].OPNING === '窓') {
            this.countWindow += 1
          }
          if (this.windowResultList[i].OPNING === 'ドア') {
            this.countDoor += 1
          }
        }
      }
      for (let i = 0; i < this.doorResultList.length; i++) {
        notcountsw = 0
        if (syu === 'D' && ix === i) {
          notcountsw = 1
        }
        if (notcountsw === 0) {
          if (this.doorResultList[i].OPNING === '窓') {
            this.countWindow += 1
          }
          if (this.doorResultList[i].OPNING === 'ドア') {
            this.countDoor += 1
          }
        }
      }
    },
    resultDataSet () {
      this.resultSeq = 0
      this.resultWindowList = []
      this.resultDoorList = []
      let wklist = {}
      this.showWindowCardsResult = false
      this.showDoorCardsResult = false
      for (let i = 0; i < this.windowResultList.length; i++) {
        if (this.windowResultList[i].OPNING === '窓') {
          this.resultSeq += 1
          wklist = this.resultWindowToWindowSet(i)
          // alert(JSON.stringify(wklist))
          this.resultWindowList.push(wklist)
          this.showWindowCardsResult = true
        }
      }
      for (let i = 0; i < this.doorResultList.length; i++) {
        if (this.doorResultList[i].OPNING === '窓') {
          this.resultSeq += 1
          wklist = this.resultDoorToWindowSet(i)
          this.resultWindowList.push(wklist)
          this.showWindowCardsResult = true
        }
      }
      this.resultSeq = 0
      for (let i = 0; i < this.windowResultList.length; i++) {
        if (this.windowResultList[i].OPNING === 'ドア') {
          this.resultSeq += 1
          wklist = this.resultWindowToDooRSet(i)
          this.resultDoorList.push(wklist)
          this.showDoorCardsResult = true
        }
      }
      for (let i = 0; i < this.doorResultList.length; i++) {
        if (this.doorResultList[i].OPNING === 'ドア') {
          this.resultSeq += 1
          wklist = this.resultDoorToDooRSet(i)
          this.resultDoorList.push(wklist)
          this.showDoorCardsResult = true
        }
      }
      if (this.inputSW === 1) {
        // alert(0)
        this.resultWindowList.sort((a, b) => a.INPUTSEQ - b.INPUTSEQ)
        this.resultDoorList.sort((a, b) => a.INPUTSEQ - b.INPUTSEQ)
        // alert(1)
        for (let i = 0; i < this.resultWindowList.length; i++) {
          this.resultWindowList[i].SEQ = String(i + 1).padStart(2, '0')
        }
        for (let i = 0; i < this.resultDoorList.length; i++) {
          this.resultDoorList[i].SEQ = String(i + 1).padStart(2, '0')
        }
      }
      // 20260104 各行の対象となる数値を取得する。
      // typeの場合はtype値を撮る。ただしtypeの値が「-」だった場合、EXAMの値をとる。
      // ALLの場合は、typeとEXAMの数値の内、小さいものを取得する。
      for (let i = 0; i < this.resultWindowList.length; i++) {
        this.resultWindowList[i].HANTEI_SYU_THERMAL_TRANS = ''
        if (!Number.isNaN(Number(this.resultWindowList[i].TYPE_THERMAL_TRANS))) {
          this.resultWindowList[i].THERMAL_TRANS_MIN = this.resultWindowList[i].TYPE_THERMAL_TRANS
          this.resultWindowList[i].HANTEI_SYU_THERMAL_TRANS = 'TYPE'
        } else {
          if (!Number.isNaN(Number(this.resultWindowList[i].EXAM_THERMAL_TRANS))) {
            this.resultWindowList[i].THERMAL_TRANS_MIN = this.resultWindowList[i].EXAM_THERMAL_TRANS
            this.resultWindowList[i].HANTEI_SYU_THERMAL_TRANS = 'EXAM'
          } else {
            this.resultWindowList[i].THERMAL_TRANS_MIN = 0
            this.resultWindowList[i].HANTEI_SYU_THERMAL_TRANS = ''
          }
        }
        this.resultWindowList[i].HANTEI_SYU_SOLARHEAT = ''
        if (!Number.isNaN(Number(this.resultWindowList[i].TYPE_SOLARHEAT))) {
          this.resultWindowList[i].SOLARHEAT_MIN = this.resultWindowList[i].TYPE_SOLARHEAT
          this.resultWindowList[i].HANTEI_SYU_SOLARHEAT = 'TYPE'
        } else {
          if (!Number.isNaN(Number(this.resultWindowList[i].EXAM_SOLARHEAT))) {
            this.resultWindowList[i].SOLARHEAT_MIN = this.resultWindowList[i].EXAM_SOLARHEAT
            this.resultWindowList[i].HANTEI_SYU_SOLARHEAT = 'EXAM'
          } else {
            this.resultWindowList[i].SOLARHEAT_MIN = 0
            this.resultWindowList[i].HANTEI_SYU_SOLARHEAT = ''
          }
        }
        if (this.hanteiMethod !== 'TYPE') {
          // this.resultWindowList[i].HANTEI_SYU_THERMAL_TRANS = ''
          if (!Number.isNaN(Number(this.resultWindowList[i].EXAM_THERMAL_TRANS))) {
            if (this.resultWindowList[i].EXAM_THERMAL_TRANS < this.resultWindowList[i].THERMAL_TRANS_MIN) {
              this.resultWindowList[i].THERMAL_TRANS_MIN = this.resultWindowList[i].EXAM_THERMAL_TRANS
              this.resultWindowList[i].HANTEI_SYU_THERMAL_TRANS = 'EXAM'
            }
          }
          // this.resultWindowList[i].HANTEI_SYU_SOLARHEAT = ''
          if (!Number.isNaN(Number(this.resultWindowList[i].EXAM_SOLARHEAT))) {
            if (this.resultWindowList[i].EXAM_SOLARHEAT < this.resultWindowList[i].SOLARHEAT_MIN) {
              this.resultWindowList[i].SOLARHEAT_MIN = this.resultWindowList[i].EXAM_SOLARHEAT
              this.resultWindowList[i].HANTEI_SYU_SOLARHEAT = 'EXAM'
            }
          }
        }
      }
      this.resultDisplay = {}
      this.resultDisplay.WINDOW_NO1 = ''
      this.resultDisplay.WINDOW_EXIST1 = 'なし'
      this.resultDisplay.WINDOW_THERMAL_TRANS1 = ''
      this.resultDisplay.WINDOW_SOLARHEAT1 = ''
      this.resultDisplay.WINDOW_HANTEI4_1 = '該当窓なし'
      this.resultDisplay.WINDOW_HANTEI5_1 = '該当窓なし'
      // this.resultDisplay.WINDOW_HANTEI_SYU_1 = ''
      this.resultDisplay.WINDOW_HANTEI_SYU_NM_1 = ['']
      // -----
      this.resultDisplay.WINDOW_NO2 = ''
      this.resultDisplay.WINDOW_EXIST2 = 'なし'
      this.resultDisplay.WINDOW_THERMAL_TRANS2 = ''
      this.resultDisplay.WINDOW_SOLARHEAT2 = ''
      this.resultDisplay.WINDOW_HANTEI4_2 = '該当窓なし'
      this.resultDisplay.WINDOW_HANTEI5_2 = '該当窓なし'
      // this.resultDisplay.WINDOW_HANTEI_SYU_2 = ''
      this.resultDisplay.WINDOW_HANTEI_SYU_NM_2 = ['']
      // -----
      this.resultDisplay.WINDOW_NO3 = ''
      this.resultDisplay.WINDOW_EXIST3 = 'なし'
      this.resultDisplay.WINDOW_THERMAL_TRANS3 = ''
      this.resultDisplay.WINDOW_SOLARHEAT3 = ''
      this.resultDisplay.WINDOW_HANTEI4_3 = '該当窓なし'
      this.resultDisplay.WINDOW_HANTEI5_3 = '該当窓なし'
      // this.resultDisplay.WINDOW_HANTEI_SYU_3 = ''
      this.resultDisplay.WINDOW_HANTEI_SYU_NM_3 = ['']
      // -----
      // ---
      this.resultDisplay.STANDARD4_THERMAL_TRANS1 = ''
      this.resultDisplay.STANDARD4_SOLARHEAT1 = ''
      this.resultDisplay.STANDARD5_THERMAL_TRANS1 = ''
      this.resultDisplay.STANDARD5_SOLARHEAT1 = ''
      this.resultDisplay.STANDARD4_THERMAL_TRANS2 = ''
      this.resultDisplay.STANDARD4_SOLARHEAT2 = ''
      this.resultDisplay.STANDARD5_THERMAL_TRANS2 = ''
      this.resultDisplay.STANDARD5_SOLARHEAT2 = ''
      this.resultDisplay.STANDARD4_THERMAL_TRANS3 = ''
      this.resultDisplay.STANDARD4_SOLARHEAT3 = ''
      this.resultDisplay.STANDARD5_THERMAL_TRANS3 = ''
      this.resultDisplay.STANDARD5_SOLARHEAT3 = ''
      // ---
      this.resultDisplay.WINDOW_PDF_TYPE1_1 = ''
      this.resultDisplay.WINDOW_PDF_TYPE2_1 = ''
      this.resultDisplay.WINDOW_PDF_TYPE3_1 = ''
      this.resultDisplay.WINDOW_PDF_TYPE4_1 = ''
      this.resultDisplay.WINDOW_PDF_TYPE1_2 = ''
      this.resultDisplay.WINDOW_PDF_TYPE2_2 = ''
      this.resultDisplay.WINDOW_PDF_TYPE3_2 = ''
      this.resultDisplay.WINDOW_PDF_TYPE4_2 = ''
      this.resultDisplay.WINDOW_PDF_TYPE1_3 = ''
      this.resultDisplay.WINDOW_PDF_TYPE2_3 = ''
      this.resultDisplay.WINDOW_PDF_TYPE3_3 = ''
      this.resultDisplay.WINDOW_PDF_TYPE4_3 = ''
      // ---
      this.resultDisplay.WINDOW_BIKOU_1 = ['']
      this.resultDisplay.WINDOW_BIKOU_2 = ['']
      this.resultDisplay.WINDOW_BIKOU_3 = ['']
      this.resultDisplay.WINDOW_BIKOUADDRESS_1 = ['']
      this.resultDisplay.WINDOW_BIKOUADDRESS_2 = ['']
      this.resultDisplay.WINDOW_BIKOUADDRESS_3 = ['']
      // 窓からさがす
      let hisashiMax1 = 0
      let hisashiMaxNo1 = -1
      let hisashiMax2 = 0
      let nishaMax2 = 0
      let max2sw = 0
      let hisashiMaxNo2 = -1
      let hisashiMax3 = 0
      let nishaMax3 = 0
      let max3sw = 0
      let hisashiMaxNo3 = -1
      let returnList = {}
      for (let i = 0; i < this.resultWindowList.length; i++) {
        // ひさしありで熱貫流率が一番大きい物を探す
        if (this.resultWindowList[i].HISASHI === 'あり') {
          if (this.rigionClass === '8') { // 20260204
            if (hisashiMaxNo1 === -1) { // 8地域では最初のひさしありをセットする。
              hisashiMax1 = Number(this.resultWindowList[i].THERMAL_TRANS_MIN)
              hisashiMaxNo1 = i
              this.resultDisplay.WINDOW_EXIST1 = 'あり'
              this.resultDisplay.WINDOW_NO1 = this.resultWindowList[i].SEQ
              this.resultDisplay.WINDOW_THERMAL_TRANS1 = this.resultWindowList[i].THERMAL_TRANS_MIN
              this.resultDisplay.WINDOW_SOLARHEAT1 = this.resultWindowList[i].SOLARHEAT_MIN
              // this.resultDisplay.WINDOW_HANTEI_SYU_1 = this.resultWindowList[i].HANTEI_SYU_SOLARHEAT
              returnList = this.windowHanteiMsgSet(this.resultWindowList[i])
              this.resultDisplay.WINDOW_HANTEI_SYU_NM_1 = returnList.msg
              this.resultDisplay.WINDOW_PDF_TYPE1_1 = this.pdftypeNoneSet(returnList.pdfType1) // 20260204
              this.resultDisplay.WINDOW_PDF_TYPE2_1 = this.pdftypeNoneSet(returnList.pdfType2) // 20260204
              this.resultDisplay.WINDOW_PDF_TYPE3_1 = this.pdftypeNoneSet(returnList.pdfType3) // 20260204
              this.resultDisplay.WINDOW_PDF_TYPE4_1 = this.pdftypeNoneSet(returnList.pdfType4) // 20260204
              this.resultDisplay.WINDOW_BIKOU_1 = returnList.bikou
              this.resultDisplay.WINDOW_BIKOUADDRESS_1 = returnList.bikouaddress
            }
          } else { // 8地域以外は熱貫流率が一番大きい物を探す
            if (this.resultWindowList[i].THERMAL_TRANS_MIN > hisashiMax1) {
              // alert(i + ' ' + this.resultWindowList[i].THERMAL_TRANS_MIN)
              hisashiMax1 = Number(this.resultWindowList[i].THERMAL_TRANS_MIN)
              hisashiMaxNo1 = i
              this.resultDisplay.WINDOW_EXIST1 = 'あり'
              this.resultDisplay.WINDOW_NO1 = this.resultWindowList[i].SEQ
              this.resultDisplay.WINDOW_THERMAL_TRANS1 = this.resultWindowList[i].THERMAL_TRANS_MIN
              this.resultDisplay.WINDOW_SOLARHEAT1 = this.resultWindowList[i].SOLARHEAT_MIN
              // this.resultDisplay.WINDOW_HANTEI_SYU_1 = this.resultWindowList[i].HANTEI_SYU_SOLARHEAT
              returnList = this.windowHanteiMsgSet(this.resultWindowList[i])
              this.resultDisplay.WINDOW_HANTEI_SYU_NM_1 = returnList.msg
              this.resultDisplay.WINDOW_PDF_TYPE1_1 = this.pdftypeNoneSet(returnList.pdfType1) // 20260204
              this.resultDisplay.WINDOW_PDF_TYPE2_1 = this.pdftypeNoneSet(returnList.pdfType2) // 20260204
              this.resultDisplay.WINDOW_PDF_TYPE3_1 = this.pdftypeNoneSet(returnList.pdfType3) // 20260204
              this.resultDisplay.WINDOW_PDF_TYPE4_1 = this.pdftypeNoneSet(returnList.pdfType4) // 20260204
              this.resultDisplay.WINDOW_BIKOU_1 = returnList.bikou
              this.resultDisplay.WINDOW_BIKOUADDRESS_1 = returnList.bikouaddress
            }
          }
        } else { // ひさし無し
          // 熱貫流率最大
          max2sw = 0
          if (Number(this.resultWindowList[i].THERMAL_TRANS_MIN) > Number(hisashiMax2)) {
            max2sw = 1
          }
          if (Number(this.resultWindowList[i].THERMAL_TRANS_MIN) === Number(hisashiMax2)) {
            // alert('イコール')
            if (this.rigionPattern === '2') { // 20260311 地域5-7のみ処理
              if (Number(this.resultWindowList[i].SOLARHEAT_MIN) > Number(nishaMax2)) {
                max2sw = 1
              }
            }
          }
          // alert(max2sw + '  ' + this.resultWindowList[i].THERMAL_TRANS_MIN + '  ' + this.resultWindowList[i].SOLARHEAT_MIN)
          // alert(hisashiMax2 + '  ' + nishaMax2)
          if (max2sw === 1) {
            hisashiMax2 = Number(this.resultWindowList[i].THERMAL_TRANS_MIN)
            nishaMax2 = Number(this.resultWindowList[i].SOLARHEAT_MIN)
            hisashiMaxNo2 = i
            this.resultDisplay.WINDOW_EXIST2 = 'あり'
            this.resultDisplay.WINDOW_NO2 = this.resultWindowList[i].SEQ
            this.resultDisplay.WINDOW_THERMAL_TRANS2 = this.resultWindowList[i].THERMAL_TRANS_MIN
            this.resultDisplay.WINDOW_SOLARHEAT2 = this.resultWindowList[i].SOLARHEAT_MIN
            // this.resultDisplay.WINDOW_HANTEI_SYU_2 = this.resultWindowList[i].HANTEI_SYU_THERMAL_TRANS
            returnList = this.windowHanteiMsgSet(this.resultWindowList[i])
            this.resultDisplay.WINDOW_HANTEI_SYU_NM_2 = returnList.msg
            this.resultDisplay.WINDOW_PDF_TYPE1_2 = this.pdftypeNoneSet(returnList.pdfType1) // 20260204
            this.resultDisplay.WINDOW_PDF_TYPE2_2 = this.pdftypeNoneSet(returnList.pdfType2) // 20260204
            this.resultDisplay.WINDOW_PDF_TYPE3_2 = this.pdftypeNoneSet(returnList.pdfType3) // 20260204
            this.resultDisplay.WINDOW_PDF_TYPE4_2 = this.pdftypeNoneSet(returnList.pdfType4) // 20260204
            this.resultDisplay.WINDOW_BIKOU_2 = returnList.bikou
            this.resultDisplay.WINDOW_BIKOUADDRESS_2 = returnList.bikouaddress
          }
          // 日射最大
          max3sw = 0
          if (Number(this.resultWindowList[i].SOLARHEAT_MIN) > Number(nishaMax3)) {
            max3sw = 1
          }
          if (Number(this.resultWindowList[i].SOLARHEAT_MIN) === Number(nishaMax3)) {
            if (this.rigionPattern === '2') { // 20260311 地域5-7のみ処理
              if (Number(this.resultWindowList[i].THERMAL_TRANS_MIN) > Number(hisashiMax3)) {
                max3sw = 1
              }
            }
          }
          if (max3sw === 1) {
            hisashiMax3 = Number(this.resultWindowList[i].THERMAL_TRANS_MIN)
            nishaMax3 = Number(this.resultWindowList[i].SOLARHEAT_MIN)
            hisashiMaxNo3 = i
            this.resultDisplay.WINDOW_EXIST3 = 'あり'
            this.resultDisplay.WINDOW_NO3 = this.resultWindowList[i].SEQ
            this.resultDisplay.WINDOW_THERMAL_TRANS3 = this.resultWindowList[i].THERMAL_TRANS_MIN
            this.resultDisplay.WINDOW_SOLARHEAT3 = this.resultWindowList[i].SOLARHEAT_MIN
            // this.resultDisplay.WINDOW_HANTEI_SYU_3 = this.resultWindowList[i].HANTEI_SYU_SOLARHEAT
            returnList = this.windowHanteiMsgSet(this.resultWindowList[i])
            this.resultDisplay.WINDOW_HANTEI_SYU_NM_3 = returnList.msg
            this.resultDisplay.WINDOW_PDF_TYPE1_3 = this.pdftypeNoneSet(returnList.pdfType1) // 20260204
            this.resultDisplay.WINDOW_PDF_TYPE2_3 = this.pdftypeNoneSet(returnList.pdfType2) // 20260204
            this.resultDisplay.WINDOW_PDF_TYPE3_3 = this.pdftypeNoneSet(returnList.pdfType3) // 20260204
            this.resultDisplay.WINDOW_PDF_TYPE4_3 = this.pdftypeNoneSet(returnList.pdfType4) // 20260204
            this.resultDisplay.WINDOW_BIKOU_3 = returnList.bikou
            this.resultDisplay.WINDOW_BIKOUADDRESS_3 = returnList.bikouaddress
          }
        }
      }
      // 1～3でを判定する。
      if (this.rigionClass === '8') { // 20260110
        this.resultDisplay.WINDOW_HANTEI4_1 = '該当窓なし'
        this.resultDisplay.WINDOW_HANTEI5_1 = '該当窓なし'
      }
      let resultHan
      if (hisashiMaxNo1 > -1) {
        resultHan = this.standard45HanteiWindow(this.resultDisplay.WINDOW_THERMAL_TRANS1, this.resultDisplay.WINDOW_SOLARHEAT1, '1') // 20260311
        this.resultDisplay.WINDOW_HANTEI4_1 = resultHan.HANTEI_4 // 等級4
        this.resultDisplay.WINDOW_HANTEI5_1 = resultHan.HANTEI_5 // 等級4
        this.resultDisplay.STANDARD4_THERMAL_TRANS1 = this.standardTextAdd(this.WINDOW_STANDARD4_THERMAL_TRANS)
        this.resultDisplay.STANDARD4_SOLARHEAT1 = this.standardTextAdd(this.WINDOW_STANDARD4_SOLARHEAT_DIS)
        this.resultDisplay.STANDARD5_THERMAL_TRANS1 = this.standardTextAdd(this.WINDOW_STANDARD5_THERMAL_TRANS)
        this.resultDisplay.STANDARD5_SOLARHEAT1 = this.standardTextAdd(this.WINDOW_STANDARD5_SOLARHEAT_DIS)
        if (!Number.isNaN(Number(this.resultDisplay.WINDOW_THERMAL_TRANS1))) { // 20251218
          this.resultDisplay.WINDOW_THERMAL_TRANS1 = (Math.round(this.resultDisplay.WINDOW_THERMAL_TRANS1 * 10) / 10).toFixed(1) // 四捨五入
        }
        if (!Number.isNaN(Number(this.resultDisplay.WINDOW_SOLARHEAT1))) { // 20251218
          // 20251222指摘により修正this.resultDisplay.WINDOW_SOLARHEAT1 = Math.round(this.resultDisplay.WINDOW_SOLARHEAT1 * 10) / 10 // 四捨五入
          this.resultDisplay.WINDOW_SOLARHEAT1 = (Math.round(this.resultDisplay.WINDOW_SOLARHEAT1 * 100) / 100).toFixed(2) // 四捨五入
        }
        if (this.rigionClass === '8') { // 20260110
          this.resultDisplay.WINDOW_HANTEI4_1 = '該当窓あり'
          this.resultDisplay.WINDOW_HANTEI5_1 = '該当窓あり'
        }
      }
      if (hisashiMaxNo2 > -1) {
        resultHan = this.standard45HanteiWindow(this.resultDisplay.WINDOW_THERMAL_TRANS2, this.resultDisplay.WINDOW_SOLARHEAT2, '0') // 20260311
        this.resultDisplay.WINDOW_HANTEI4_2 = resultHan.HANTEI_4 // 等級4
        this.resultDisplay.WINDOW_HANTEI5_2 = resultHan.HANTEI_5 // 等級4
        this.resultDisplay.STANDARD4_THERMAL_TRANS2 = this.standardTextAdd(this.WINDOW_STANDARD4_THERMAL_TRANS)
        this.resultDisplay.STANDARD4_SOLARHEAT2 = this.standardTextAdd(this.WINDOW_STANDARD4_SOLARHEAT_DIS)
        this.resultDisplay.STANDARD5_THERMAL_TRANS2 = this.standardTextAdd(this.WINDOW_STANDARD5_THERMAL_TRANS)
        this.resultDisplay.STANDARD5_SOLARHEAT2 = this.standardTextAdd(this.WINDOW_STANDARD5_SOLARHEAT_DIS)
        if (!Number.isNaN(Number(this.resultDisplay.WINDOW_THERMAL_TRANS2))) { // 20251218
          this.resultDisplay.WINDOW_THERMAL_TRANS2 = (Math.round(this.resultDisplay.WINDOW_THERMAL_TRANS2 * 10) / 10).toFixed(1) // 四捨五入
        }
        if (!Number.isNaN(Number(this.resultDisplay.WINDOW_SOLARHEAT2))) { // 20251218
          // 20251222指摘により修正this.resultDisplay.WINDOW_SOLARHEAT2 = Math.round(this.resultDisplay.WINDOW_SOLARHEAT2 * 10) / 10 // 四捨五入
          this.resultDisplay.WINDOW_SOLARHEAT2 = (Math.round(this.resultDisplay.WINDOW_SOLARHEAT2 * 100) / 100).toFixed(2) // 四捨五入
        }
      }
      if (hisashiMaxNo3 > -1) {
        resultHan = this.standard45HanteiWindow(this.resultDisplay.WINDOW_THERMAL_TRANS3, this.resultDisplay.WINDOW_SOLARHEAT3, '0') // 20260311
        this.resultDisplay.WINDOW_HANTEI4_3 = resultHan.HANTEI_4 // 等級4
        this.resultDisplay.WINDOW_HANTEI5_3 = resultHan.HANTEI_5 // 等級4
        this.resultDisplay.STANDARD4_THERMAL_TRANS3 = this.standardTextAdd(this.WINDOW_STANDARD4_THERMAL_TRANS)
        this.resultDisplay.STANDARD4_SOLARHEAT3 = this.standardTextAdd(this.WINDOW_STANDARD4_SOLARHEAT_DIS)
        this.resultDisplay.STANDARD5_THERMAL_TRANS3 = this.standardTextAdd(this.WINDOW_STANDARD5_THERMAL_TRANS)
        this.resultDisplay.STANDARD5_SOLARHEAT3 = this.standardTextAdd(this.WINDOW_STANDARD5_SOLARHEAT_DIS)
        if (!Number.isNaN(Number(this.resultDisplay.WINDOW_THERMAL_TRANS3))) { // 20251218
          this.resultDisplay.WINDOW_THERMAL_TRANS3 = (Math.round(this.resultDisplay.WINDOW_THERMAL_TRANS3 * 10) / 10).toFixed(1) // 四捨五入
        }
        if (!Number.isNaN(Number(this.resultDisplay.WINDOW_SOLARHEAT3))) { // 20251218
          // 20251222指摘により修正this.resultDisplay.WINDOW_SOLARHEAT3 = Math.round(this.resultDisplay.WINDOW_SOLARHEAT3 * 10) / 10 // 四捨五入
          this.resultDisplay.WINDOW_SOLARHEAT3 = (Math.round(this.resultDisplay.WINDOW_SOLARHEAT3 * 100) / 100).toFixed(2) // 四捨五入
        }
      }
      // ----------------------------------ドア
      for (let i = 0; i < this.resultDoorList.length; i++) {
        this.resultDoorList[i].HANTEI_SYU_THERMAL_TRANS = ''
        if (!Number.isNaN(Number(this.resultDoorList[i].TYPE_THERMAL_TRANS))) {
          this.resultDoorList[i].THERMAL_TRANS_MIN = this.resultDoorList[i].TYPE_THERMAL_TRANS
          this.resultDoorList[i].HANTEI_SYU_THERMAL_TRANS = 'TYPE'
        } else {
          if (!Number.isNaN(Number(this.resultDoorList[i].EXAM_THERMAL_TRANS))) {
            this.resultDoorList[i].THERMAL_TRANS_MIN = this.resultDoorList[i].EXAM_THERMAL_TRANS
            this.resultDoorList[i].HANTEI_SYU_THERMAL_TRANS = 'EXAM'
          } else {
            this.resultDoorList[i].THERMAL_TRANS_MIN = 0
            this.resultDoorList[i].HANTEI_SYU_THERMAL_TRANS = ''
          }
        }
        this.resultDoorList[i].HANTEI_SYU_SOLARHEAT = ''
        if (!Number.isNaN(Number(this.resultDoorList[i].TYPE_SOLARHEAT))) {
          this.resultDoorList[i].SOLARHEAT_MIN = this.resultDoorList[i].TYPE_SOLARHEAT
          this.resultDoorList[i].HANTEI_SYU_SOLARHEAT = 'TYPE'
        } else {
          if (!Number.isNaN(Number(this.resultDoorList[i].EXAM_SOLARHEAT))) {
            this.resultDoorList[i].SOLARHEAT_MIN = this.resultDoorList[i].EXAM_SOLARHEAT
            this.resultDoorList[i].HANTEI_SYU_SOLARHEAT = 'EXAM'
          } else {
            this.resultDoorList[i].SOLARHEAT_MIN = 0
            this.resultDoorList[i].HANTEI_SYU_SOLARHEAT = ''
          }
        }
        if (this.hanteiMethod !== 'TYPE') {
          if (!Number.isNaN(Number(this.resultDoorList[i].EXAM_THERMAL_TRANS))) {
            if (this.resultDoorList[i].EXAM_THERMAL_TRANS < this.resultDoorList[i].THERMAL_TRANS_MIN) {
              this.resultDoorList[i].THERMAL_TRANS_MIN = this.resultDoorList[i].EXAM_THERMAL_TRANS
              this.resultDoorList[i].HANTEI_SYU_THERMAL_TRANS = 'EXAM'
            }
          }
          if (!Number.isNaN(Number(this.resultDoorList[i].EXAM_SOLARHEAT))) {
            if (this.resultDoorList[i].EXAM_SOLARHEAT < this.resultDoorList[i].SOLARHEAT_MIN) {
              this.resultDoorList[i].SOLARHEAT_MIN = this.resultDoorList[i].EXAM_SOLARHEAT
              this.resultDoorList[i].HANTEI_SYU_SOLARHEAT = 'EXAM'
            }
          }
        }
      }
      this.resultDisplay.DOOR_NO = ''
      this.resultDisplay.DOOR_EXIST = 'なし'
      this.resultDisplay.DOOR_THERMAL_TRANS = ''
      this.resultDisplay.DOOR_SOLARHEAT = ''
      this.resultDisplay.DOOR_HANTEI4 = '該当ドアなし'
      this.resultDisplay.DOOR_HANTEI5 = '該当ドアなし'
      this.resultDisplay.STANDARD4_THERMAL_TRANSD = ''
      this.resultDisplay.STANDARD5_THERMAL_TRANSD = ''
      this.resultDisplay.DOOR_HANTEI_SYU = ''
      this.resultDisplay.DOOR_HANTEI_SYU_NM = ['']
      this.resultDisplay.DOOR_PDF_TYPE1 = ''
      this.resultDisplay.DOOR_PDF_TYPE2 = ''
      this.resultDisplay.DOOR_PDF_TYPE3 = ''
      this.resultDisplay.DOOR_PDF_TYPE4 = ''
      this.resultDisplay.DOOR_BIKOU = ['']
      this.resultDisplay.DOOR_BIKOUADDRESS = ['']
      let hisashiMax = 0
      let hisashiMaxNo = -1
      // alert(0)
      for (let i = 0; i < this.resultDoorList.length; i++) {
        if (this.resultDoorList[i].THERMAL_TRANS_MIN > hisashiMax) {
          hisashiMax = Number(this.resultDoorList[i].THERMAL_TRANS_MIN)
          hisashiMaxNo = i
          this.resultDisplay.DOOR_EXIST = 'あり'
          this.resultDisplay.DOOR_NO = this.resultDoorList[i].SEQ
          this.resultDisplay.DOOR_THERMAL_TRANS = this.resultDoorList[i].THERMAL_TRANS_MIN
          this.resultDisplay.DOOR_SOLARHEAT = this.resultDoorList[i].SOLARHEAT_MIN
          // this.resultDisplay.DOOR_HANTEI_SYU = this.resultDoorList[i].HANTEI_SYU_THERMAL_TRANS
          returnList = this.doorHanteiMsgSet(this.resultDoorList[i])
          this.resultDisplay.DOOR_HANTEI_SYU_NM = returnList.msg
          this.resultDisplay.DOOR_PDF_TYPE1 = this.pdftypeNoneSet(returnList.pdfType1) // 20260204
          this.resultDisplay.DOOR_PDF_TYPE2 = this.pdftypeNoneSet(returnList.pdfType2) // 20260204
          this.resultDisplay.DOOR_PDF_TYPE3 = this.pdftypeNoneSet(returnList.pdfType3) // 20260204
          this.resultDisplay.DOOR_PDF_TYPE4 = this.pdftypeNoneSet(returnList.pdfType4) // 20260204
          this.resultDisplay.DOOR_BIKOU = returnList.bikou
          this.resultDisplay.DOOR_BIKOUADDRESS = returnList.bikouaddress
        }
      }
      if (hisashiMaxNo > -1) {
        resultHan = this.standard45HanteiDoor(this.resultDisplay.DOOR_THERMAL_TRANS, this.resultDisplay.DOOR_SOLARHEAT, 0)
        this.resultDisplay.DOOR_HANTEI4 = resultHan.HANTEI_4 // 等級4
        this.resultDisplay.DOOR_HANTEI5 = resultHan.HANTEI_5 // 等級4
        this.resultDisplay.STANDARD4_THERMAL_TRANSD = this.standardTextAdd(this.DOOR_STANDARD4_THERMAL_TRANS)
        this.resultDisplay.STANDARD5_THERMAL_TRANSD = this.standardTextAdd(this.DOOR_STANDARD5_THERMAL_TRANS)
        if (!Number.isNaN(Number(this.resultDisplay.DOOR_THERMAL_TRANS))) { // 20251218
          this.resultDisplay.DOOR_THERMAL_TRANS = (Math.round(this.resultDisplay.DOOR_THERMAL_TRANS * 10) / 10).toFixed(1) // 四捨五入
        }
        if (!Number.isNaN(Number(this.resultDisplay.DOOR_SOLARHEAT))) { // 20251218
          // 20251222指摘により修正this.resultDisplay.DOOR_SOLARHEAT = Math.round(this.resultDisplay.DOOR_SOLARHEAT * 10) / 10 // 四捨五入
          this.resultDisplay.DOOR_SOLARHEAT = (Math.round(this.resultDisplay.DOOR_SOLARHEAT * 100) / 100).toFixed(2) // 四捨五入
        }
      }
      // 基準等
      this.resultDisplay.WS4_THERMAL_TRANS_KIJUNN = this.WINDOW_STANDARD4_THERMAL_TRANS_DIS_KIJUNN
      this.resultDisplay.WS5_THERMAL_TRANS_KIJUNN = this.WINDOW_STANDARD5_THERMAL_TRANS_DIS_KIJUNN
      this.resultDisplay.WS4_SOLARHEAT_KIJUNN = this.WINDOW_STANDARD4_SOLARHEAT_DIS_KIJUNN
      this.resultDisplay.WS5_SOLARHEAT_KIJUNN = this.WINDOW_STANDARD5_SOLARHEAT_DIS_KIJUNN
      this.resultDisplay.DS4_THERMAL_TRANS_KIJUNN = this.DOOR_STANDARD4_THERMAL_TRANS_DIS_KIJUNN
      this.resultDisplay.DS5_THERMAL_TRANS_KIJUNN = this.DOOR_STANDARD5_THERMAL_TRANS_DIS_KIJUNN
      this.resultDisplay.DS4_SOLARHEAT_KIJUNN = this.DOOR_STANDARD4_SOLARHEAT_DIS_KIJUNN
      this.resultDisplay.DS5_SOLARHEAT_KIJUNN = this.DOOR_STANDARD5_SOLARHEAT_DIS_KIJUNN
      this.resultDisplay.RIGIONCLASS = this.rigionClass + '地域' // 20260207
    },
    pdftypeNoneSet (x1) {
      if (x1 === '無') {
        return ''
      }
      return x1
    },
    standardTextAdd (x1) {
      if (x1 === '') {
        return '－'
      } else {
        return '≦' + x1
      }
    },
    windowHanteiMsgSet (object) {
      // alert('rigionPattern ' + this.rigionPattern + '   [' + object.HISASHI + ']')
      const returnList = {}
      returnList.msg = []
      returnList.pdfType1 = ''
      returnList.pdfType2 = ''
      returnList.pdfType3 = ''
      returnList.pdfType4 = ''
      returnList.bikou = []
      returnList.bikouaddress = []
      const wklist = []
      let wkbikou = []
      // 地域1-4 日射を見ない
      if (this.rigionPattern === '1') {
        if (object.HANTEI_SYU_THERMAL_TRANS === 'TYPE') {
          wklist.push('建具とガラスの組み合わせ')
          returnList.msg = wklist
          returnList.pdfType1 = object.PDF_TYPE1
          returnList.pdfType2 = object.PDF_TYPE2
          returnList.pdfType3 = object.PDF_TYPE3
          returnList.pdfType4 = object.PDF_TYPE4
          if (object.HISASHI === 'なし') {
            if (object.PDF_DECLRATION1234567 !== '無') {
              wkbikou.push(object.PDF_DECLRATION1234567)
              returnList.bikou.push(wkbikou)
              returnList.bikouaddress.push(this.urltextbikouSetType(object.PDF_DECLRATION1234567))
            }
            // wkbikou = []
            // wkbikou.push('開口部の熱貫流率と日射熱取得率（玄関ドア・引戸）')
            // returnList.bikou.push(wkbikou)
            // returnList.bikouaddress.push(this.urltextbikouSetType('開口部の熱貫流率と日射熱取得率（玄関ドア・引戸）'))
          } else {
            wkbikou = []
            // 開口部の熱貫流率（窓・框ドア・引戸）
            if (object.PDF_DECLRATION1234567 !== '無') {
              wkbikou.push(object.PDF_DECLRATION1234567)
              returnList.bikou.push(wkbikou)
              returnList.bikouaddress.push(this.urltextbikouSetType(object.PDF_DECLRATION1234567))
            }
          }
        }
        if (object.HANTEI_SYU_THERMAL_TRANS === 'EXAM') {
          wklist.push('自己適合宣言書・附属書')
          returnList.msg = wklist
          wkbikou = []
          wkbikou.push(object.SERIES)
          returnList.bikou.push(wkbikou)
          returnList.bikouaddress.push('')
          wkbikou = []
          wkbikou.push('附属書№：')
          wkbikou.push(object.SELF_DECLRATION_NO)
          if (object.SELF_DECLRATION_ID === '無' || object.SELF_DECLRATION_ID === '－') {
            wkbikou.push('')
          } else {
            wkbikou.push('(区分記号：' + object.SELF_DECLRATION_ID + ')')
          }
          returnList.bikou.push(wkbikou)
          // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION_NO + '.pdf')
          returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION_NO))
          wkbikou = []
          wkbikou.push('自己適合宣言書：')
          wkbikou.push(object.SELF_DECLRATION)
          returnList.bikou.push(wkbikou)
          // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION + '.pdf')
          returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION))
        }
      }
      // 地域5-7
      if (this.rigionPattern === '2' && object.HISASHI !== 'なし') { // ひさしあり 日射を見ない
        if (object.HANTEI_SYU_THERMAL_TRANS === 'TYPE') {
          wklist.push('建具とガラスの組み合わせ')
          returnList.msg = wklist
          returnList.pdfType1 = object.PDF_TYPE1
          returnList.pdfType2 = object.PDF_TYPE2
          returnList.pdfType3 = object.PDF_TYPE3
          returnList.pdfType4 = object.PDF_TYPE4
          wkbikou = []
          if (object.PDF_DECLRATION1234567 !== '無') { // 20260311
            wkbikou.push(object.PDF_DECLRATION1234567) // 20260311
            returnList.bikou.push(wkbikou) // 20260311
            returnList.bikouaddress.push(this.urltextbikouSetType(object.PDF_DECLRATION1234567)) // 20260311
          }
          // 20260311 wkbikou.push('開口部の熱貫流率（窓・框ドア・引戸）')
          // 20260311 returnList.bikou.push(wkbikou)
          // 20260311 returnList.bikouaddress.push(this.urltextbikouSetType('開口部の熱貫流率（窓・框ドア・引戸）'))
        }
        if (object.HANTEI_SYU_THERMAL_TRANS === 'EXAM') {
          wklist.push('自己適合宣言書・附属書')
          returnList.msg = wklist
          wkbikou = []
          wkbikou.push(object.SERIES)
          returnList.bikou.push(wkbikou)
          returnList.bikouaddress.push('')
          wkbikou = []
          wkbikou.push('附属書№：')
          wkbikou.push(object.SELF_DECLRATION_NO)
          if (object.SELF_DECLRATION_ID === '無' || object.SELF_DECLRATION_ID === '－') {
            wkbikou.push('')
          } else {
            wkbikou.push('(区分記号：' + object.SELF_DECLRATION_ID + ')')
          }
          returnList.bikou.push(wkbikou)
          // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION_NO + '.pdf')
          returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION_NO))
          wkbikou = []
          wkbikou.push('自己適合宣言書：')
          wkbikou.push(object.SELF_DECLRATION)
          returnList.bikou.push(wkbikou)
          // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION + '.pdf')
          returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION))
        }
      }
      if (this.rigionPattern === '2' && object.HISASHI === 'なし') { // ひさしなし
        if (object.HANTEI_SYU_THERMAL_TRANS === 'TYPE') {
          if (object.HANTEI_SYU_SOLARHEAT === 'TYPE') {
            wklist.push('建具とガラスの組み合わせ')
            returnList.msg = wklist
            returnList.pdfType1 = object.PDF_TYPE1
            returnList.pdfType2 = object.PDF_TYPE2
            returnList.pdfType3 = object.PDF_TYPE3
            returnList.pdfType4 = object.PDF_TYPE4
            wkbikou = []
            // 開口部の熱貫流率（窓・框ドア・引戸）
            // alert(JSON.stringify(object))
            if (object.PDF_DECLRATION1234567 !== '無') {
              wkbikou.push(object.PDF_DECLRATION1234567)
              returnList.bikou.push(wkbikou)
              returnList.bikouaddress.push(this.urltextbikouSetType(object.PDF_DECLRATION1234567))
            }
            // wkbikou.push('開口部の熱貫流率（窓・框ドア・引戸）')
            // returnList.bikou.push(wkbikou)
            // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/1/product_26.pdf')
            wkbikou = []
            // 開口部の日射熱取得率
            if (object.PDF_DECLRATION5678 !== '無') {
              wkbikou.push(object.PDF_DECLRATION5678)
              returnList.bikou.push(wkbikou)
              returnList.bikouaddress.push(this.urltextbikouSetType(object.PDF_DECLRATION5678))
            }
            // wkbikou.push('開口部の日射熱取得率')
            // returnList.bikou.push(wkbikou)
            // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/1/product_31.pdf')
          } else {
            wklist.push('U値：建具とガラス')
            wklist.push('の組み合わせ')
            wklist.push('ηd値：自己適合宣言')
            wklist.push('書・附属書')
            returnList.msg = wklist
            wkbikou = []
            // 開口部の熱貫流率（窓・框ドア・引戸）
            if (object.PDF_DECLRATION1234567 !== '無') {
              wkbikou.push(object.PDF_DECLRATION1234567)
              returnList.bikou.push(wkbikou)
              returnList.bikouaddress.push(this.urltextbikouSetType(object.PDF_DECLRATION1234567))
            }
            wkbikou = []
            wkbikou.push('ηd値：' + object.SERIES)
            returnList.bikou.push(wkbikou)
            returnList.bikouaddress.push('')
            wkbikou = []
            wkbikou.push('附属書№：')
            wkbikou.push(object.SELF_DECLRATION_NO)
            if (object.SELF_DECLRATION_ID === '無' || object.SELF_DECLRATION_ID === '－') {
              wkbikou.push('')
            } else {
              wkbikou.push('(区分記号：' + object.SELF_DECLRATION_NO + ')')
            }
            returnList.bikou.push(wkbikou)
            // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION_NO + '.pdf')
            returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION_NO))
          }
        }
        if (object.HANTEI_SYU_THERMAL_TRANS === 'EXAM') {
          if (object.HANTEI_SYU_SOLARHEAT === 'EXAM') {
            wklist.push('自己適合宣言書・附属書')
            returnList.msg = wklist
            wkbikou = []
            wkbikou.push(object.SERIES)
            returnList.bikou.push(wkbikou)
            returnList.bikouaddress.push('')
            wkbikou = []
            wkbikou.push('附属書№：')
            wkbikou.push(object.SELF_DECLRATION_NO)
            if (object.SELF_DECLRATION_ID === '無' || object.SELF_DECLRATION_ID === '－') {
              wkbikou.push('')
            } else {
              wkbikou.push('(区分記号：' + object.SELF_DECLRATION_ID + ')')
            }
            returnList.bikou.push(wkbikou)
            // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION_NO + '.pdf')
            returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION_NO))
            wkbikou = []
            wkbikou.push('自己適合宣言書：')
            wkbikou.push(object.SELF_DECLRATION)
            returnList.bikou.push(wkbikou)
            // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION + '.pdf')
            returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION))
          } else {
            wklist.push('U値：自己適合宣言')
            wklist.push('書・附属書')
            wklist.push('ηd値：建具とガラス')
            wklist.push('の組み合わせ')
            returnList.msg = wklist
            // type
            wkbikou = []
            wkbikou.push('U値：' + object.SERIES)
            returnList.bikou.push(wkbikou)
            returnList.bikouaddress.push('')
            wkbikou = []
            wkbikou.push('附属書№：')
            wkbikou.push(object.SELF_DECLRATION_NO)
            if (object.SELF_DECLRATION_ID === '無') {
              wkbikou.push('')
            } else {
              wkbikou.push('(区分記号：' + object.SELF_DECLRATION_ID + ')')
            }
            returnList.bikou.push(wkbikou)
            // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION_NO + '.pdf')
            returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION_NO))
            wkbikou = []
            wkbikou.push('自己適合宣言書：')
            wkbikou.push(object.SELF_DECLRATION)
            returnList.bikou.push(wkbikou)
            // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION + '.pdf')
            returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION))
            wkbikou = []
            // 開口部の日射熱取得率
            if (object.PDF_DECLRATION5678 !== '無') {
              wkbikou.push('ηd値：')
              wkbikou.push(object.PDF_DECLRATION5678)
              returnList.bikou.push(wkbikou)
              returnList.bikouaddress.push(this.urltextbikouSetType(object.PDF_DECLRATION5678))
            }
            // wkbikou.push('開口部の日射熱取得率')
            // returnList.bikou.push(wkbikou)
            // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/1/product_31.pdf')
          }
        }
      }
      // 地域8 熱貫流率を見ない ひさし有は対応しない、すべてグレーアウト(あり/なしのみ)
      if (this.rigionPattern === '3' && object.HISASHI !== 'なし') { // ひさしありグレーアウト
        wklist.push('')
        returnList.msg = ['']
        returnList.pdfType1 = ''
        returnList.pdfType2 = ''
        returnList.pdfType3 = ''
        returnList.pdfType4 = ''
        returnList.bikou = ['']
        returnList.bikouaddress = ['']
      }
      if (this.rigionPattern === '3' && object.HISASHI === 'なし') { // ひさしなし 日射を見ない
        // alert('rigionPattern ' + this.rigionPattern + '   [' + object.HANTEI_SYU_SOLARHEAT)
        if (object.HANTEI_SYU_SOLARHEAT === 'TYPE') {
          // alert('type')
          wklist.push('建具とガラスの組み合わせ')
          returnList.msg = wklist
          returnList.pdfType1 = object.PDF_TYPE1
          returnList.pdfType2 = object.PDF_TYPE2
          returnList.pdfType3 = object.PDF_TYPE3
          returnList.pdfType4 = object.PDF_TYPE4
          wkbikou = []
          // 開口部の日射熱取得率
          if (object.PDF_DECLRATION5678 !== '無') {
            wkbikou.push(object.PDF_DECLRATION5678)
            returnList.bikou.push(wkbikou)
            returnList.bikouaddress.push(this.urltextbikouSetType(object.PDF_DECLRATION5678))
          }
        }
        if (object.HANTEI_SYU_SOLARHEAT === 'EXAM') {
          // alert('exam')
          wklist.push('自己適合宣言書・附属書')
          returnList.msg = wklist
          wkbikou = []
          wkbikou.push(object.SERIES)
          returnList.bikou.push(wkbikou)
          returnList.bikouaddress.push('')
          wkbikou = []
          wkbikou.push('附属書№：')
          wkbikou.push(object.SELF_DECLRATION_NO)
          if (object.SELF_DECLRATION_ID === '無' || object.SELF_DECLRATION_ID === '－') {
            wkbikou.push('')
          } else {
            wkbikou.push('(区分記号：' + object.SELF_DECLRATION_ID + ')')
          }
          returnList.bikou.push(wkbikou)
          // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION_NO + '.pdf')
          returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION_NO))
          wkbikou = []
          wkbikou.push('自己適合宣言書：')
          wkbikou.push(object.SELF_DECLRATION)
          returnList.bikou.push(wkbikou)
          // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION + '.pdf')
          returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION))
        }
      }
      return returnList
    },
    doorHanteiMsgSet (object) {
      const returnList = {}
      returnList.msg = []
      returnList.pdfType1 = ''
      returnList.pdfType2 = ''
      returnList.pdfType3 = ''
      returnList.pdfType4 = ''
      returnList.bikou = []
      returnList.bikouaddress = []
      const wklist = []
      let wkbikou = []
      // 地域8以外 日射を見ない
      if (this.rigionPattern !== '3') {
        if (object.HANTEI_SYU_THERMAL_TRANS === 'TYPE') {
          wklist.push('建具とガラスの組み合わせ')
          returnList.msg = wklist
          returnList.pdfType1 = object.PDF_TYPE1
          returnList.pdfType2 = object.PDF_TYPE2
          returnList.pdfType3 = object.PDF_TYPE3
          returnList.pdfType4 = object.PDF_TYPE4
          wkbikou = []
          if (object.PDF_DECLRATION1234567 !== '無') {
            wkbikou.push(object.PDF_DECLRATION1234567)
            returnList.bikou.push(wkbikou)
            returnList.bikouaddress.push(this.urltextbikouSetType(object.PDF_DECLRATION1234567))
          }
          // wkbikou.push('開口部の熱貫流率と日射熱取得率（玄関ドア・引戸）')
          // returnList.bikou.push(wkbikou)
          // returnList.bikouaddress.push(this.urltextbikouSetType('開口部の熱貫流率と日射熱取得率（玄関ドア・引戸）'))
        }
        if (object.HANTEI_SYU_THERMAL_TRANS === 'EXAM') {
          wklist.push('自己適合宣言書・附属書')
          returnList.msg = wklist
          wkbikou = []
          wkbikou.push(object.SERIES)
          returnList.bikou.push(wkbikou)
          returnList.bikouaddress.push('')
          wkbikou = []
          wkbikou.push('附属書№：')
          wkbikou.push(object.SELF_DECLRATION_NO)
          if (object.SELF_DECLRATION_ID === '無' || object.SELF_DECLRATION_ID === '－') {
            wkbikou.push('')
          } else {
            wkbikou.push('(区分記号：' + object.SELF_DECLRATION_ID + ')')
          }
          returnList.bikou.push(wkbikou)
          // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION_NO + '.pdf')
          returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION_NO))
          wkbikou = []
          wkbikou.push('自己適合宣言書：')
          wkbikou.push(object.SELF_DECLRATION)
          returnList.bikou.push(wkbikou)
          // returnList.bikouaddress.push('https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/' + object.SELF_DECLRATION + '.pdf')
          returnList.bikouaddress.push(this.urlAddress1Set2(object.FROM, object.SELF_DECLRATION))
        }
      }
      return returnList
    },
    urltextbikouSetType (ix) {
      if (this.urlAddressbikou[ix] !== undefined) {
        return this.urlAddressbikou[ix]
      } else {
        return ''
      }
    },
    urlAddress1Set2 (syu, ix) {
      if (syu === 'WINDOW') {
        if (this.urlAddress1['窓'] !== undefined) {
          return this.urlAddress1['窓'] + ix + '.pdf'
        } else {
          return ''
        }
      }
      if (syu === 'DOOR') {
        if (this.urlAddress1['ドア'] !== undefined) {
          return this.urlAddress1['ドア'] + ix + '.pdf'
        } else {
          return ''
        }
      }
    },
    resultWindowToWindowSet (i) {
      const wklist = {}
      wklist.FROM = 'WINDOW'
      wklist.HANTEI_SYU = '' // EXAMかTYPE
      wklist.HANTEI_SYU_THERMAL_TRANS = '' // EXAMかTYPE
      wklist.HANTEI_SYU_SOLARHEAT = '' // EXAMかTYPE
      wklist.SEQ = String(this.resultSeq).padStart(2, '0')
      wklist.ID = this.windowResultList[i].ID
      wklist.SPEC = this.windowResultList[i].SPEC
      wklist.SERIES = this.windowResultList[i].SERIES
      wklist.GLASS_TYPE = this.windowResultList[i].GLASS_TYPE
      wklist.WINDOW_TYPE = this.windowResultList[i].WINDOW_TYPE
      wklist.BUZAI = 'なし'
      wklist.HISASHI = 'なし'
      if (this.windowResultList[i].HISASHI === '1') {
        wklist.HISASHI = 'あり'
      }
      wklist.SELF_DECLRATION_NO = this.windowResultList[i].SELF_DECLRATION_NO
      wklist.SELF_DECLRATION = this.windowResultList[i].SELF_DECLRATION
      wklist.SELF_DECLRATION_ID = this.windowResultList[i].SELF_DECLRATION_ID
      wklist.EXAM_THERMAL_TRANS = this.windowResultList[i].EXAM_THERMAL_TRANS
      wklist.TYPE_THERMAL_TRANS = this.windowResultList[i].TYPE_THERMAL_TRANS
      wklist.EXAM_SOLARHEAT = this.windowResultList[i].EXAM_SOLARHEAT
      wklist.TYPE_SOLARHEAT = this.windowResultList[i].TYPE_SOLARHEAT
      wklist.EXAM_HANTEI_4 = this.windowResultList[i].EXAM_HANTEI_4
      wklist.EXAM_HANTEI_5 = this.windowResultList[i].EXAM_HANTEI_5
      wklist.TYPE_HANTEI_4 = this.windowResultList[i].TYPE_HANTEI_4
      wklist.TYPE_HANTEI_5 = this.windowResultList[i].TYPE_HANTEI_5
      wklist.PDF_TYPE1 = this.windowResultList[i].PDF_TYPE1
      wklist.PDF_TYPE2 = this.windowResultList[i].PDF_TYPE2
      wklist.PDF_TYPE3 = this.windowResultList[i].PDF_TYPE3
      wklist.PDF_TYPE4 = this.windowResultList[i].PDF_TYPE4
      wklist.PDF_DECLRATION1234567 = this.windowResultList[i].PDF_DECLRATION1234567
      wklist.PDF_DECLRATION5678 = this.windowResultList[i].PDF_DECLRATION5678
      wklist.INPUTSEQ = this.windowResultList[i].INPUTSEQ
      return wklist
    },
    resultDoorToWindowSet (i) {
      const wklist = {}
      wklist.FROM = 'DOOR'
      wklist.HANTEI_SYU = '' // EXAMかTYPE
      wklist.HANTEI_SYU_THERMAL_TRANS = '' // EXAMかTYPE
      wklist.HANTEI_SYU_SOLARHEAT = '' // EXAMかTYPE
      wklist.SEQ = String(this.resultSeq).padStart(2, '0')
      wklist.ID = this.doorResultList[i].ID
      wklist.SPEC = ''
      wklist.SERIES = this.doorResultList[i].SERIES
      wklist.GLASS_TYPE = this.doorResultList[i].GLASS_TYPE
      wklist.WINDOW_TYPE = this.doorResultList[i].FRAME + '、' + this.doorResultList[i].DESIGN
      wklist.BUZAI = 'なし'
      wklist.HISASHI = 'なし'
      if (this.doorResultList[i].HISASHI === '1') {
        wklist.HISASHI = 'あり'
      }
      // 20260108 wklist.HISASHI = 'なし'
      wklist.SELF_DECLRATION_NO = this.doorResultList[i].SELF_DECLRATION_NO
      wklist.SELF_DECLRATION = this.doorResultList[i].SELF_DECLRATION
      wklist.SELF_DECLRATION_ID = '－'
      wklist.EXAM_THERMAL_TRANS = this.doorResultList[i].EXAM_THERMAL_TRANS
      wklist.TYPE_THERMAL_TRANS = this.doorResultList[i].TYPE_THERMAL_TRANS
      wklist.EXAM_SOLARHEAT = this.doorResultList[i].EXAM_SOLARHEAT
      wklist.TYPE_SOLARHEAT = this.doorResultList[i].TYPE_SOLARHEAT
      wklist.EXAM_HANTEI_4 = this.doorResultList[i].EXAM_HANTEI_4
      wklist.EXAM_HANTEI_5 = this.doorResultList[i].EXAM_HANTEI_5
      wklist.TYPE_HANTEI_4 = this.doorResultList[i].TYPE_HANTEI_4
      wklist.TYPE_HANTEI_5 = this.doorResultList[i].TYPE_HANTEI_5
      wklist.PDF_TYPE1 = this.doorResultList[i].PDF_TYPE1
      wklist.PDF_TYPE2 = this.doorResultList[i].PDF_TYPE2
      wklist.PDF_TYPE3 = this.doorResultList[i].PDF_TYPE3
      wklist.PDF_TYPE4 = this.doorResultList[i].PDF_TYPE4
      wklist.PDF_DECLRATION1234567 = this.doorResultList[i].PDF_DECLRATION1234567
      wklist.PDF_DECLRATION5678 = this.doorResultList[i].PDF_DECLRATION5678
      wklist.INPUTSEQ = this.doorResultList[i].INPUTSEQ
      return wklist
    },
    resultWindowToDooRSet (i) {
      const wklist = {}
      wklist.FROM = 'WINDOW'
      wklist.HANTEI_SYU = '' // EXAMかTYPE
      wklist.HANTEI_SYU_THERMAL_TRANS = '' // EXAMかTYPE
      wklist.HANTEI_SYU_SOLARHEAT = '' // EXAMかTYPE
      wklist.SEQ = String(this.resultSeq).padStart(2, '0')
      wklist.ID = this.windowResultList[i].ID
      wklist.SPEC = this.windowResultList[i].SPEC
      wklist.SERIES = this.windowResultList[i].SERIES
      wklist.GLASS_TYPE = this.windowResultList[i].GLASS_TYPE
      wklist.WINDOW_TYPE = this.windowResultList[i].WINDOW_TYPE
      wklist.BUZAI = 'なし'
      wklist.HISASHI = 'なし'
      if (this.windowResultList[i].HISASHI === '1') {
        wklist.HISASHI = 'あり'
      }
      wklist.SELF_DECLRATION_NO = this.windowResultList[i].SELF_DECLRATION_NO
      wklist.SELF_DECLRATION = this.windowResultList[i].SELF_DECLRATION
      wklist.SELF_DECLRATION_ID = this.windowResultList[i].SELF_DECLRATION_ID
      wklist.EXAM_THERMAL_TRANS = this.windowResultList[i].EXAM_THERMAL_TRANS
      wklist.TYPE_THERMAL_TRANS = this.windowResultList[i].TYPE_THERMAL_TRANS
      wklist.EXAM_SOLARHEAT = this.windowResultList[i].EXAM_SOLARHEAT
      wklist.TYPE_SOLARHEAT = this.windowResultList[i].TYPE_SOLARHEAT
      wklist.EXAM_HANTEI_4 = this.windowResultList[i].EXAM_HANTEI_4
      wklist.EXAM_HANTEI_5 = this.windowResultList[i].EXAM_HANTEI_5
      wklist.TYPE_HANTEI_4 = this.windowResultList[i].TYPE_HANTEI_4
      wklist.TYPE_HANTEI_5 = this.windowResultList[i].TYPE_HANTEI_5
      wklist.PDF_TYPE1 = this.windowResultList[i].PDF_TYPE1
      wklist.PDF_TYPE2 = this.windowResultList[i].PDF_TYPE2
      wklist.PDF_TYPE3 = this.windowResultList[i].PDF_TYPE3
      wklist.PDF_TYPE4 = this.windowResultList[i].PDF_TYPE4
      wklist.PDF_DECLRATION1234567 = this.windowResultList[i].PDF_DECLRATION1234567
      wklist.PDF_DECLRATION5678 = this.windowResultList[i].PDF_DECLRATION5678
      wklist.INPUTSEQ = this.windowResultList[i].INPUTSEQ
      return wklist
    },
    resultDoorToDooRSet (i) {
      const wklist = {}
      wklist.FROM = 'DOOR'
      wklist.HANTEI_SYU = '' // EXAMかTYPE
      wklist.HANTEI_SYU_THERMAL_TRANS = '' // EXAMかTYPE
      wklist.HANTEI_SYU_SOLARHEAT = '' // EXAMかTYPE
      wklist.SEQ = String(this.resultSeq).padStart(2, '0')
      wklist.ID = this.doorResultList[i].ID
      wklist.SPEC = ''
      wklist.SERIES = this.doorResultList[i].SERIES
      wklist.GLASS_TYPE = this.doorResultList[i].GLASS_TYPE
      wklist.WINDOW_TYPE = this.doorResultList[i].FRAME + '、' + this.doorResultList[i].DESIGN
      wklist.BUZAI = 'なし'
      wklist.HISASHI = 'なし'
      wklist.SELF_DECLRATION_NO = this.doorResultList[i].SELF_DECLRATION_NO
      wklist.SELF_DECLRATION = this.doorResultList[i].SELF_DECLRATION
      wklist.SELF_DECLRATION_ID = '－'
      wklist.EXAM_THERMAL_TRANS = this.doorResultList[i].EXAM_THERMAL_TRANS
      wklist.TYPE_THERMAL_TRANS = this.doorResultList[i].TYPE_THERMAL_TRANS
      wklist.EXAM_SOLARHEAT = this.doorResultList[i].EXAM_SOLARHEAT
      wklist.TYPE_SOLARHEAT = this.doorResultList[i].TYPE_SOLARHEAT
      wklist.EXAM_HANTEI_4 = this.doorResultList[i].EXAM_HANTEI_4
      wklist.EXAM_HANTEI_5 = this.doorResultList[i].EXAM_HANTEI_5
      wklist.TYPE_HANTEI_4 = this.doorResultList[i].TYPE_HANTEI_4
      wklist.TYPE_HANTEI_5 = this.doorResultList[i].TYPE_HANTEI_5
      wklist.PDF_TYPE1 = this.doorResultList[i].PDF_TYPE1
      wklist.PDF_TYPE2 = this.doorResultList[i].PDF_TYPE2
      wklist.PDF_TYPE3 = this.doorResultList[i].PDF_TYPE3
      wklist.PDF_TYPE4 = this.doorResultList[i].PDF_TYPE4
      wklist.PDF_DECLRATION1234567 = this.doorResultList[i].PDF_DECLRATION1234567
      wklist.PDF_DECLRATION5678 = this.doorResultList[i].PDF_DECLRATION5678
      wklist.INPUTSEQ = this.doorResultList[i].INPUTSEQ
      return wklist
    },
    pdfDataSet () {
      const result = {}
      result.windowdata = JSON.parse(JSON.stringify(this.resultWindowList))
      result.doordata = JSON.parse(JSON.stringify(this.resultDoorList))
      result.summrydata = JSON.parse(JSON.stringify(this.resultDisplay))
      return result
    },
    pdfUrlSet () {
      const result = []
      let pdfW = ''
      let pdfD = ''
      if (this.urlAddress1['窓'] !== undefined) {
        pdfW = this.urlAddress1['窓']
      } else {
        pdfW = 'https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/2/'
      }
      if (this.urlAddress1['ドア'] !== undefined) {
        pdfD = this.urlAddress1['ドア']
      } else {
        pdfD = 'https://www.ykkap.co.jp/business/law/supportguide/products_28/pdf/3/'
      }
      let wklist = {}
      for (let i = 0; i < this.windowPdf1.length; i++) {
        wklist = {}
        wklist.url = pdfW + this.windowPdf1[i] + '.pdf'
        wklist.filename = '附属書' + this.windowPdf1[i] + '.pdf'
        result.push(wklist)
      }
      for (let i = 0; i < this.windowPdf2.length; i++) {
        wklist = {}
        wklist.url = pdfW + this.windowPdf2[i] + '.pdf'
        wklist.filename = '自己適合宣言書' + this.windowPdf2[i] + '.pdf'
        result.push(wklist)
      }
      for (let i = 0; i < this.doorPdf1.length; i++) {
        wklist = {}
        wklist.url = pdfD + this.doorPdf1[i] + '.pdf'
        wklist.filename = '附属書' + this.doorPdf1[i] + '.pdf'
        result.push(wklist)
      }
      for (let i = 0; i < this.doorPdf2.length; i++) {
        wklist = {}
        wklist.url = pdfD + this.doorPdf2[i] + '.pdf'
        wklist.filename = '自己適合宣言書' + this.doorPdf2[i] + '.pdf'
        result.push(wklist)
      }
      const wkresult = []
      for (let i = 0; i < this.resultDisplay.WINDOW_BIKOU_1.length; i++) {
        for (let j = 0; j < this.resultDisplay.WINDOW_BIKOU_1[i].length; j++) {
          if (this.bikouNmCheck(this.resultDisplay.WINDOW_BIKOU_1[i][j]) === 1) {
            if (this.resultDisplay.WINDOW_BIKOUADDRESS_1[i] !== '') {
              wklist = {}
              wklist.url = this.resultDisplay.WINDOW_BIKOUADDRESS_1[i]
              wklist.filename = this.resultDisplay.WINDOW_BIKOU_1[i][j] + '.pdf'
              wkresult.push(wklist)
            }
          }
        }
      }
      // 熱貫流
      for (let i = 0; i < this.resultDisplay.WINDOW_BIKOU_2.length; i++) {
        for (let j = 0; j < this.resultDisplay.WINDOW_BIKOU_2[i].length; j++) {
          if (this.bikouNmCheck(this.resultDisplay.WINDOW_BIKOU_2[i][j]) === 1) {
            if (this.resultDisplay.WINDOW_BIKOUADDRESS_2[i] !== '') {
              wklist = {}
              wklist.url = this.resultDisplay.WINDOW_BIKOUADDRESS_2[i]
              wklist.filename = this.resultDisplay.WINDOW_BIKOU_2[i][j] + '.pdf'
              if (this.rigionPattern === '1') { // 20260321
                wkresult.push(wklist)
              }
              if (this.rigionPattern === '2') { // 20260321
                wkresult.push(wklist)
              }
              // alert('w2 ' + this.resultDisplay.WINDOW_BIKOU_3[i][j])
            }
          }
        }
      }
      // 日射
      for (let i = 0; i < this.resultDisplay.WINDOW_BIKOU_3.length; i++) {
        for (let j = 0; j < this.resultDisplay.WINDOW_BIKOU_3[i].length; j++) {
          if (this.bikouNmCheck(this.resultDisplay.WINDOW_BIKOU_3[i][j]) === 1) {
            if (this.resultDisplay.WINDOW_BIKOUADDRESS_3[i] !== '') {
              wklist = {}
              wklist.url = this.resultDisplay.WINDOW_BIKOUADDRESS_3[i]
              wklist.filename = this.resultDisplay.WINDOW_BIKOU_3[i][j] + '.pdf'
              if (this.rigionPattern === '2') { // 20260321
                wkresult.push(wklist)
              }
              if (this.rigionPattern === '3') { // 20260321
                wkresult.push(wklist)
              }
              // alert('w3 ' + this.resultDisplay.WINDOW_BIKOU_3[i][j])
            }
          }
        }
      }
      // 日射
      for (let i = 0; i < this.resultDisplay.DOOR_BIKOU.length; i++) {
        for (let j = 0; j < this.resultDisplay.DOOR_BIKOU[i].length; j++) {
          if (this.bikouNmCheck(this.resultDisplay.DOOR_BIKOU[i][j]) === 1) {
            if (this.resultDisplay.DOOR_BIKOUADDRESS[i] !== '') {
              wklist = {}
              wklist.url = this.resultDisplay.DOOR_BIKOUADDRESS[i]
              wklist.filename = this.resultDisplay.DOOR_BIKOU[i][j] + '.pdf'
              wkresult.push(wklist)
              // alert('door ' + this.resultDisplay.DOOR_BIKOU[i][j])
            }
          }
        }
      }
      const seen = new Set()
      for (const item of wkresult) {
        if (!seen.has(item.url)) {
          seen.add(item.url)
          result.push(item)
        }
      }
      return result
    },
    bikouNmCheck (x1) {
      if (this.urlAddressbikou[x1] !== undefined) {
        return 1
      } else {
        return 0
      }
      /*
      if (x1 === '開口部の熱貫流率と日射熱取得率（玄関ドア・引戸）') {
        return 1
      }
      if (x1 === '開口部の熱貫流率（窓・框ドア・引戸）') {
        return 1
      }
      if (x1 === '開口部の日射熱取得率') {
        return 1
      }
      return 0
      */
    },
    hanteiSyuChange () {
      // alert(this.hanteiMethod)
      this.resultDataSet()
    },
    getFormattedDateTime () {
      const now = new Date()
      const yyyy = now.getFullYear()
      const mm = String(now.getMonth() + 1).padStart(2, '0') // 月は0始まり！
      const dd = String(now.getDate()).padStart(2, '0')
      const hh = String(now.getHours()).padStart(2, '0')
      const min = String(now.getMinutes()).padStart(2, '0')
      const ss = String(now.getSeconds()).padStart(2, '0')
      const ms = String(now.getMilliseconds()).padStart(3, '0')
      const base = `${yyyy}${mm}${dd}${hh}${min}${ss}${ms}`
      const random = this.getRandomHex(4) // ランダムな8桁
      const combined = base + random
      // シャッフル
      const shuffled = combined.split('')
        .sort(() => Math.random() - 0.5)
        .join('')
      return shuffled
      // return `${yyyy}${mm}${dd}${hh}${min}${ss}${ms}`
    },
    getRandomHex (bytes = 4) {
      const array = new Uint8Array(bytes)
      window.crypto.getRandomValues(array)
      return Array.from(array, b => b.toString(16).padStart(2, '0')).join('')
    },
    onHelp () {
      this.helpdialogWidth = '800'
      this.helpmsgtitle = ''
      this.helpmsgtext = this.resulttext.replace(/\r?\n/g, '<br>')
      this.helpmsgdialog = true
    },
    onKaikoubuHelp () {
      this.helpdialogWidth = '700'
      this.helpmsgtitle = ''
      this.helpmsgtext = this.kaikoubutext.replace(/\r?\n/g, '<br>')
      this.helpmsgdialog = true
    },
    onHisashiHelp () {
      this.helpdialogWidth = '700'
      this.helpmsgtitle = ''
      this.helpmsgtext = this.hisashitext.replace(/\r?\n/g, '<br>')
      this.helpmsgdialog = true
      // alert('onHisashiHelp')
    },
    onBuzaiHelp () {
      this.helpdialogWidth = '750'
      this.helpmsgtitle = ''
      this.helpmsgtext = this.buzaitext.replace(/\r?\n/g, '<br>')
      this.helpmsgdialog = true
      // alert('onBuzaiHelp')
    },
    onGlassHelp () {
      this.helpdialogWidth = '800'
      this.helpmsgtitle = ''
      this.helpmsgtext = this.glasstext.replace(/\r?\n/g, '<br>')
      this.helpmsgdialog = true
      // alert('onBuzaiHelp')
    },
    countWindowAlert (ix) {
      // alert('window over')
      this.alertdialogWidth = '750'
      this.alertmsgtitle = ''
      this.alertmsgtext = this.windowcountmsg
      this.alertmsgdialog = true
    },
    countDoorAlert (ix) {
      this.alertdialogWidth = '750'
      this.alertmsgtitle = ''
      this.alertmsgtext = this.doorcountmsg
      this.alertmsgdialog = true
    },
    getNoStyle (x1) {
      if (x1 === '') {
        return { backgroundColor: '#404040' }
      } else {
        return { backgroundColor: 'white' }
      }
    },
    getValueStyle (x1) {
      if (x1 === '') {
        return { backgroundColor: '#404040' }
      } else {
        if (x1 === '－') {
          return { backgroundColor: 'white', justifyContent: 'center', paddingRight: '0px' }
        } else {
          return { backgroundColor: 'white', justifyContent: 'right', paddingRight: '5px' }
        }
      }
    },
    getKijyunn4Style (x1) {
      if (x1 === '') {
        return { backgroundColor: '#404040' }
      } else {
        if (x1 === '－') {
          return { backgroundColor: '#ffeb5a', justifyContent: 'center', paddingRight: '0px', borderBottom: '1px solid black', borderLeft: '1px solid black' }
        } else {
          return { backgroundColor: '#ffeb5a', justifyContent: 'right', paddingRight: '5px', borderBottom: '1px solid black', borderLeft: '1px solid black' }
        }
      }
    },
    getKijyunn5Style (x1) {
      if (x1 === '') {
        return { backgroundColor: '#404040' }
      } else {
        if (x1 === '－') {
          return { backgroundColor: '#cdf5ad', justifyContent: 'center', paddingRight: '0px' }
        } else {
          return { backgroundColor: '#cdf5ad', justifyContent: 'right', paddingRight: '5px' }
        }
      }
    },
    getResult4Style (x1) {
      if (x1 === '') {
        return { backgroundColor: '#404040' }
      } else {
        if (x1 === '適合' || x1 === '該当窓なし' || x1 === '該当ドアなし') {
          return { backgroundColor: '#ffeb5a', justifyContent: 'center', color: 'black' }
        } else {
          return { backgroundColor: '#ffeb5a', justifyContent: 'center', color: 'red' }
        }
      }
    },
    getResult5Style (x1) {
      if (x1 === '') {
        return { backgroundColor: '#404040' }
      } else {
        if (x1 === '適合' || x1 === '該当窓なし' || x1 === '該当ドアなし') {
          return { backgroundColor: '#cdf5ad', justifyContent: 'center', color: 'black' }
        } else {
          return { backgroundColor: '#cdf5ad', justifyContent: 'center', color: 'red' }
        }
      }
    }
  }
}
</script>
<style scoped>
.card-container {
  margin-top: 3px;
  max-height: 180px; /* 高さ制限 */
  overflow-y: auto;  /* スクロール表示 */
}
.card-container-w-pro {
  margin-top: 3px;
  max-height: 420px; /* 高さ制限 */
  overflow-y: auto;  /* スクロール表示 */
}
.card-container-d-pro {
  margin-top: 3px;
  max-height: 420px; /* 高さ制限 */
  overflow-y: auto;  /* スクロール表示 */
}
</style>
<style scoped>
.list-container {
  display: flex; /* フレックスボックスでリストを横に並べる */
}
.list-box {
  border: 1px solid #ccc; /* 枠線の色とスタイルを設定 */
}
.scrollable-list {
  width: 865px; /* リストの幅を300pxに設定 */
  height: 250px; /* 高さを調整して10行分にします */
  overflow-y: auto; /* コンテンツが溢れた場合にスクロールバーを表示 */
  border: 1px solid #ccc; /* 枠線の色とスタイルを設定 */
  border-radius: 4px; /* 角を丸くするオプション */
}

.selected-item {
  background-color: #e0e0e0 !important; /* 選択されたアイテムの背景色 */
}
.v-list-item {
  cursor: pointer; /* アイテムにカーソルを合わせるとポインタが表示されるようにする */
}
.left-aligned {
  text-align: left; /* テキストを左寄せにする */
}
.custom-select {
  background-color: #ffffff; /* 背景色を設定 */
  border: 1px solid rgb(10, 10, 255); /* 枠線を設定 */
  border-radius: 4px; /* 角を丸くする */
  padding: 10px; /* 内側の余白を設定 */
  height: 28px;
}
.toggle-box {
  width: 450px;
  height: 35px;
  border: 1px solid #8685852e;
  border-radius: 4px;
  color: #1976d2;
  background-color: white;
  display: flex;
  justify-content: center; /* 中央揃え */
  align-items: center; /* 縦方向の中央揃え */
}
.toggle-box {
  width: 450px;
  height: 35px;
  border: 1px solid #8685852e;
  border-radius: 4px;
  color: #1976d2;
  background-color: white;
  display: flex;
}

.toggle-btn3 {
  flex: 1;
  height: 100%;
  border: 1px solid #1976d2;
  border-radius: 4px;
  color: #1976d2;
  background-color: white;
  transition: all 0.3s ease; /* スムーズなアニメーション */
}

/* 選択されたボタンに特定のスタイル */
.toggle-box {
  width: 450px; /* 固定幅 */
  height: 35px; /* 高さを固定 */
  border: 1px solid #8685852e;
  border-radius: 4px;
  color: #1976d2;
  background-color: white;
  display: flex;
  justify-content: space-between; /* ボタン間のスペースを均等に */
  align-items: stretch; /* ボタンを縦方向に伸ばす */
}

.toggle-btn3 {
  flex: 1; /* ボタンを均等に広げる */
  height: 100%; /* 親要素（toggle-box）の高さに合わせる */
  border: 1px solid #1976d2;
  border-radius: 4px;
  color: #1976d2;
  background-color: white;
  transition: all 0.3s ease; /* スムーズなアニメーション */
}

/* 選択されたボタンに特定のスタイル */
.toggle-btn3.selected {
  border: none;
  background-color: #1976d2;
  color: white;
}

/* 選択されていないボタンの右境界線を明確 */
.toggle-btn3:not(.selected) {
  border-right: 1px solid #1976d2;
}

.toggle-btn3.v-btn--active {
  background-color: #1976d2;
  color: white;
}

.toggle-btn3:disabled {
  background-color: #c4c4c4; /* 薄いグレーに */
  color: #343434; /* 文字も薄く */
  border-color: #c4c4c4; /* 枠線も薄く */
  cursor: not-allowed;
  opacity: 0.6;
}
.toggle-box-class {
  width: 300px;             /* 全体の幅 */
  height: 35px;             /* 全体の高さ */
  border: 1px solid #8685852e;
  border-radius: 4px;
  color: #1976d2;
  background-color: white;
}
.toggle-btn {
  width: 50%;
  height: 100%;
  border: 1px solid #1976d2;
  border-radius: 4px;
  color: #1976d2;
  background-color: white;
  border: 1px solid #1976d2;
  border-radius: 4px;
  color: #1976d2;
  background-color: white;
}
.toggle-btn.v-btn--active {
  background-color: #1976d2;
  color: white;
}
</style>

<style scoped>

.thumbnail-box {
  width: 1168px;
  /* border: 1px solid black; */
  background-color: #eaeaea;
  padding: 10px;
}
.thumb-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.grid {
  display: grid;
  margin: 3px;
  grid-template-columns: repeat(5, 1fr); /* 横に5列 */
  gap: 10px;
  background-color: #eaeaea; /* 20260219 add */
}

.thumb {
  position: relative;
  display: inline-block;
  cursor: pointer;
  border: 1px solid #9e9e9e; /* 20260214 black */
  border-radius: 6px;   /* ← 追加（丸み）20260214 */
  z-index: 0;
  background-color: #ffffff;
}
/*
.thumb:hover {
  z-index: 10; 拡大時に前面に出す
}
*/
.thumb img {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 6px;
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.2); 20260214del*/
  /* transition: transform 0.2s ease-in-out; 20260214del*/
  box-shadow: none;  /* ← 通常時は影なし */
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  transform-origin: center;
}
/*
.thumb img:hover {
  transform: scale(1.2);
  box-shadow: 0 8px 20px rgba(0,0,0,0.35); // hover時だけ影
}
*/
.tooltip {
  position: absolute;
  top: 190px;
  left: 50%;
  transform: translateX(-50%);
  background: #1976d2;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 11px;
  text-align: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 9999;
  display: block;  /* ★ 折り返し幅を有効にするため */
  width: 150px;
  /*max-width: 250px; */
  white-space: normal;
  word-break: break-word;
}

.thumb:hover .tooltip {
  opacity: 1;
}
.caption {
  display: flex;
  align-items: center;     /* 縦方向の中央揃え */
  justify-content: center; /* 横方向の中央揃え */
  height: 40px;
  font-size: 12px;
  text-align: center;
  color: black;
  word-break: break-word;
}
.selected-thumb {
  border: 4px solid #1976d2;
  background-color: #ffffff; /* e3f2fd 20260214 */
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(25, 118, 210, 0.3); /* 半透明の青 */
  z-index: 2;
}
/* イメージ無し用 */
.fallback-text {
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background-color: #eee;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  text-align: center;
}
.fallback-text {
  width: 150px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eee;
  color: #333;
  font-size: 16px;
}
/* ローディング画面用 */
.transparent-card {
  background-color: rgba(0, 0, 0, 0.5) !important;
  box-shadow: none;
}
.spinner {
  margin: 40px auto 0;
  width: 70px;
  text-align: center;
}

.spinner > div {
  width: 18px;
  height: 18px;
  background-color: #1976d2;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
</style>
<style scoped>
.colright-align {
  justify-content: flex-end;
  padding-right: 5px;
}

.colcenter-align {
  justify-content: center;
}

.colbk-yellow {
  color: black;
  background-color: lightyellow;
}
.colbk-gray {
  color: red;
  background-color: lightgray;
}
.capsule-yellow {
  margin-top: -1px;
  position: absolute;
  border: 1px solid #ffeb5a;
  border-radius: 999px;
  padding: 1px 5px;
  position: absolute;
  font-size: 11px;
  background-color: #ffeb5a;
  text-align: center;
  display: inline-block;
  width: 100px;
}
.capsule-4 {
  position: absolute;
  border-radius: 999px;
  padding: 1px 5px;
  position: absolute;
  font-size: 11px;
  background-color: #ffeb5a;
  text-align: center;
  justify-content: center;
  display: inline-block;
  width: 210px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.capsule-5 {
  position: absolute;
  border-radius: 999px;
  padding: 1px 5px;
  position: absolute;
  font-size: 11px;
  background-color: #cdf5ad;
  text-align: center;
  justify-content: center;
  display: inline-block;
  width: 210px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.capsule-text-black {
  color: black;
}
.capsule-text-red {
  color: red;
}
</style>
<style scoped>
.wrap-pre {
  white-space: pre-wrap; /* 改行を保持しつつ折り返す */
  word-wrap: break-word; /* 長い単語を折り返す */
}
.vhtml-text {
  line-height: 1.3; /* 調整。1.0?1.3あたり */
}
</style>
<style scoped>
.glass-button-grid {
  width: 900px;
  display: grid;
  margin: 3px;
  grid-template-columns: repeat(3, 1fr); /* 横に4列 */
  gap: 10px;
}
</style>
<style scoped>
.select-wrapper {
  position: relative;
  width: 1168px;
  height: 60px;
}

.select-bg {
  position: absolute;
  inset: 0;
  background-color: #eaeaea;
  border-radius: 0; /* 20260214 4px */
}

.select-foreground {
  position: relative;
  width: 450px;
  margin-left: 10px;
  padding-top: 5px; /* 縦位置微調整 */
}
.select-foregroundGlass {
  position: relative;
  width: 750px;
  margin-left: 10px;
  padding-top: 5px; /* 縦位置微調整 */
}
</style>
<style scoped>
.dialog-container {
  position: relative; /* ← closeボタンの基準 */
  padding: 20px;   /* ボタン分の余白 */
}
.white-bg {
  background-color: #ffffff;
}
.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  border-radius: 2px;
  width: 24px;
  height: 24px;
}
.scroll-area {
  max-height: 85vh;   /* 画面高さ基準 */
  overflow-y: auto;
}
</style>
<style>
/* 選択された値（入力欄側）を太字 */
.hantei-select {
  font-weight: bold;
  line-height: 1.4; /* 適切な値に調整 */
}
.hantei-select .v-input__control {
  display: flex;
  align-items: center;
}
.hantei-select-radio {
  font-weight: bold;
  line-height: 1.4; /* 適切な値に調整 */
  margin-left: -3px;   /* グループ全体を左へ */
}
.radio-bold .v-label {
  opacity: 1 !important;
  color: #000 !important;
  font-weight: 700;
}
</style>
